export default {
    route: {
        dashboard: 'Arbela',
        article: 'Artikuluak',
    },
    month: {
        jan: 'Urtarrila',
        feb: 'Otsaila',
        mar: 'martxoa',
        apr: 'Apirila',
        may: 'Maiatza',
        jun: 'Ekaina',
        jul: 'Uztaila',
        aug: 'Abuztua',
        sep: 'Iraila',
        oct: 'Urria',
        nov: 'Azaroa',
        dec: 'Abendua',
    },
    week: {
        mon: 'al',
        tue: 'ar',
        wed: 'az',
        thu: 'og',
        fri: 'or',
        sat: 'lr',
        sun: 'ig',
    },
    navbar: {
        logOut: 'Saioa itxi',
        myProfile: 'Nire profila',
        termsConditions: 'Terminoak eta baldintzak',
    },
    login: {
        title: 'Saioa hasi: ##COMPANY_BRAND_NAME## - eMobility Zerbitzuaren Plataforma',
        logIn: 'Saioa hasi',
        username: 'Erabiltzaile-izena',
        password: 'Pasahitza',
        loginForm: {
            header: 'Ongi etorri ##COMPANY_BRAND_NAME##',
        },
        qrCode: {
            header: 'Sartu kodea zure egiaztatzailetik.',
            subheader: 'Sartu 6 digituko honako kode hau jarraitzeko',
            placeholderSecurityCode: 'Sartu hemen Segurtasun-kodea',
        },
        forgotPassword: {
            header: 'Pasahitza ahaztu duzu?',
            subheader: 'Sartu behean zure helbide elektronikoa eta pasahitza berrezartzeko mezua bidaliko dizugu',
            placeholderEmail: 'Sartu zure helbide elektronikoa',
        },
        resetPassord: {
            header: 'Berrezarri pasahitza.',
            subheader: 'Sartu postaz bidali dizugun kodea eta berrezarri zure pasahitza.',
            placeholder: {
                code: 'Sartu zure kodea',
                newPassWord: 'Sartu zure pasahitz berria',
                confirmPassWord: 'Berretsi pasahitza',
            },
            success: 'Pasahitza behar bezala berrezarri da.',
        },
        button: {
            login: 'Saioa hasi',
            forgotPassword: 'Pasahitza ahaztu duzu?',
            resetMyPassword: 'Berrezarri pasahitza',
            submitMyPassword: 'Pasahitz berria gorde',
            back: 'Atzera',
            instavolt: '##COMPANY_BRAND_NAME##',
        },
        label: {
            rememberMe: 'Gogoratu',
            password: 'Pasahitza',
            userId: 'Erabiltzailearen ID-a',
            copyright: '##COMPANY_BRAND_NAME## copyrighta.',
            showPassword: 'Pasahitza erakutsi',
            hidePassword: 'Pasahitza ezkutatu',
        },
        errors: {
            email: {
                email: 'Sartu baliozko helbide elektroniko bat.',
                required: 'Sartu zure helbide elektronikoa.',
            },
            password: {
                required: 'Sartu zure pasahitza.',
                max: 'Pasahitzak 8 karaktere izan behar ditu gutxienez',
            },
            securityCode: {
                required: 'Sartu zure segurtasun-kodea.',
                max: 'Segurtasun-kodeak 6 karaktere izan behar ditu gutxienez',
            },
            verificationCodeInvalid: 'Egiaztatze-kodea ez da baliozkoa.',
            generalError: 'Errorea zure eskaera prozesatzean.',
            incorrectCredentials: 'Erabiltzaile-izen edo pasahitz okerra.',
            defaultPasswordExpired: 'Zure pasahitzak iraungi du eta administratzaileak berrezarri behar du.',
            inValidEmailAddress: 'Helbide elektronikoa ez da baliozkoa.',
            securityCodeInvalid: 'Baliogabetu segurtasun-kodea.',
            verificationCodeFormat: 'Sartu 6 digituko egiaztatze-kodea.',
            passwordFormat:
                'Pasahitzak 15 karaktere edo gehiago izan behar ditu, letra maiuskula, letra minuskula, karaktere berezi eta zenbaki banarekin.',
            confirmPasswordMatch: 'Idatzitako pasahitza eta berretsitako pasahitza ez datoz bat.',
            common: 'Zerbait ez da ongi atera, saiatu berriro arren.',
        },
        toast: {
            error: 'Zerbait ez da ongi atera, saiatu berriro arren.',
        },
    },
    dashboard: {
        title: 'Hasierako orria: ##COMPANY_BRAND_NAME## - eMobility Zerbitzuaren Plataforma',
        header: 'Arbela',
        formtitle: 'Formulario balioztapena',
        label: {
            pending: 'Egiteke',
            currentBalance: 'Uneko saldoa',
            closingBalance: 'Azken saldoa',
            availableCredit: 'Kreditu erabilgarria',
            unbilledAmount: 'Fakturatu gabeko zenbatekoa',
            filter: 'Iragazi',
            reportTags: 'Jakinarazitako etiketak',
            driverGroup: 'Gidari-taldeak',
            selectDriverGroup: 'Hautatu gidari-taldeak',
            selectTags: 'Hautatu etiketak',
            dateRange: 'Data-tartea',
            month: 'Hilabetea',
            year: 'Urtea',
            day: 'Eguna',
            week: 'Astea',
            userSessionTitle: 'Gidariaren saioak',
            userSessions: 'Gidariaren saioak',
            expenseTitle: 'Gastuen zenbatekoa',
            expense: 'Gastuak',
            energyTitle: 'Energia-batura (kWh)',
            enrgy: 'Energia',
            averageTransationTitle: 'Batezbesteko transakzioak',
            transaction: 'Transakzioa',
            creditLimit: 'Kredituaren muga',
            totalDriverAccounts: 'Gidarien kontuen guztizkoa',
            enabled: 'Gaituta',
            disabled: 'Desgaituta',
        },
        button: {
            apply: 'Aplikatu',
            clear: 'Garbitu',
        },
        cpoType: {
            Both: 'Biak',
            Local: 'Tokikoa',
            International: 'Nazioartekoa',
        },
    },
    permission: {
        createArticle: 'Artikulu bat gehitu',
        editArticle: 'Artikulua editatu',
        save: 'Gorde',
        confirm: 'Ziur zaude?',
        cancel: 'Ezeztatu',
        update: 'Eguneratu',
    },
    table: {
        pagination: {
            prev: 'Aurrekoa',
            nrev: 'Hurrengoa',
            showing: 'Bistaratzen',
        },
        data: {
            noData: 'Ez da aurkitu daturik.',
        },
    },
    article: {
        title: 'Kudeatu artikulua',
        id: 'Artikuluaren ID-a',
        date: 'Data',
        tabletitle: 'Izenburua',
        author: 'Egilea',
        reviewer: 'Ikuskatzailea',
        actions: 'Ekintzak',
        saveMessage: 'Artikulua ongi gorde da',
        updateMessage: 'Artikulua ongi eguneratu da',
        deleteMessage: 'Artikulua ongi ezabatu da',
    },
    user: {
        title: 'Erabiltzaileak: ##COMPANY_BRAND_NAME## - eMobility Zerbitzuaren Plataforma',
        user: 'Erabiltzaileak',
        manageUser: 'Kudeatu erabiltzailea',
        placeholder: {
            name: 'Izena',
            email: 'Helbide elektronikoa',
            phoneNo: 'Telefono-zenb.',
            firstName: 'Izena',
            lastName: 'Abizena',
            userGroup: 'Erabiltzaile-taldeak',
            userRoles: 'Erabiltzailearen betekizunak',
            Organisation: 'Erakundea',
            select: 'Hautatu egoera',
            selectOrganisation: 'Hautatu erakundea',
            selectUserGroup: 'Hautatu erabiltzaile-taldea',
            languagePreference: 'Hizkuntza lehenetsia',
        },
        label: {
            firstName: 'Izena',
            lastName: 'Abizena',
            email: 'Helbide elektronikoa',
            phoneNo: 'Telefono-zenb.',
            optional: '(Aukerakoa)',
            userGroups: 'Erabiltzaile-taldeak',
            userRoles: 'Erabiltzailearen betekizunak',
            Organisation: 'Erakundea',
            createdDate: 'Noiz sortua',
            languagePreference: 'Hizkuntza lehenetsia',
            id: 'Id',
            action: 'Ekintza',
            status: 'Egoera',
            name: 'Izena',
            delete: 'Ezabatu',
            enable: 'Gaitu',
            all: 'Guztiak',
            disable: 'Desgaitu',
            enabled: 'Gaituta',
            disabled: 'Desgaituta',
            pending: 'Egiteke',
            reset2FA: 'Berrezarri 2FA',
            deleted: 'Ezabatuta',
            lastLoginDate: 'Azken saio hasieraren data',
        },
        button: {
            search: 'Bilatu',
            cancel: 'Ezeztatu',
            save: 'Gorde',
            add: 'Gehitu',
            edit: 'Editatu',
            reset: 'Berrezarri',
            delete: 'Ezabatu',
            yes: 'Bai',
            no: 'Ez',
            enabled: 'Gaitu',
            disabled: 'Desgaitu',
            action: 'Ekintza',
            back: 'Atzera',
            sendEmail: 'Bidali posta elektronikoa',
            reset2FA: 'Berrezarri 2FA',
        },
        message: {
            deleteConfirmMesage: 'Ziur ezabatu nahi duzula?',
            enableConfirmMesage: 'Ziur gaitu nahi duzula?',
            disableConfirmMesage: 'Ziur desgaitu nahi duzula?',
            sendMailConfirmMessage: 'Ziur mezu elektronikoa bidali nahi duzula?',
            mailSentSuccessMessage: 'Mezu elektronikoa ondo bidali da.',
            reset2FAConfirmMesage: 'Ziur 2FA berrezarri nahi duzula erabiltzaile honentzat?',
        },
        errors: {
            email: {
                required: 'Sartu helbide elektronikoa',
                email: 'Sartu baliozko helbide elektronikoa',
            },
            firstName: {
                required: 'Sartu izena',
                valid: 'Sartu baliozko izen bat',
            },
            lastName: {
                required: 'Sartu abizena',
                valid: 'Sartu baliozko abizena',
            },
            phoneNo: {
                required: 'Sartu telefono-zenbakia',
                match: 'Sartu baliozko telefono-zenbaki bat',
            },
            userGroups: {
                required: 'Aukeratu Erabiltzaile-talde bat gutxienez',
            },
            organization: {
                required: 'Hautatu erakundea',
            },
        },
    },
    userGroup: {
        title: 'Erabiltzaile-taldeak: ##COMPANY_BRAND_NAME## - eMobility Zerbitzuaren Plataforma',
        manageUserGroup: 'Kudeatu erabiltzaile-taldea',
        users: 'Erabiltzaileak',
        header: 'Erabiltzaile-taldeak',
        button: {
            search: 'Bilatu',
            reset: 'Berrezarri',
            edit: 'Editatu',
            delete: 'Ezabatu',
            save: 'Gorde',
            cancel: 'Ezeztatu',
            yes: 'Bai',
            no: 'Ez',
            action: 'Ekintza',
            add: 'Gehitu',
            back: 'Atzera',
            enable: 'Gaitu',
            disable: 'Desgaitu',
            permission: 'Sartzeko baimena',
        },
        placeholder: {
            groupName: 'Taldearen izena',
            users: 'Hautatu erabiltzaileak',
            select: 'Hautatu egoera',
            organisation: 'Hautatu erakundea',
        },
        message: {
            deleteConfirmMesageForOrganistion:
                'Erakunde-taldea ezabatzean, erakunde zehatz batentzako elkarte-taldea kenduko dugu, ziur jarraitu nahi duzula?',
            deleteConfirmMesage: 'Ziur ezabatu nahi duzula?',
            enableConfirmMesage: 'Ziur gaitu nahi duzula?',
            disableConfirmMesage: 'Ziur desgaitu nahi duzula?',
        },
        label: {
            id: 'Id',
            name: 'Izena',
            description: 'Deskribapena',
            Organisation: 'Erakundea',
            createdBy: 'Sortzailea',
            status: 'Egoera',
            modifiedBy: 'Nork aldatua',
            createdDate: 'Noiz sortua',
            modifiedDate: 'Noiz aldatua',
            action: 'Ekintza',
            groupName: 'Taldearen izena',
            delete: 'Ezabatu',
            enable: 'Gaitu',
            disable: 'Desgaitu',
            phoneNo: 'Telefono-zenbakia',
            email: 'Helbide elektronikoa',
            groupAccess: 'Taldeko sarbidea',
            selectUsers: 'Hautatu erabiltzaileak',
            enabled: 'Gaituta',
            disabled: 'Desgaituta',
            yes: 'Bai',
            no: 'Ez',
        },
        form: {
            groupName: {
                label: 'Taldearen izena',
                placeholder: 'Sartu taldearen izena',
            },
            description: {
                label: 'Deskribapena',
                placeholder: 'Idatzi deskribapena',
            },
            Organisation: {
                label: 'Erakundea',
            },
        },
        errors: {
            groupName: {
                required: 'Sartu taldearen izena',
                valid: 'Sartu taldearen baliozko izen bat',
                max: '50 karaktere erabil daitezke gehienez',
            },
            description: {
                max: '255 karaktere erabil daitezke gehienez',
            },
            userList: {
                required: 'Aukeratu erabiltzaile bat gutxienez',
            },
        },
        permission: {
            header: 'Baimena',
            label: {
                module: 'Modulua',
                subModule: 'Azpi-modulua',
                action: 'Ekintza',
            },
        },
    },
    transactions: {
        headerTitle: 'Gidariaren transakzioak - ##COMPANY_BRAND_NAME## : IE karga azkarra EB (UK)',
        title: 'Gidariaren transakzioak',
        transaction: 'Transakzioa',
        columns: {
            amount: 'Kantitatea',
            location: 'Kokapena',
            date: 'Data',
            milesAdded: 'Gehitutako miliak',
            time: 'Denbora',
            cost: 'Kostua',
            energy: 'Energia',
            action: 'Ekintza',
            remark: 'Iruzkinak',
            credit: 'Kreditua',
            debit: 'Zordunketa',
            closing: 'Ixten',
            transaction: 'Transakzioaren ID-a',
            name: 'Izena',
            type: 'Mota',
            federatedAccount: 'Kontu mota federatuak',
            reference_id: 'Erreferentziaren ID-a',
            energyCost: 'Energia kostua',
            fixedCost: 'Kostu finkoa',
            chargingTimeCost: 'Karga denboraren kostua',
            parkingTime: 'Aparkatze denbora',
            parkingCost: 'Aparkatze kostua',
            appliedTariff: 'Aplikatutako Tarifa',
            netCost: 'Kostu garbia',
            VATRate: 'BEZ tasa',
        },
        form: {
            charge: 'Karga',
            payment: 'Ordainketa',
            month: 'Hilabetea',
        },
        label: {
            exportAll: 'Esportatu denak',
            driver: 'Gidaria',
            vehicle: 'Ibilgailua',
            cardPayment: 'Txartel bidezko ordainketa',
            referralBonus: 'Igorpen hobaria',
            rewards: 'Sariak',
            transactionDetails: 'Transakzioaren xehetasunak',
            transaction_id: 'Transakzioaren Id-a',
            fullName: 'Izen-abizenak',
            email: 'Helbide elektronikoa',
            phone_number: 'Telefono-zenbakia',
            viewFailedPayments: 'Huts egindako ordainketak ikusi',
        },
        button: {
            search: 'Bilatu',
            reset: 'Berrezarri',
            back: 'Atzera',
        },
        placeholder: {
            startDate: 'Hasiera-data',
            endDate: 'Bukaera-data',
            name: 'Izena',
            chargingStation: 'Kargatzeko geltokia',
            selectType: 'Hautatu mota',
            transaction: 'Transakzioaren ID-a',
            reference_id: 'Erreferentziaren ID-a',
        },
        message: {
            noDataToExport: 'Ez dago daturik esportatzeko.',
            error: {
                common: 'Zerbait ez da ongi atera. Berriz saiatu',
            },
        },
    },
    driver: {
        title: 'Gidariak: ##COMPANY_BRAND_NAME## - eMobility Zerbitzuaren Plataforma',
        header: 'Gidariak',
        manageDriver: 'Kudeatu gidariak',
        startCharge: 'Abian jarri urrutiko karga',
        activities: 'Jarduerak',
        detail: 'Gidariaren xehetasunak',
        address_detail: 'Helbidea',
        billing_address_detail: 'Fakturazio helbidea',
        chargeDetails: 'Kargaren xehetasunak',
        debtLetterHistory: 'Zorren inguruko gutunen historiala',
        note: 'Oharra: Uneko gidariaren saria eta sustapen berria desberdinak badira, haren egungo voltak iraungi egingo dira.',
        charityAdded: 'Ongizateko dohaintza erantsia',
        cd: 'od',
        placeholder: {
            name: 'Izena',
            email: 'Helbide elektronikoa',
            firstName: 'Izena',
            lastName: 'Abizena',
            payment_card: 'Ordainketa txartelaren azken 4 digituak',
            select: {
                status: 'Hautatu egoera',
                account_type: 'Hautatu kontu mota',
                payment_type: 'Hautatu ordainketa mota',
                driver_groups: 'Hautatu gidari-taldeak',
                driver_tags: 'Hautatu etiketak',
                organization: 'Hautatu erakundea',
                promotion: 'Hautatu sustapena',
            },
            driverGroup: 'Gidari-taldeak',
            organization: 'Erakundea',
            account_type: 'Kontu mota',
            payment_type: 'Ordainketa mota',
            referral_code: 'Igorpen-kodea',
            driver_tags: 'Etiketak',
            address: 'Helbidearen 1. lerroa',
            address2: 'Helbidearen 2. lerroa',
            city: 'Hiria',
            county: 'Konderria',
            postal_code: 'Posta kodea',
            billing_address: 'Helbidearen 1. lerroa',
            billing_address2: 'Helbidearen 2. lerroa',
            billing_city: 'Hiria',
            billing_county: 'Konderria',
            billing_postal_code: 'Posta kodea',
            promotion: 'Sustapenak',
            currentDriverPromotion: 'Abian den sustapena',
            driverPromotionJoinDate: 'Noiz elkartua',
            chargeLocation: 'Kokapena',
            chargeStation: 'Geltokia',
            connector: 'Konektorea',
            limitedKWH: 'kWh mugatua:',
            confirmationNote:
                'Kontuaren segurtasunerako, berretsi gidariaren izen-abizenak, helbidearen 1. lerroa eta posta kodea urrutiko kargari ekin aurretik. Markatu karratua bezeroaren berrespenaren ondoren',
            rfidCard: 'RFID txartela',
            confirmationNoteFleet: 'Berretsi pasahitza gidariarekin: ',
            vehicle_number: 'Ibilgailuaren zenbakia',
            api_url: 'API URL-a',
            startDate: 'Hasiera-data',
            endDate: 'Bukaera-data',
            publicRFID: 'RFID publikoko txartelaren ID-a',
            languagePreference: 'Hizkuntza lehenetsia',
            searchAddress: 'Helbidea',
        },
        label: {
            firstName: 'Izena',
            lastName: 'Abizena',
            email: 'Helbide elektronikoa',
            group: 'Taldea',
            driverGroups: 'Gidari-taldeak',
            driver_tags: 'Etiketak',
            organization: 'Erakundea',
            payment_type: 'Ordainketa mota',
            referral_code: 'Igorpen-kodea',
            createdDate: 'Noiz sortua',
            id: 'Id',
            action: 'Ekintza',
            status: 'Egoera',
            account_type: 'Kontu mota',
            type: 'Mota',
            name: 'Izena',
            delete: 'Ezabatu',
            enable: 'Gaitu',
            all: 'Guztiak',
            disable: 'Desgaitu',
            enabled: 'Gaituta',
            disabled: 'Desgaituta',
            cancelled: 'Ezeztatuta',
            deleted: 'Ezabatuta',
            address: 'Helbidea',
            address2: 'Helbidearen 2. lerroa',
            city: 'Hiria',
            county: 'Konderria',
            postal_code: 'Posta kodea',
            billing_address: 'Helbidearen 1. lerroa',
            billing_address2: 'Helbidearen 2. lerroa',
            billing_city: 'Hiria',
            billing_county: 'Konderria',
            billing_postal_code: 'Posta kodea',
            promotion: 'Sustapenak',
            expired: ' - Iraungia',
            currentDriverPromotion: 'Abian den sustapena',
            driverPromotionJoinDate: 'Noiz elkartua',
            vehicleNumber: 'Ibilgailuaren zenbakia',
            paymentCard: 'Ordaintzeko txartela',
            cardType: 'Txartel mota',
            cardNumber: 'Txartel-zenbakia (Azken 4 digituak)',
            cardTitle: 'Txartelaren izenburua',
            cardExpiry: 'Txartelaren iraungitze-data',
            paymentServiceProvider: 'Ordainketa zerbitzuaren hornitzailea',
            viewReferral: 'Ikus bidalketa',
            referralDetails: 'Bidalketaren xehetasunak',
            referrer_name: 'Igorlearen izena',
            referral_name: 'Bidalketaren izena',
            referral_bonus: 'Igorpen hobaria',
            referralBonusStatus: 'Bidalketaren hobariaren egoera',
            referee_Name: 'Bitartekariaren izena',
            noRecords: 'Ez dago erregistrorik erakusteko',
            noReferralsMessage: 'Ez dago bidalketarik',
            referrerName: 'Bitartekariaren igorle-izena: ',
            referralCode: 'Bitartekariaren igorle-kodea:',
            noReferrerMessage: 'Ez dago igorlerik',
            current_balance: 'Uneko saldoa',
            referral_balance: 'Igorlearen saldoa',
            account_balance: 'Kontuko saldoa',
            rewards_balance: 'Sarien saldoa',
            balanceDetails: 'Saldoaren xehetasunak',
            pending_transactions_details: 'Zain dauden Transakzioen Xehetasunak',
            pending_balance: 'Zain dagoen Saldoa',
            federated_account_type: 'Kontu mota federatuak',
            pending: 'Egiteke',
            rfidCard: 'RFID txartela',
            startCharge: 'Abian jarri urrutiko karga',
            chargeLocation: 'Kokapena',
            chargeStation: 'Geltokia',
            connector: 'Konektorea',
            limitedKWH: 'kWh mugatua:',
            confirmationNote:
                'Kontuaren segurtasunerako, berretsi gidariaren izen-abizenak, helbidearen 1. lerroa eta posta kodea urrutiko kargari ekin aurretik. Markatu karratua bezeroaren berrespenaren ondoren',
            fullName: 'Izen-abizenak',
            phoneNo: 'Telefono-zenbakia',
            confirmationNoteFleet: 'Berretsi pasahitza gidariarekin: ',
            chargingStartedMessage: 'Abian jarri urrutiko karga eskaria ongi burutu da',
            resetPassword: 'Berrezarri pasahitza',
            password: 'Pasahitza',
            disablePaymentCard: 'Desgaitu ordaintzeko txartela',
            requestedData: 'Eskatutako datuak',
            apiURL: 'API',
            viewData: 'Ikusi datuak',
            deletionEmailSent: 'Kontua deuseztatzeko posta elektronikoa bidali da',
            yes: 'Bai',
            onstop: 'Geldo',
            badDebtor: 'Zordun txarra',
            available: 'Erabilgarri',
            languagePreference: 'Hizkuntza lehenetsia',
            fakeAccount: 'Kontu faltsua',
            addNotes: 'Gehitu oharrak',
            newNote: 'Ohar berria',
            addNote: 'Gehitu oharra',
            existingNotes: 'Aurreko oharrak',
            viewNotes: 'Ikus oharrak',
            notes: 'Oharrak',
            financialDetails: 'Finantza-xehetasunak',
            uniqueID: 'ID bakarra',
            dateGenerated: 'Noiz sortua',
            debtValue: 'Zorraren balioa',
            letterTemplate: 'Erabilitako gutunaren txantiloia',
            lastCardValidationDate: 'Txartelaren azken balioztatze-data',
            cancelPendingTransactions: 'Bertan Behera Utzi Transakzioak Zain Daudenak',
            cancelTransactions: 'Transakzioak Ezeztatu',
        },
        pendingTransaction: {
            label: {
                chargeLocation: 'Kokapena',
                chargeStation: 'Karga Geltokia',
                sessionId: 'Saio ID',
                sessionStatus: 'Saioaren Egoera',
                amount: 'Zenbateko',
                createdDate: 'Sortze Data',
            },
            button: {
                settle: 'Kitatu',
                cancel: 'Ezeztatu',
            },
        },
        account_type: {
            driver: 'Gidaria',
            vehicle: 'Ibilgailua',
        },
        payment_type: {
            credit_account: 'Kreditu-kontua',
            prepayment_account: 'Aurreordainketa-kontua',
        },
        button: {
            search: 'Bilatu',
            cancel: 'Ezeztatu',
            save: 'Gorde',
            edit: 'Editatu',
            reset: 'Berrezarri',
            delete: 'Ezabatu',
            yes: 'Bai',
            no: 'Ez',
            enabled: 'Gaitu',
            disabled: 'Desgaitu',
            action: 'Ekintza',
            back: 'Atzera',
            sendEmail: 'Bidali posta elektronikoa',
            viewTransactions: 'Ikus transakzioak',
            close: 'Itxi',
            startCharge: 'Abian jarri urrutiko karga',
            startChargeBtn: 'Abian jarri karga',
            resetPassword: 'Berrezarri pasahitza',
            submit: 'Bidali',
            amendBalance: 'Zuzendu saldoa',
            viewActivities: 'Ikus jarduerak',
            premiumSubscriptions: 'Premium harpidetzak',
            markAsFake: 'Markatu kontu faltsu gisa',
            addNotes: 'Gehitu oharrak',
            debtLetterHistory: 'Zorren inguruko gutunen historiala',
            enableReferralCode: 'Gaitu igorle-kodea',
            disableReferralCode: 'Desgaitu igorle-kodea',
        },
        message: {
            deleteConfirmMesage: 'Ziur ezabatu nahi duzula?',
            enableConfirmMesage: 'Ziur gaitu nahi duzula?',
            disableConfirmMesage: 'Ziur desgaitu nahi duzula?',
            sendMailConfirmMessage: 'Ziur mezu elektronikoa bidali nahi duzula?',
            mailSentSuccessMessage: 'Mezu elektronikoa ondo bidali da.',
            resetPasswordConfirmMesage: 'Ziur pasahitza berrezarri nahi duzula erabiltzaile honentzat?',
            deleteDriverConfirmMesage: 'Ziur gidari honen kontua ezabatu nahi duzula?',
            markAsFakeConfirmMessage:
                'Gidariaren kontua faltsu gisa markatu nahi duzu? Prozesu honek ez du atzera egiterik eta informazioa ezabatu egingo da.',
            enableReferralCodeConfirmMesage: 'Ziur zaude igorle-kodea gaitu nahi duzula gidari honentzat?',
            disableReferralCodeConfirmMesage: 'Ziur zaude igorle-kodea desgaitu nahi duzula gidari honentzat?',
            cancelPendingTransactionsConfirmMesage:
                'Ziur zaude hautatutako zain dauden transakzioak ezeztatu nahi dituzula?',
        },
        errors: {
            driverGroups: {
                required: 'Aukeratu Gidari-talde bat gutxienez',
            },
            organization: {
                required: 'Hautatu erakundea',
            },
            tag: {
                invalid_fromat: 'Karaktere baliogabeak etiketan',
            },
            fullName: {
                valid: 'Sartu taldearen baliozko izen bat',
            },
            phoneNo: {
                match: 'Sartu baliozko telefono-zenbaki bat',
            },
            email: {
                required: 'Sartu helbide elektronikoa',
                email: 'Sartu baliozko helbide elektronikoa',
            },
            password: {
                passwordFormat:
                    'Pasahitzak 10 karaktere edo gehiago izan behar ditu, letra maiuskula, letra minuskula, karaktere berezi eta zenbaki banarekin.',
            },
        },
    },
    driverGroup: {
        title: 'Gidari-taldeak: ##COMPANY_BRAND_NAME## - eMobility Zerbitzuaren Plataforma',
        titleFleet: 'Taldeak: ##COMPANY_BRAND_NAME## - eMobility Zerbitzuaren Plataforma',
        manageDriverGroup: 'Kudeatu Gidari-taldea',
        manageDriverGroupFleet: 'Kudeatu taldea',
        driversList: 'Gidariak',
        driversListFleet: 'Gidariak/Ibilgailuak',
        header: 'Gidari-taldeak',
        headerFleet: 'Taldeak',
        button: {
            search: 'Bilatu',
            reset: 'Berrezarri',
            edit: 'Editatu',
            delete: 'Ezabatu',
            save: 'Gorde',
            cancel: 'Ezeztatu',
            yes: 'Bai',
            no: 'Ez',
            action: 'Ekintza',
            add: 'Gehitu',
            back: 'Atzera',
            enable: 'Gaitu',
            disable: 'Desgaitu',
        },
        placeholder: {
            groupName: 'Taldearen izena',
            drivers: 'Hautatu gidariak',
            driversFleet: 'Hautatu gidariak/Ibilgailuak',
            select: 'Hautatu egoera',
            selectType: 'Hautatu mota',
        },
        message: {
            deleteConfirmMesage: 'Ziur ezabatu nahi duzula?',
            enableConfirmMesage: 'Ziur gaitu nahi duzula?',
            disableConfirmMesage: 'Ziur desgaitu nahi duzula?',
        },
        label: {
            id: 'Id',
            name: 'Izena',
            description: 'Deskribapena',
            organization: 'Erakundea',
            createdBy: 'Sortzailea',
            status: 'Egoera',
            modifiedBy: 'Nork aldatua',
            createdDate: 'Noiz sortua',
            modifiedDate: 'Noiz aldatua',
            action: 'Ekintza',
            groupName: 'Taldearen izena',
            delete: 'Ezabatu',
            enable: 'Gaitu',
            disable: 'Desgaitu',
            phoneNo: 'Telefono-zenbakia',
            email: 'Helbide elektronikoa',
            groupAccess: 'Taldeko sarbidea',
            selectDrivers: 'Hautatu gidariak',
            selectDriversFleet: 'Hautatu gidariak/Ibilgailuak',
            enabled: 'Gaituta',
            disabled: 'Desgaituta',
            yes: 'Bai',
            no: 'Ez',
            vehicle_number: 'Ibilgailu zenb.',
            type: 'Mota',
            updateDriverAssociation: 'Eguneratu gidariaren elkartea',
            addToThisGroup: 'Gehitu talde honetan',
            cancel: 'Ezeztatu',
        },
        form: {
            groupName: {
                label: 'Taldearen izena',
                placeholder: 'Sartu taldearen izena',
            },
            description: {
                label: 'Deskribapena',
                placeholder: 'Idatzi deskribapena',
            },
        },
        errors: {
            groupName: {
                required: 'Sartu taldearen izena',
                valid: 'Sartu baliozko taldearen izen bat',
                max: '50 karaktere erabil daitezke gehienez',
            },
            description: {
                max: '255 karaktere erabil daitezke gehienez',
            },
            driverList: {
                required: 'Aukeratu gidari bat gutxienez',
                requiredfleet: 'Aukeratu gidari/ibilgailu bat gutxienez',
            },
            spendLimit: {
                valid: 'Sartu gastuen gehienezko balio bat gutxienez',
            },
        },
    },
    vat: {
        title: 'BEZ zenbakia: ##COMPANY_BRAND_NAME##',
        vat: 'BEZ',
        manageVat: 'Kudeatu BEZ zenbakia',
        label: {
            name: 'Izena',
            description: 'Deskribapena',
            rate: 'Tasa',
            createdDate: 'Noiz sortua',
            action: 'Ekintza',
            status: 'Egoera',
            disabled: 'Desgaituta',
            enabled: 'Gaituta',
            delete: 'Ezabatu',
            enable: 'Gaitu',
            disable: 'Desgaitu',
            defaultVAT: 'BEZ lehenetsia',
            yes: 'Bai',
        },
        message: {
            deleteConfirmMesage: 'Ziur ezabatu nahi duzula?',
            enableConfirmMesage: 'Ziur gaitu nahi duzula?',
            disableConfirmMesage: 'Ziur desgaitu nahi duzula?',
            setDefaultConfirmMesage: 'Ziur BEZ hori lehenetsi nahi duzula?',
        },
        button: {
            search: 'Bilatu',
            cancel: 'Ezeztatu',
            save: 'Gorde',
            add: 'Gehitu',
            edit: 'Editatu',
            reset: 'Berrezarri',
            delete: 'Ezabatu',
            enabled: 'Gaitu',
            disabled: 'Desgaitu',
            action: 'Ekintza',
            back: 'Atzera',
            setDefaultVAT: 'ezarri Lehenetsi gisa',
        },
        placeholder: {
            select: 'Hautatu egoera',
            name: 'Izena',
            description: 'Deskribapena',
            rate: 'Tasa',
        },
        errors: {
            name: {
                valid: 'Sartu baliozko izena.',
            },
            rate: {
                max: 'Tasak ezin du 100 baino handiagoa izan',
                min: 'Tasak ezin du 0 baino txikiagoa izan',
                number: 'Tasa zenbaki bat izan behar da',
            },
            description: {
                valid: 'Sartu baliozko deskribapena',
            },
        },
    },
    confirmBox: {
        button: {
            yes: 'Bai',
            no: 'Ez',
            proceed: 'Ekin',
            cancel: 'Ezeztatu',
        },
    },
    tag: {
        title: 'Etiketak: ##COMPANY_BRAND_NAME## - eMobility Zerbitzuaren Plataforma',
        tag: 'Etiketak',
        manageUser: 'Kudeatu erabiltzaileak',
        placeholder: {
            name: 'Etiketatu izena',
            select: 'Hautatu',
        },
        label: {
            name: 'Etiketatu izena',
            driver_count: 'Gidariaren kontua',
            charge_location_count: 'Karga-kokapenaren kontua',
            action: 'Ekintza',
            delete: 'Ezabatu',
            editHeader: 'Editatu etiketa',
        },
        button: {
            search: 'Bilatu',
            cancel: 'Ezeztatu',
            save: 'Gorde',
            add: 'Gehitu',
            edit: 'Editatu',
            reset: 'Berrezarri',
            delete: 'Ezabatu',
            yes: 'Bai',
            no: 'Ez',
            enabled: 'Gaitu',
            disabled: 'Desgaitu',
            action: 'Ekintza',
            back: 'Atzera',
        },
        message: {
            deleteConfirmMesage:
                'Etiketa ezabatuko da gidari elkartu guztietatik eta kargaren kokapenetik. Ziur ezabatu nahi duzula?',
        },
        errors: {
            name: 'Karaktere baliogabeak etiketan',
        },
    },
    chargeStation: {
        title: 'Kargatzeko geltokiak: ##COMPANY_BRAND_NAME## - eMobility Zerbitzuaren Plataforma',
        chargeStations: 'Kargatzeko geltokiak',
        manageVat: 'Kudeatu kargatzeko geltokia',
        label: {
            modifiedDate: 'Noiz aldatua',
            importChargeStationHeader: 'Inportatu kargatzeko geltokia',
            csvFile: 'CSV Fitxategia',
            manageAmenities: 'Kudeatu instalazioak',
            chargePoint: 'Karga-kokapena',
            allLocations: 'Kokapen guztiak',
            assignedLocation: 'Esleitutako kokapenak',
            unassignedLocation: 'Esleitu gabeko kokapenak',
            chargeLocation: {
                cp_id: 'KG-ren Id-a',
                type: 'Mota',
                name: 'Izena',
                locationName: 'Kokapenaren izena',
                address: 'Helbidea',
                city: 'Hiria',
                postal_code: 'Posta kodea',
                appliesToOrg: 'Erakundeari dagokio',
                associatedPromotion: 'Lotutako sustapena',
                gmbLocationId: 'GMB kokapenaren ID-a',
                override_tariff: 'Tarifa gainidatzi',
                cpo: 'CPO',
            },
            chargeStation: {
                uid: 'UId',
                evse_id: 'EVSE ID',
                status: 'Egoera',
                physicalReference: 'Erreferentzia fisikoa',
                city: 'Hiria',
                postal_code: 'Posta kodea',
            },
            stationConnector: {
                connector_id: 'Konektorearen Id-a',
                standard: 'Arrunta',
                format: 'Formatua mota gisa',
                power_type: 'Potentzia mota',
                voltage: 'Tentsioa',
                amperage: 'Anpere-kopurua',
                power_rating: 'Potentzia tasa',
                override_tariff: 'Tarifa gainidatzi',
            },
            selectTag: 'Hautatu etiketak',
            addTagHeader: 'Lotu etiketak',
            tags: 'Etiketak',
            yes: 'Bai',
            assignedTariff: 'Esleitu tarifa',
            assignTariff: 'Esleitu tarifa kokapenei',
            delete: 'Ezabatu',
            action: 'Ekintza',
            addPromotion: 'Gehitu sustapena',
            selectPromotion: 'Hautatu sustapena',
            exportChargeStations: {
                connector_id: 'connector_id',
                max_power: 'max_power',
                cp_id: 'cp_id',
                type: 'mota',
                location: 'kokapena',
                station_name: 'station_name',
                address: 'helbidea',
                city: 'hiria',
                postal_code: 'postal_code',
                country: 'herrialdea',
                latitude: 'latitudea',
                longitude: 'longitudea',
                evse_id: 'evse_id',
                standard: 'arrunta',
                format: 'formatua',
                powertype: 'potentziamota',
                voltage: 'tentsioa',
                amperage: 'anpere-kopurua',
            },
            gmbLocationID: 'GMB kokapenaren ID-a',
            clickHere: 'Sakatu hemen',
            downloadTemplate: 'txantiloia deskargatzeko',
            importStationsModel: 'Inportatu kargatzeko geltokien modeloa',
            noDataToExport: 'Ez dago daturik esportatzeko.',
            note: 'Oharra: ',
            autoCalculateMaxPowerNote:
                'CPO batzuk potentzia maximoa automatikoki kalkulatzeko konfiguratu dira; inportazio hori erabiliz, kalkulatutako balioak gaindi daitezke.',
            applyToOrg: 'Aplikatu erakunde osoari',
        },
        errors: {
            tag: {
                invalid_fromat: 'Karaktere baliogabeak etiketan',
            },
            file: {
                fileType: "'.csv' luzapeneko fitxategia igo daiteke.",
            },
            gmbLocationId: {
                valid: 'Sartu baliozko GMP Kokapenaren ID-a',
            },
            common: 'Zerbait ez da ongi atera. Berriz saiatu',
        },
        button: {
            search: 'Bilatu',
            reset: 'Berrezarri',
            save: 'Gorde',
            cancel: 'Ezeztatu',
            edit: 'Editatu',
            expand: 'Zabaldu',
            collapse: 'Txikitu',
            import: 'Inportatu',
            synchronize: 'Sinkronizatu',
            syncStation: 'Sinkronizatu geltokia',
            assignTariff: 'Esleitu tarifa',
            delete: 'Ezabatu',
            add: 'Gehitu',
            addSelected: 'Gehitu hautatuak',
            addAll: 'Gehitu denak',
            yes: 'Bai',
            no: 'Ez',
            back: 'Atzera',
            apply: 'Aplikatu',
            editGMBLocationID: 'Editatu GMB kokapenaren ID-a',
            downloadLocationsData: 'Atera kargatzeko kokapenen datuak',
            exportAll: 'Esportatu denak',
            importStationsModel: 'Inportatu kargatzeko geltokien modeloa',
            deleteSelected: 'Ezabatu hautatuak',
            export: 'Esportatu',
            viewAssociatedTariffs: 'Tarifa elkartuak ikusi',
        },
        placeholder: {
            selectStationStatus: 'Hautatu egoera',
            name: 'Izena',
            cp_id: 'KG-ren Id-a',
            tags: 'Etiketak',
            address: 'Helbidea',
            selectTag: 'Hautatu etiketa',
            evse_id: 'EVSE ID-a',
            selectChargePoint: 'Hautatu CPO-ak',
            selectRegion: 'Hautatu eskualdea',
            selectPromotion: 'Hautatu sustapena',
            gmbLocationID: 'GMB kokapenaren ID-a',
            selectPowerType: 'Hautatu potentzia mota',
            selectAppliedTariff: 'Aukeratu Aplikatutako Tarifa',
        },
        message: {
            deleteConfirmMesage: 'Ziur ezabatu nahi duzula?',
            addPromotion: 'Sustapenaren xehetasunak ongi eguneratu dira',
            updateAmenitiesSuccess: 'Karga-kokapeneko instalazioak ongi eguneratu dira',
            chargePointRequire: 'Karga-kokapen bat behar da gutxienez',
            deleteBulkConfirmMessage: 'Ziur ezabatu nahi dituzula hautatutako erregistroak?',
            applyToAllOrgConfirmMessage: 'Tarifa hori erakunde eta kokapen guztiei aplikatu nahi diezu? ',
        },
        manageAmenities: 'Kudeatu instalazioak',
        chargeStationTariffDetailsModal: {
            header: 'Tarifaren xehetasunak',
            tabsName: {
                general: 'Orokorra',
            },
        },
    },
    chargeStationMap: {
        title: 'Kargatzeko geltokien maparen ikuspegia: ##COMPANY_BRAND_NAME## - eMobility Zerbitzuaren Plataforma',
        header: 'Kargatzeko geltokiak',
        label: {
            address: 'Helbidea',
            backOfficeUrl: 'Back Office-ko URL-a:',
            amenities: 'Instalazioak:',
            satellite: 'Satelitea',
            map: 'Mapa',
            search: 'Bilatu',
            refresh: 'Eguneratu',
            apply: 'Aplikatu',
            clear: 'Garbitu',
            loading: 'Kargatzen...',
        },
        placeholder: {
            locationSearch: 'Bilatu geltokia',
            mapSearch: 'Bilatu kalearen izenean, hirian edo posta kodean oinarrituta',
        },
    },
    promotionsRequest: {
        headerTitle: 'Gidarien sustapenen eskaera - ##COMPANY_BRAND_NAME## - eMobility Zerbitzuaren Plataforma',
        title: 'Gidarien sustapenen eskaera',
        promotionsRequest: 'Eskatutako sustapenak',
        columns: {
            driverName: 'Gidariaren izena',
            promotionsName: 'Sustapenen izena',
            promotionsCode: 'Kodea',
            approved: 'Egoera',
            approvedBy: 'Nork aldatua',
            approvedDate: 'Noiz aldatua',
            action: 'Ekintza',
            email: 'Helbide elektronikoa',
        },
        form: {
            charge: 'Karga',
            payment: 'Ordainketa',
            month: 'Hilabetea',
        },
        label: {
            approved: 'Onetsia',
            pending: 'Egiteke',
            rejected: 'Ukatua',
            modelHeader: 'Eskatutako sustapena - ',
            enterComment: 'Idatzi zure iruzkinak',
        },
        button: {
            search: 'Bilatu',
            reset: 'Berrezarri',
            back: 'Atzera',
            approved: 'Onetsi',
            pending: 'Egiteke',
            rejected: 'Ukatu',
            action: 'Ekintza',
            edit: 'Editatu',
        },
        placeholder: {
            driverName: 'Gidariaren izena',
            promotionsName: 'Sustapenen izena',
            promotionsCode: 'Kodea',
            select: 'Hautatu egoera',
        },
        message: {
            ManagestatusMesage:
                'Sakatu Onartua edo Baztertua eskaera egoera aplikatzeko. Eskaera hau eguneratzean, ezingo da editatu.',
        },
    },
    driverAccountBalance: {
        title: 'Gidariaren kontuko saldoa: ##COMPANY_BRAND_NAME## - eMobility Zerbitzuaren Plataforma',
        driverAccountBalance: 'Gidariaren kontuko saldoa',
        manageUser: 'Kudeatu gidariaren kontuko saldoa',
        placeholder: {
            name: 'Izena/e-posta',
            select: 'Hautatu egoera',
            payment_type: 'Hautatu ordainketa mota',
            description: 'Iruzkina',
            amount: 'Sartu kreditu/zordunketa kantitatea',
        },
        label: {
            name: 'Izena',
            email: 'Helbide elektronikoa',
            payment_type: 'Ordainketa mota',
            driver_status: 'Kontuaren egoera',
            current_balance: 'Saldoa',
            currency: 'Moneta',
            driver_id: 'Gidariaren Id-a',
            action: 'Ekintza',
            delete: 'Ezabatu',
            refundHeader: 'Funtsak ateratzea',
            creditPayment: 'Kreditu-kontua',
            prePayment: 'Aurreordainketa-kontua',
            enabled: 'Gaituta',
            disabled: 'Desgaituta',
            refund: 'Zuzendu kontuko saldoa',
            description: 'Iruzkina',
            amount: 'Sartu kreditu/zordunketa kantitatea',
            additional_payment: 'Ordainketa osagarria',
            payment_refunds: 'Ordainketako funtsak atera',
            payment_settlement: 'Saldoaren zuzenketa - Eskaera',
            balance: 'Saldo mota',
            accountBalance: 'Kontuko funtsak',
            referralBonus: 'Igorpen hobaria',
            rewardBalance: 'Sarien saldoa',
            total_balance: 'Saldoa guztira',
            rewards: 'Sariak',
            pendingBalance: 'Zain dagoen Saldoa',
        },
        button: {
            search: 'Bilatu',
            cancel: 'Ezeztatu',
            save: 'Gorde',
            add: 'Gehitu',
            edit: 'Editatu',
            reset: 'Berrezarri',
            delete: 'Ezabatu',
            yes: 'Bai',
            no: 'Ez',
            enabled: 'Gaitu',
            disabled: 'Desgaitu',
            action: 'Ekintza',
            back: 'Atzera',
            send_for_approval: 'Bidali onesteko',
        },
        message: {
            deleteConfirmMesage:
                'Etiketa ezabatuko da gidari elkartu guztietatik eta karga-kokapenetik. Ziur ezabatu nahi duzula?',
        },
        errors: {
            name: 'Karaktere baliogabeak etiketan',
            amount: {
                moreThan: 'Kantitateak 0 baino handiagoa/txikiagoa izan behar du',
                maxcredit: 'Kreditu-konturako gehienezko mugara iritsi da',
                maxdebit: 'Zordunketa-konturako gehienezko mugara iritsi da',
            },
        },
    },
    driverPromotions: {
        title: 'Kudeatu sustapena: ##COMPANY_BRAND_NAME## - eMobility Zerbitzuaren Plataforma',
        manageDriverPromotion: 'Kudeatu sustapena',
        driverPromotions: 'Sustapenak',
        label: {
            name: 'Izena',
            code: 'Kodea',
            errorMessage: 'Errore-mezua',
            used: 'Erabilia',
            unUsed: 'Erabili gabea',
            uploadFileErrorMessage: 'Errorea sustapen-kodeak kargatzean.',
            updatePromotionCode: 'Eguneratu sustapen-kodea',
            unique_code: 'Kode bakarra',
            uniquePromotionCode: 'Sustapen-kodeak',
            importDriverPromotionCodeHeader: 'Inportatu gidariaren sustapen-kodea',
            csvFile: 'Sustapen-kodeak',
            promotionCode: 'Sustapen-kodea',
            usedBy: 'Honek erabilia',
            description: 'Deskribapena',
            accountCredit: 'Kontuaren kreditua',
            discountRatePeriod: 'Deskontu-tasaren aldia',
            indays: '(Egunak)',
            intilakWhRate: 'Hasierako kWh tasa',
            ivRewardsPromotion: 'IV sarien sustapena',
            referralPromotion: 'Igorle-sustapena',
            expiryDate: 'Iraungitze-data',
            needApprovalToJoinPromotion: 'Onespena behar da sustapenean sartzeko',
            newDriversOnly: 'Gidari berriak bakarrik',
            forOrganisation: 'Erakundearentzat',
            createdDate: 'Noiz sortua',
            action: 'Ekintza',
            status: 'Egoera',
            delete: 'Ezabatu',
            enable: 'Gaitu',
            disable: 'Desgaitu',
            enabled: 'Gaituta',
            disabled: 'Desgaituta',
            deleted: ' (Ezabatuta)',
            csvFileSupported: 'CSV fitxategia bakarrik da bateragarria',
            clickHere: 'Sakatu hemen',
            downloadTemplate: 'txantiloia deskargatzeko',
            exportColumnHeder: 'promotion_codes',
            min_kwh_package_promotion: 'kWh minimoa',
            package_promotion_period: 'Paketearen sustapenaren aldia (Egunak)',
            package_promotion_volt_bonus: 'Saritutako volt kopurua',
            rfidCardUnitPrice: 'RFID txartelaren unitate-prezioa',
            subscription: 'Premium harpidetza',
            tariffUpdate: 'Tarifaren eguneratzea',
            currentTariff: 'Uneko gainidazketa tarifa',
            next: 'Hurrengoa',
            newTariff: 'Tarifa berria gainidazteko',
            save: 'Gorde',
            override_tariff: 'Tarifa gainidatzi',
            manageOverrideTariff: 'Gainidazketa-Tarifa kudeatu',
        },
        placeholder: {
            name: 'Izena',
            promotionCode: 'Sustapen-kodea',
            selectTariff: 'Hautatu tarifa',
            selectStatus: 'Hautatu egoera',
            startDate: 'Hasiera-data',
            endDate: 'Bukaera-data',
            forOrganisation: 'Erakundearentzat',
            min_kwh_package_promotion: 'kWh minimoa',
            package_promotion_period: 'Paketearen sustapenaren aldia',
            package_promotion_volt_bonus: 'Saritutako volt kopurua',
            rfidCardUnitPrice: 'RFID txartelaren unitate-prezioa',
            premium_subscription: 'Premium harpidetza',
            selectCurrentTariff: 'Hautatu uneko gainidazketa tarifa',
            selectNewTariff: 'Hautatu tarifa berria gainidazteko',
            selectOverrideTariff: 'Hautatu gainidazketa-Tarifa',
        },
        button: {
            update: 'Eguneratu',
            import: 'Inportatu',
            search: 'Bilatu',
            cancel: 'Ezeztatu',
            save: 'Gorde',
            add: 'Gehitu',
            edit: 'Editatu',
            reset: 'Berrezarri',
            delete: 'Ezabatu',
            enable: 'Gaitu',
            disable: 'Desgaitu',
            action: 'Ekintza',
            back: 'Atzera',
        },
        message: {
            deleteConfirmMesage: 'Ziur ezabatu nahi duzula?',
            enableConfirmMesage: 'Ziur gaitu nahi duzula?',
            disableConfirmMesage: 'Ziur desgaitu nahi duzula?',
            subscriptionChangeWarningMessage:
                'Abisua: Harpidetza mota aldatzeak Gidariaren kontuari lotutako berritze automatiko guztiak ezeztatuko ditu.',
            tariffUpdateNote: 'Tarifa berria ezarriko zaie hurrengo sustapenei:',
            updateTariffConfirmMessage: 'Ziur zaude tarifa eguneratu nahi duzula hautatutako sustapenentzat?',
            selectOneRecord: 'Hautatu sustapen bat gutxienez tarifa eguneratzeko',
        },
        errors: {
            promotionName: {
                valid: 'Sartu baliozko sustapen-izen bat',
            },
            promotionCode: {
                valid: 'Sartu baliozko sustapen-kode bat',
            },
            accountCredit: {
                moreThan: 'Kontuaren kredituak 0 baino handiagoa izan behar du',
                max: 'Kreditu-konturako gehienezko mugara iritsi da',
                typeError: 'Sartu baliozko kontuko kreditu zenbateko bat',
            },
            discountRatePeriod: {
                moreThan: 'Deskontu-tasaren aldiak ezin du 0 baino handiagoa izan',
            },
            intialRate: {
                max: 'Tasak ezin du 100 baino handiagoa izan',
                min: 'Tasak ezin du 0 baino txikiagoa izan',
                typeError: 'Sartu baliozko tasa',
            },
            common: 'Zerbait ez da ongi atera, saiatu berriro arren.',
            file: {
                fileType: "'.csv' luzapeneko fitxategia igo daiteke.",
            },
            maxValue: 'Gehienezko balioak ezin du 2147483647 baino handiagoa izan',
            rfidCardUnitPrice: {
                max: 'RFID txartelaren unitate-prezioa ezin da 1000 baino handiagoa izan',
            },
        },
    },
    paymentApproval: {
        headerTitle: 'Kontuko saldoaren onespenak - ##COMPANY_BRAND_NAME## : IE karga azkarra EB (UK)',
        title: 'Kontuko saldoaren onespenak',
        transaction: 'Transakzioa',
        columns: {
            email: 'Helbide elektronikoa',
            amount: 'Kantitatea',
            status: 'Egoera',
            request_by: 'Nork eskatua',
            request_date: 'Noiz eskatua',
            request_by_comment: 'Iruzkinek eskatua',
            review_by: 'Nork berrikusia',
            review_date: 'Noiz berrikusia',
            review_comment: 'Ikuskatzailearen iruzkinak',
            credit: 'Kreditua',
            debit: 'Zordunketa',
            closing: 'Ixten',
            transaction: 'Transakzioaren ID-a',
            name: 'Izena',
            action: 'Ekintza',
            request_type: 'Eskaera mota',
            invoice: 'Faktura',
        },
        form: {
            driver: 'Gidaria',
            organisation: 'Erakundea',
            month: 'Hilabetea',
        },
        label: {
            request_type: 'Eskaera mota',
            refundHeader: 'Saldoaren zuzenketa',
            pending: 'Egiteke',
            approved: 'Onetsi',
            declined: 'Baztertu',
            approve: 'Onetsi',
            decline: 'Baztertu',
            comment: 'Idatzi zure iruzkinak',
            status: 'Egoera',
            refund: 'Onartu kreditua/zordunketa',
            refundAmount: 'Ateratako dirua ',
            commentsFrom: 'Honen iruzkinak',
        },
        button: {
            search: 'Bilatu',
            reset: 'Berrezarri',
            back: 'Atzera',
            save: 'Gorde',
            cancel: 'Ezeztatu',
        },
        placeholder: {
            comment: 'Idatzi zure iruzkinak',
            status: 'Hautatu egoera',
            name: 'Izena/e-posta',
            refundAmount: 'Ateratako dirua ',
        },
        message: {
            noDataToExport: 'Ez dago daturik esportatzeko.',
            selectApprovalOrReject: 'Onartu/Baztertu eskaera hau.',
        },
    },
    paymentScheduleSetting: {
        title: 'Ordainketa-egutegiaren ezarpena: ##COMPANY_BRAND_NAME## - eMobility Zerbitzuaren Plataforma',
        header: 'Ordainketa-egutegia',
        note: ' Programatu lan bat atzeko planoan gidariek egindako IE birkargen ordaindu gabeko fakturak likidatzeko.',
        placeholder: {
            day_of_week: 'Asteko eguna',
        },
        label: {
            daily: 'Egunean behin',
            weekly: 'Astean behin',
            day_of_week: 'Asteko eguna',
            selectDay: 'Hautatu eguna',
        },
        day_of_week: {
            monday: 'ASTEARTEA',
            tuesday: 'ASTEAZKENA',
            wednesday: 'OSTEGUNA',
            thursday: 'OSTIRALA',
            friday: 'LARUNBATA',
            saturday: 'IGANDEA',
            sunday: 'ASTELEHENA',
        },
        button: {
            save: 'Gorde',
        },
    },
    paymentFailures: {
        title: 'Ordainketa-akatsak: ##COMPANY_BRAND_NAME## - eMobility Zerbitzuaren Plataforma',
        managePaymentFailures: 'Ordainketa-akatsak',
        placeholder: {
            name: 'Izena/e-posta',
            note: 'Iruzkina',
            startDate: 'Hasiera-data',
            endDate: 'Bukaera-data',
            select: 'Hautatu egoera',
            status: 'Hautatu egoera',
            failureReason: 'Hutsegitearen arrazoia',
        },
        label: {
            name: 'Izena',
            email: 'Helbide elektronikoa',
            transaction_id: 'Transakzioaren ID-a',
            total_amount: 'Kantitatea guztira',
            currency_name: 'Moneta',
            created_date: 'Noiz sortua',
            status: 'Egoera',
            note: 'Iruzkina',
            action: 'Ekintza',
            editHeader: 'Eguneratu ordainketen egoera',
            pending: 'Egiteke',
            acknowledged: 'Aintzatetsia',
            closed: 'Itxita',
            transactionDetails: 'Transakzioaren xehetasunak',
            transaction_request: 'Transakzio-eskera',
            transaction_response: 'Transakzio-erantzuna',
            error_message: 'Errore-mezua',
            error_code: 'Errore-kodea',
            request_type: 'Eskaera mota',
            response_code: 'Erantzun-kodea',
            response_code_description: 'Erantzun-kodearen deskribapena',
            null_data: 'Ez da aurkitu daturik',
            transaction_date: 'Transakzioaren data',
            failureReason: 'Hutsegitearen arrazoia',
        },
        button: {
            search: 'Bilatu',
            cancel: 'Ezeztatu',
            save: 'Gorde',
            add: 'Gehitu',
            edit: 'Editatu egoera',
            reset: 'Berrezarri',
            yes: 'Bai',
            no: 'Ez',
            action: 'Ekintza',
            back: 'Atzera',
        },
    },
    chargeTariff: {
        title: 'Tarifak: ##COMPANY_BRAND_NAME## - eMobility Zerbitzuaren Plataforma',
        header: 'Tarifak',
        tariff: 'Tarifa',
        columns: {
            location: 'Kokapena',
            chargeStation: 'Karga estazioaren izena',
            connector: 'Konektorea',
            standard: 'Arrunta',
        },
        label: {
            name: 'Izena',
            vat_name: 'BEZ izena',
            vat_rate: 'Tasa (%)',
            vat_description: 'Deskribapena',
            cpo_id: 'cpo Id-a',
            action: 'Ekintza',
            url: 'URL-a',
            currency: 'Moneta',
            createdDate: 'Noiz sortua',
            status: 'Egoera',
            enabled: 'Gaituta',
            deleted: 'Ezabatuta',
            detail: 'Xehetasuna',
            promotions: 'Sustapenak',
            lastUpdated: 'Azken eguneraketaren data',
            promotionCode: 'Sustapen-kodea',
            description: 'Deskribapena',
            expiryDate: 'Iraungitze-data',
            priceComponents: 'Prezioaren osagaiak',
            priceComponent: 'Prezioaren osagaia',
            type: 'MOTA',
            price: 'PREZIOA',
            pricePerHour: 'Prezioa (orduko)',
            restriction: 'Murrizketa',
            startDate: 'Hasiera-data',
            startTime: 'Hasiera-ordua',
            endDate: 'Bukaera-data',
            endTime: 'Bukaera-ordua',
            minkWh: 'kWh min',
            maxkWh: 'kWh max',
            minPower: 'Potentzia Min',
            maxPower: 'Potentzia Max',
            minDuration: 'Iraupena Min',
            maxDuration: 'Iraupena Max',
            weekDays: 'Asteko egunak',
            selectVat: 'Hautatu BEZ-a',
            attachVat: 'Erantsi BEZ-a',
            vatdetail: 'BEZ-aren xehetasunak',
            editVAT: 'Editatu BEZ mota',
            vatType: 'BEZ mota',
            tariffID: 'Tarifaren ID-a',
            element: 'ELEMENTUA',
            prices: 'Prezioak',
            restrictions: 'Mugak',
            stepSize: 'GRANULARITATEA',
            vat: 'BEZ',
            date: 'DATA',
            time: 'ORDUA',
            kwh: 'KWH',
            power: 'POTENTZIA (KW)',
            duration: 'IRAUPENA (SEC)',
            current: 'KORRONTEA (AMP)',
            maxCurrent: 'Korronte Maximoa',
            minCurrent: 'Korronte Minimoa',
            restrictionTitle: 'MUGA',
            details: 'Xehetasunak',
            weekDaysTitle: 'ASTEGUNAK',
            maxKwhTitle: 'KWH Gehienezkoa',
            minKwhTitle: 'KWH Gutxienezkoa',
            accessGroups: 'Taldeen sarbidea',
            locations: 'Kokalekuak',
            CPOs: 'CPO-ak',
            connectors: 'Konektoreak',
        },
        placeholder: {
            name: 'Izena',
            selectStatus: 'Hautatu egoera',
            selectVat: 'Hautatu BEZ-a',
            selectType: 'Hautatu BEZ mota',
            tariffID: 'Tarifaren ID-a',
            vatType: 'BEZ mota',
            currency: 'Moneta',
        },
        button: {
            search: 'Bilatu',
            reset: 'Berrezarri',
            action: 'Ekintza',
            edit: 'Editatu',
            detail: 'Xehetasuna',
            add: 'Gehitu',
            back: 'Atzera',
            save: 'Gorde',
            cancel: 'Ezeztatu',
            editvat: 'Erantsi BEZ-a',
            editVAT: 'Editatu BEZ mota',
            groupRestrictions: 'Taldeko Tarifa Murrizketak',
            ungroupRestrictions: 'Taldegabetutako Tarifa Murrizketak',
        },
        noRestrictionAvailable: 'Ez Dago Mugarik Eskuragarri',
    },
    partnerPromotion: {
        title: 'Bazkideen sustapenak: ##COMPANY_BRAND_NAME## - eMobility Zerbitzuaren Plataforma',
        header: 'Bazkideen sustapenak',
        placeholder: {
            nameorcompany: 'Izena edo Enpresa',
            status: 'Hautatu egoera',
            date_from: 'Hasiera-data',
            date_to: 'Bukaera-data',
        },
        label: {
            name: 'Izena',
            company: 'Enpresa',
            description: 'Deskribapena',
            date_from: 'Hasiera-data',
            date_to: 'Bukaera-data',
            expiry_date: 'Iraungitze-data',
            created_date: 'Noiz sortua',
            status: 'Egoera',
            action: 'Ekintza',
            enabled: 'Gaituta',
            disabled: 'Desgaituta',
            delete: 'Ezabatu',
        },
        button: {
            search: 'Bilatu',
            cancel: 'Ezeztatu',
            add: 'Gehitu',
            save: 'Gorde',
            edit: 'Editatu',
            reset: 'Berrezarri',
            delete: 'Ezabatu',
            yes: 'Bai',
            no: 'Ez',
            enabled: 'Gaitu',
            disabled: 'Desgaitu',
            action: 'Ekintza',
            back: 'Atzera',
            enable: 'Gaitu',
            disable: 'Desgaitu',
            chargeStation: 'Kargatzeko geltokiak',
            preview: 'Aurreikusi',
        },
        message: {
            deleteConfirmMesage: 'Ziur ezabatu nahi duzula?',
            enableConfirmMesage: 'Ziur gaitu nahi duzula?',
            disableConfirmMesage: 'Ziur desgaitu nahi duzula?',
        },
        insert: {
            header: 'Kudeatu bazkideen sustapenak',
            placeholder: {
                name: 'Izena',
                company: 'Enpresaren informazioa',
                description: 'Deskribapena',
                start_date: 'Hasiera-data',
                expiry_date: 'Iraungitze-data',
                offer_duration: '60 minutu',
                stored_for_future_use_days: '2 egun',
                qr_code_details: 'QR kodearen informazioa',
                certificate: 'Ziurtagiria',
                image: 'Eskaintzaren irudia',
                image1: '1. irudi osagarria',
                image2: '2. irudi osagarria',
                image3: '3. irudi osagarria',
                image4: '4. irudi osagarria',
                image5: '5. irudi osagarria',
                banner_image: 'Sustapenaren logotipoa',
                locationPageImage: 'Kokapen-orriaren irudia',
                displayOnChargeLocation: 'Bistaratu karga-kokapenaren pantailan',
                promotion_button_text: 'Sustapen botoiko testua',
            },
            label: {
                name: 'Izena',
                company: 'Enpresa',
                description: 'Deskribapena',
                start_date: 'Hasiera-data',
                expiry_date: 'Iraungitze-data',
                offer_duration: 'Eskaintzaren iraupena (minutuak)',
                stored_for_future_use_days: 'Etorkizunean erabiltzeko gorde (egunak)',
                always_display_on_partner_promotion: 'Bistaratu beti bazkideen sustapenak',
                qr_code_details: 'QR Kodea',
                certificate: 'Ziurtagiria',
                image: 'Eskaintzaren irudia',
                banner_image: 'Sustapenaren logotipoa (1030 X 430)',
                layout: 'Arbelaren itxura',
                note1: 'Kontuan izan <strong>##image##</strong> eta <strong>##qrcode##</strong> aipatu behar dituzula HTML pantaila bistaratzean, dagozkien xehetasunak haren arabera ordezkatzeko. Irudi osagarriak gehi daitezke diseinuan##image0X## kodea baliatuz, non X  1 eta 5 bitarteko zenbakia izan daitekeen.',
                qr_code_note:
                    'Kontuan izan <strong>##ChargeTransID##</strong>, <strong>##StartChargeTS##</strong>, <strong>##ChargeStationID##</strong> eta <strong>##ChargeStationAddress##</strong> aipatu behar dituzula QR Kodean dagozkien xehetasunak behar bezala ordezkatzeko.',
                locationPageImage: 'Kokapen-orriaren irudia',
                displayOnChargeLocation: 'Bistaratu karga-kokapenaren pantailan',
                partner_promotion_display_type: 'Sustapen-diseinu mota',
                promotion_button_text: 'Sustapen-botoiko testua',
                open_external_url: 'Ireki kanpoko URL-a',
                external_url: 'Kanpoko URL-a',
                image1: '1. irudi osagarria',
                image2: '2. irudi osagarria',
                image3: '3. irudi osagarria',
                image4: '4. irudi osagarria',
                image5: '5. irudi osagarria',
            },
            errors: {
                common: 'Zerbait ez da ongi atera, saiatu berriro arren.',
                name: {
                    valid: 'Sartu baliozko sustapen-izen bat',
                    max: 'Sustapen-izena luzeegia da',
                },
                description: {
                    max: 'Sustapenaren deskribapena luzeegia da',
                },
                offer_duration: {
                    moreThan: 'Eskaintzaren iraupenak 0 baino handiagoa izan behar du',
                    max: 'Eskaintzaren iraupenak ezin du 60 minututik gorakoa izan',
                },
                stored_for_future_use_days: {
                    moreThan: 'Etorkizunean erabiltzeko gordetzeko egun kopurua 0 baino handiagoa izan behar da',
                    max: 'Etorkizunean erabiltzeko gordetzeko egunen kopuruak ezin du 99 baino handiagoa izan',
                },
                banner_image: {
                    dimensions: 'Sustapenaren logotipoaren neurria 1030 X 430 izan behar da',
                },
                image: {
                    fileType: "'.jpg', '.png', '.svg', '.jpeg' luzapeneko fitxategiak karga daitezke",
                    location_page_image: 'Kokapen-orriaren irudia beharrezkoa da',
                },
                certificate: {
                    fileType: " '.crt', '.cer' luzapeneko fitxategiak igo daitezke.",
                },
                promotion_button_text: {
                    valid: 'Sartu baliozko sustapen-botoiko testua',
                },
                external_url: {
                    url: 'Kanpoko URL-ak baliozko URL bat izan behar du',
                },
            },
        },
        assign: {
            header: 'Kargatzeko geltokiak',
            headerModal: 'Kargatzeko geltokia',
            placeholder: {
                name: 'Sartu izena',
                locationName: 'Sartu kokapenaren izena',
                address: 'Helbidea',
                tags: 'Hautatu etiketak',
            },
            label: {
                add: 'Gehitu',
                name: 'Izena',
                type: 'Mota',
                address: 'Helbidea',
                city: 'Hiria',
                postcode: 'Posta kodea',
                last_updated: 'Noiz aldatua',
                action: 'Ekintza',
                delete: 'Ezabatu',
            },
            button: {
                delete: 'Ezabatu',
            },
            message: {
                deleteConfirmMesage: 'Ziur ezabatu nahi duzula?',
            },
        },
    },
    CPOInterface: {
        title: 'Kontuak: ##COMPANY_BRAND_NAME## - eMobility Zerbitzuaren Plataforma',
        header: 'Kontuak',
        placeholder: {
            name: 'Izena',
            status: 'Hautatu egoera',
        },
        label: {
            name: 'Izena',
            party_id: 'Alderdiaren Id-a',
            country_code: 'Herrialdearen kodea',
            version_url: 'Bertsioaren URL-a',
            created_date: 'Noiz sortua',
            status: 'Egoera',
            action: 'Ekintza',
            enabled: 'Gaituta',
            disabled: 'Desgaituta',
            locationGroup: 'Taldearen kokapena',
            yes: 'Bai',
            no: 'Ez',
            rfidDriverTokens: 'Gidariaren RFID tokenak bakarrik partekatu',
            vat_type: 'BEZ mota',
            version_2_1_1: '2.1.1',
            version_2_2: '2.2',
            version_2_2_1: '2.2.1',
            external_cpo: '##COMPANY_BRAND_NAME## Nazioarteko CPO-a',
            cpo_type: 'CPO Mota',
            override_tariff: 'Baliogabetu tarifa',
            provides_session_total_cost_updates: 'Eskaintzen Ditu Saioaren Kostu Osoaren Eguneraketak',
        },
        button: {
            search: 'Bilatu',
            cancel: 'Ezeztatu',
            add: 'Gehitu',
            save: 'Gorde',
            edit: 'Editatu',
            reset: 'Berrezarri',
            yes: 'Bai',
            no: 'Ez',
            enabled: 'Gaitu',
            disabled: 'Desgaitu',
            action: 'Ekintza',
            back: 'Atzera',
            enable: 'Gaitu',
            disable: 'Desgaitu',
            getCredentials: 'Lortu kredentzialak',
            performHandshake: 'Eskukada egin',
            reHandshake: 'Berriz eskukatu',
            generateHandshakeToken: 'Eskukada tokena sortu',
            reGenerateHandshakeToken: 'Eskukada tokena berriro sortu',
            changeMutualOCPIVersion: 'OCPI bertsio elkarrekoa aldatu',
            handshakeDetails: 'Eskukada xehetasunak',
        },
        message: {
            enableConfirmMesage: 'Ziur gaitu nahi duzula?',
            disableConfirmMesage:
                'CPO hau desgaitzeak OCPI komunikazio guztia geldiaraziko du, aplikazioetan lotutako karga-kokalekuak ezkutatuko ditu, lotutako karga-estazioak "Ezabatuta" bezala markatuko ditu eta kokalekuak sarbide-taldeetatik kenduko ditu. Ziur jarraitu nahi duzula?',
        },
        insert: {
            header: 'Kudeatu karga-kokapenaren operadorea',
            placeholder: {
                name: 'Izena',
                party_id: 'Alderdiaren Id-a',
                country_code: 'Herrialde-kodea',
                ocpi: 'EMSP',
                version_url: 'CPO-ren URL bertsioa',
                token_a: 'A tokena',
                token_b: 'B tokena',
                token_c: 'C tokena',
                colour_code: 'Kolore-kodea',
                back_office_url: 'Back Office-ko URL-a',
                vat_type: 'BEZ mota',
                region: 'Hautatu eskualdea',
                vat: 'Hautatu BEZ-a',
                cpo_type: 'CPO Mota',
            },
            label: {
                name: 'Izena',
                party_id: 'Alderdiaren Id-a',
                country_code: 'Herrialde-kodea',
                ocpi: 'EMSP',
                version_url: 'Bertsioaren URL-a',
                token_a: 'A tokena',
                token_b: 'B tokena',
                token_c: 'C tokena',
                locationGroup: 'Taldearen kokapena',
                rfidDriverTokens: 'Gidariaren RFID tokenak bakarrik partekatu',
                colour_code: 'Kolore-kodea',
                back_office_url: 'Back Office-ko URL-a',
                vat_type: 'BEZ mota',
                disableLocationPatchPutRemovals: 'Desgaitu PATCH/PUT kokapenak kentzea',
                enableAutoMaxPowerCalculation: 'Gaitu potentzia maximoaren kalkulu automatikoa',
                mutual_ocpi_version: 'Elkarrekiko OCPI bertsioa',
                externalCPO: 'Lotutako eskualdea',
                is_external: '##COMPANY_BRAND_NAME## Nazioarteko CPO-a',
                defaultVat: 'BEZ lehenetsia (Gainjarri)',
                gmbAccountID: 'GMB Kontuaren ID-a',
                cpo_type: 'CPO Mota',
            },
            errors: {
                common: 'Zerbait ez da ongi atera, saiatu berriro arren.',
                name: {
                    valid: 'Sartu baliozko CPO izen bat',
                },
                party_id: {
                    valid: 'Sartu baliozko Alderdiaren Id bat',
                },
                country_code: {
                    valid: 'Sartu baliozko herrialde-kode bat',
                },
                version_url: {
                    url: 'Bertsioaren URL-ak baliozko URL bat izan behar du',
                },
                colour_code: {
                    valid: 'Sartu baliozko kolore-kode bat',
                },
                back_office_url: {
                    url: 'Back Officeko URL-ak baliozko URL bat izan behar du',
                },
            },
        },
        versionEndpoints: {
            header: 'Bertsioaren muturrak',
            label: {
                version: 'Bertsioa',
                identifier: 'Identifikatzailea',
                role: 'Betekizuna',
                url: 'URL-a',
                last_executed: 'Azken sinkronizazioa egindako azken data',
            },
        },
        modal: {
            message:
                'CPO hau nazioarteko ##COMPANY_BRAND_NAME## gisa ari zara markatzen, CPO kokapen horiek eskuz gehitu behar dituzu sarbide publikoko taldean',
            okButton: 'Ados',
        },
        performHandshakeModal: {
            handshakeHeader: 'Eskukada egin',
            reHandshakeHeader: 'Berriz eskukatu',
            label: {
                mutual_ocpi_version: 'OCPI bertsio elkarrekoa',
                version_url: 'Bertsioaren URL helbidea',
                handshake_token: 'Eskukada tokena',
            },
            placeholder: {
                mutual_ocpi_version: 'OCPI bertsio elkarrekoa',
                version_url: 'Bertsioaren URL helbidea',
                handshake_token: 'Eskukada tokena',
            },
            button: {
                cancel: 'Ezeztatu',
                generateHandshakeToken: 'Eskukada tokena sortu',
                confirm: 'Baieztatu',
                connect: 'Konektatu',
                reconnect: 'Berriro konektatu',
            },
            confirmationModal: {
                header: 'Eskukada egin',
                rehandshakeMessage:
                    'CPO kredentzialak aldatuko dira berriz eskukatu ondoren. Ziur zaude berriz eskukatze jarraitzeko?',
                tokenGeneratedMessage:
                    'Eskukada tokena CPOrentzat jada sortu da. Token hori CPOri eman eta CPOk EMSPrekin eskukada bat egitea saiatu bada, huts egin dezake. Ziur zaude berriz eskukatze jarraitzeko?',
            },
            cpoAuthTokenMessage: 'Hemen erakusten den balio lehenetsia CPO Auth Token da',
        },
        generateHandshakeTokenModal: {
            header: 'Eskukada tokena sortu',
            reGenerateTokenHeader: 'Eskukada tokena berriro sortu',
            label: {
                handshakeToken: 'Eskukada tokena',
                emsp_auth_token: 'EMSP baimenkortze tokena',
                emspVersionURL: 'EMSP bertsioaren URLa',
            },
            Placeholder: {
                handshakeToken: 'Eskukada tokena',
                emsp_auth_token: 'EMSP baimenkortze tokena',
            },
            button: {
                save: 'Gorde',
                copyToClipboard: 'Arraiolan kopiatu',
                generateToken: 'Sortu',
                reGenerateToken: 'Berriro sortu',
                confirm: 'Baieztatu',
                cancel: 'Ezeztatu',
            },
            copyToClipboard: {
                success: 'Tokena arraiolan kopiatuta',
                failed: 'Tokena kɔpiatzean huts egin du',
            },
            confirmationModal: {
                confirmationMessage:
                    'Eskukada token zaharra CPOri ematen bada, huts egin dezake CPOk eskukadarentzat erabiltzen saiatzen bada. Ziur zaude token berria gordetzeko?',
                header: 'Tokena gorde',
            },
            emspAuthTokenMessage: 'Hemen erakusten den balio lehenetsia EMSP Auth Token da',
        },
        changeMutualOCPIVersionModal: {
            header: 'OCPI bertsio elkarrekoa aldatu',
            label: {
                mutualOCPIVersion: 'OCPI bertsio elkarrekoa',
            },
            button: {
                save: 'Gorde',
                cancel: 'Ezeztatu',
                confirm: 'Baieztatu',
            },
            confirmationModal: {
                confirmationMessage: 'Ziur zaude OCPI bertsio elkarrekoa eguneratu nahi duzula?',
            },
        },
        handshakeDetailsModal: {
            header: 'Eskukada xehetasunak',
            label: {
                version_url: 'Bertsioaren URL helbidea',
                handshakeToken: 'Eskukada tokena',
                emspAuthToken: 'EMSP baimenkortze tokena',
                cpoAuthToken: 'CPO baimenkortze tokena',
            },
        },
    },
    CPOInternalTransfers: {
        title: 'Barne-transferentziak: ##COMPANY_BRAND_NAME## - eMobility Zerbitzuaren Plataforma',
        header: 'Barne-transferentziak',
        transferDetailTitle:
            'Transferentziaren xehetasunak: ##COMPANY_BRAND_NAME## - eMobility Zerbitzuaren Plataforma',
        transferDetailHeader: 'Transferentziaren xehetasunak',
        label: {
            transfer_id: 'Transferentziaren ID-a',
            gross_value: 'Balio gordina',
            created_date: 'Noiz sortua',
            action: 'Ekintza',
            transferNumber: 'Transferentziaren zenbakia',
            transferDate: 'Transferentziaren data',
            transaction: 'Transakzioaren ID-a',
            transactionStartDate: 'Transakzioaren hasiera-data',
            transactionEndDate: 'Transakzioaren bukaera-data',
            publicCardId: 'Txartel publikoaren ID-a',
            driverAccountId: 'Gidariaren kontuaren ID-a',
            driverName: 'Gidariaren/Ibilgailuaren Zenb.',
            stationId: 'Geltokiaren ID-a',
            stationName: 'Geltokiaren izena',
            stationAddress: 'Geltokiaren helbidea',
            kwh: 'kWh',
            price_per_kwh: 'Prezioa/kWh',
            disable: 'DESGAITUTA',
        },
        placeholder: {
            start_date: 'Hasiera-data',
            end_date: 'Bukaera-data',
            status: 'Egoera',
            cpo: 'Hautatu CPO-a',
        },
        button: {
            search: 'Bilatu',
            reset: 'Berrezarri',
            action: 'Ekintza',
        },
        errors: {
            cpo: {
                required: 'Mesedez hautatu CPO-a',
            },
        },
    },
    PSPSetting: {
        title: 'Ordainketa-zerbitzuaren hornitzaileak: ##COMPANY_BRAND_NAME## - eMobility Zerbitzuaren Plataforma',
        header: 'Ordainketa-zerbitzuaren hornitzaileak',
        placeholder: {
            name: 'Izena',
            status: 'Hautatu egoera',
            type: 'Hautatu mota',
        },
        label: {
            name: 'Izena',
            code: 'Kodea',
            type: 'Mota',
            description: 'Deskribapena',
            store_name: 'Denda',
            department_name: 'Departamentua',
            created_date: 'Noiz sortua',
            status: 'Egoera',
            action: 'Ekintza',
            enabled: 'Gaituta',
            disabled: 'Desgaituta',
            details: 'Xehetasunak',
            key: 'Gakoa',
            value: 'Balioa',
        },
        button: {
            search: 'Bilatu',
            cancel: 'Ezeztatu',
            add: 'Gehitu',
            save: 'Gorde',
            edit: 'Editatu',
            reset: 'Berrezarri',
            yes: 'Bai',
            no: 'Ez',
            enabled: 'Gaitu',
            disabled: 'Desgaitu',
            action: 'Ekintza',
            back: 'Atzera',
            enable: 'Gaitu',
            disable: 'Desgaitu',
            getCredentials: 'Lortu kredentzialak',
            delete: 'Ezabatu',
        },
        message: {
            enableConfirmMesage: 'Ziur gaitu nahi duzula?',
            disableConfirmMesage: 'Ziur desgaitu nahi duzula?',
        },
        insert: {
            header: 'Kudeatu ordainketa-zerbitzuaren hornitzailea',
            placeholder: {
                name: 'Izena',
                type: 'Mota',
                description: 'Deskribapena',
                store_name: 'Dendaren izena',
                store_id: 'Dendaren Id-a',
                merchant_name: 'Merkatariaren izena',
                merchant_id: 'Merkatariaren Id-a',
                department_name: 'Departamentuaren izena',
                department_id: 'Departamentuaren Id-a',
                signature_key: 'Sinadura gakoa',
                secret_key: 'Ezkutuko gakoa',
                user_name: 'Erabiltzaile-izena',
                password: 'Pasahitza',
                data: 'Datuak',
                category: 'Kategoria',
                url: 'URL-a',
                acquirerId: 'Eroslearen Id-a',
                firstName: 'Izena',
                lastName: 'Abizena',
                houseName: 'Etxearen izena',
                postcode: 'Posta kodea',
                donationProviderType: 'Dohaintzaren hornitzaile mota',
                isGiftAid: 'Oparitutako laguntza da',
                donationStoreId: 'Dohaintza Dendaren Id-a',
                donationMerchantNumber: 'Dohaintzaren merkatariaren zenbakia',
                clientID: 'Bezeroaren ID-a',
                clientSecret: 'Bezero sekretua',
                terminalID: 'Terminalaren ID-a',
                enableCardRefunds: 'Gaitu txartel itzulerak',
                enableCardVerification: 'Gaitu txartel egiaztapena',
                enableCharity: 'Gaitu karitatea',
            },
            label: {
                name: 'Izena',
                type: 'Mota',
                firstName: 'Izena',
                lastName: 'Abizena',
                houseName: 'Etxearen izena',
                postcode: 'Posta kodea',
                donationProviderType: 'Dohaintzaren hornitzaile mota',
                isGiftAid: 'Oparitutako laguntza da',
                donationStoreId: 'Dohaintza Dendaren Id-a',
                donationMerchantNumber: 'Dohaintzaren merkatariaren zenbakia',
                code: 'Kodea',
                description: 'Deskribapena',
                store_name: 'Dendaren izena',
                store_id: 'Dendaren Id-a',
                merchant_name: 'Merkatariaren izena',
                merchant_id: 'Merkatariaren Id-a',
                department_name: 'Departamentuaren izena',
                department_id: 'Departamentuaren Id-a',
                signature_key: 'Sinadura gakoa',
                secret_key: 'Ezkutuko gakoa',
                user_name: 'Erabiltzaile-izena',
                password: 'Pasahitza',
                data: 'Datuak',
                action_urls: 'Ekintzaren URL-ak',
                category: 'Kategoria',
                url: 'URL-a',
                acquirerId: 'Eroslearen Id-a',
                clientID: 'Bezeroaren ID-a',
                clientSecret: 'Bezero sekretua',
                terminalID: 'Terminalaren ID-a',
                enableCardRefunds: 'Gaitu txartel itzulerak',
                enableCardVerification: 'Gaitu txartel egiaztapena',
                enableCharity: 'Gaitu karitatea',
                mobileMerchantId: 'Merkatari ibiltariaren Id-a',
                mobileMerchantPassword: 'Merkatari ibiltariaren pasahitza',
                enableIncrementalAuthorizations: 'Baimen Inkrementalak Gaitu',
                excludedCardsForIncrementalAuthorizations: 'Baimen inkrementaletarako baztertutako txartelak',
            },
            errors: {
                common: 'Zerbait ez da ongi atera, saiatu berriro arren.',
                name: {
                    valid: 'Sartu baliozko izena',
                },
                code: {
                    valid: 'Sartu baliozko kodea',
                },
                url: {
                    valid: 'URL-ak baliozko URL bat izan behar du',
                },
                DatatransSupportCards: {
                    valid: 'Mesedez, idatzi DatatransSupportCards-en baliozko balioa',
                },
            },
        },
    },
    RFIDCards: {
        title: 'RFID txartelak: ##COMPANY_BRAND_NAME## - eMobility Zerbitzuaren Plataforma',
        header: 'RFID txartelak',
        placeholder: {
            name: 'Gidariaren izena / E-posta / Erakundea',
            manufacturer: 'Fabrikatzailea',
            part_id: 'Alderdiaren Id-a',
            public_card_id: 'Txartel publikoaren Id-a',
            status: 'Hautatu egoera',
            mifare_uid: 'Mifare UID',
        },
        label: {
            name: 'Honi esleitua',
            email_vehicle: 'Lotutako kontua',
            manufacturer: 'Fabrikatzailea',
            part_id: 'Alderdiaren Id-a',
            public_card_id: 'Txartel publikoaren Id-a',
            private_card_id: 'Txartel pribatuaren Id-a',
            created_date: 'Noiz sortua',
            status: 'Egoera',
            action: 'Ekintza',
            enabled: 'Gaituta',
            disabled: 'Desgaituta',
            delete: 'Ezabatu',
            deAllocate: 'Kendu elkartea',
            view: 'Ikus xehetasunak',
            allocateCardToOrganisation: 'Esleitu txartel-multzoa Erakundeari',
            mifare_uid: 'MIFARE UID',
            reinstate: 'Berrezarri txartela',
            card_type: 'Txartel mota',
            removeBulkAssociation: 'Kendu RFID txartelen multzoko elkarketa',
        },
        button: {
            search: 'Bilatu',
            cancel: 'Ezeztatu',
            add: 'Gehitu',
            addBulk: 'Gehitu txartel-multzoa fabrikatzeko',
            assing: 'Esleitu RFFID txartelak',
            allocateRFIDCard: 'Esleitu RFID txartela',
            import: 'Inportatu fabrikatzeko fitxategia',
            export: 'Esportatu fabrikatzeko fitxategia',
            save: 'Gorde',
            edit: 'Editatu',
            reset: 'Berrezarri',
            yes: 'Bai',
            no: 'Ez',
            enabled: 'Gaitu',
            disabled: 'Desgaitu',
            action: 'Ekintza',
            back: 'Atzera',
            enable: 'Gaitu',
            disable: 'Desgaitu',
            getCredentials: 'Lortu kredentzialak',
            delete: 'Ezabatu',
            deAllocate: 'Kendu elkartea',
            view: 'Ikus xehetasunak',
            reinstate: 'Berrezarri txartela',
            forceCPOUpdate: 'Behartu CPO eguneraketa',
        },
        errors: {
            export: {
                notSeletedCards: 'Mesedez hautatu Esportatzeko txartelen zain',
            },
        },
        message: {
            enableConfirmMesage: 'Ziur gaitu nahi duzula?',
            disableConfirmMesage: 'Ziur desgaitu nahi duzula?',
            deleteConfirmMesage: 'Ziur ezabatu nahi duzula?',
            deAllocateConfirmMesage: 'Ziur kontu batekin lotutako RFID txartela kendu nahi duzula?',
            reinstateConfirmMessage: 'Ziur RFID txartel hori berrezarri nahi duzula?',
            forceCPOUpdateConfirmMessage: 'Ziur eguneratze-tokena behartu nahi duzula CPO sisteman?',
        },
        insert: {
            header: 'Kudeatu RFID txartela',
            placeholder: {
                manufacturer: 'Fabrikatzailearen izena',
                part_id: 'Alderdiaren Id-a',
                public_card_id: 'Txartel publikoaren Id-a',
                private_card_id: 'Txartel pribatuaren Id-a',
                mifare_uid: 'Mifare UID',
                card_type: 'Txartel mota',
            },
            label: {
                manufacturer: 'Fabrikatzailea',
                part_id: 'Alderdiaren Id-a',
                public_card_id: 'Txartel publikoaren Id-a',
                private_card_id: 'Txartel pribatuaren Id-a',
                mifare_uid: 'Mifare UID',
                card_type: 'Txartel mota',
            },
            errors: {
                common: 'Zerbait ez da ongi atera, saiatu berriro arren.',
                name: {
                    valid: 'Sartu baliozko izena',
                },
                code: {
                    valid: 'Sartu baliozko kodea',
                },
                url: {
                    valid: 'URL-ak baliozko URL bat izan behar du',
                },
            },
        },
        bulkCards: {
            header: 'Gehitu txartel-multzoa',
            placeholder: {
                manufacturer: 'Fabrikatzailearen izena',
                part_id: 'Alderdiaren Id-a',
                no_of_cards: '100 txartel',
                cardType: 'Hautatu txartel mota',
            },
            label: {
                manufacturer: 'Fabrikatzailearen izena',
                part_id: 'Alderdiaren Id-a',
                no_of_cards: 'Txartel kop.',
                cardType: 'Txartel mota',
            },
            button: {
                yes: 'Sortu txartelak',
                no: 'Ezeztatu',
            },
            errors: {
                no_of_cards: {
                    min: 'Txartel kopuruak ezin du 1 baino txikiagoa izan',
                },
            },
        },
        assignCards: {
            header: 'Esleitu RFFID txartelak',
            header2: 'X txartel hautatu dituzu.',
            selectedCard: 'Txartel 1 hautatu duzu.',
            placeholder: {
                manufacturer: 'Fabrikatzailearen izena',
                part_id: 'Alderdiaren Id-a',
                no_of_cards: '100 txartel',
            },
            label: {
                driver: 'Gidaria',
                organisation: 'Erakundea',
                no_of_cards: 'Txartel kop.',
            },
            button: {
                yes: 'Esleitu',
                no: 'Ezeztatu',
            },
            form: {
                type: {
                    driver: 'Gidaria',
                    organisation: 'Erakundea',
                },
                driver: 'Gidaria',
                organisation: 'Erakundea',
                placeholder: {
                    driver: 'Hautatu gidaria',
                    organisation: 'Hautatu erakundea',
                },
            },
            errors: {
                notSeletedCards: 'Hautatu txartel erabilgarriak',
            },
        },
        disableCards: {
            header: 'Desgaitu',
            header2: 'Ziur desgaitu nahi duzula?',
            placeholder: {
                comment: 'Sartu iruzkina',
            },
            label: {
                comment: 'Iruzkina',
            },
            button: {
                yes: 'Bai',
                no: 'Ez',
            },
        },
        allocateCards: {
            header: 'Esleitu RFID txartelak',
            placeholder: {
                file: 'Hautatu CSV fitxategia',
                selectOrganisation: 'Hautatu erakundea',
            },
            label: {
                file: 'CSV Fitxategia',
                organisation: 'Erakundea',
                mifareUID: 'MifareÂ UID',
                publicCardID: 'Txartel publikoaren ID-a',
                clickHere: 'Sakatu hemen',
                downloadTemplate: 'txantiloia deskargatzeko',
            },
            button: {
                allocate: 'Esleitu',
                cancel: 'Ezeztatu',
            },
            errors: {
                file: {
                    fileType: "'.csv' luzapeneko fitxategia igo daiteke.",
                },
            },
        },
        removeAssociation: {
            header: 'Kendu RFID txartelen multzoko elkarketa',
            placeholder: {
                file: 'Hautatu CSV fitxategia',
            },
            label: {
                file: 'CSV Fitxategia',
                clickHere: 'Sakatu hemen',
                downloadTemplate: 'txantiloia deskargatzeko',
            },
            button: {
                save: 'Gorde',
                cancel: 'Ezeztatu',
            },
            errors: {
                file: {
                    fileType: "'.csv' luzapeneko fitxategia igo daiteke.",
                },
                maxRFIDRecordsReached:
                    'Zuk igotako CSV fitxategia RFID txartel publikoen txartel publikoko ID erregistroen 10.000ko gehieneko kopurura iritsi da. Mesedez, murriztu scv fitxategian RFID txartelen txartel publikoko ID erregistroak.',
            },
        },
        importCards: {
            header: 'Inportatu RFID txartelak',
            placeholder: {
                file: 'Hautatu CSV fitxategia',
            },
            label: {
                file: 'CSV Fitxategia',
            },
            button: {
                yes: 'Inportatu',
                no: 'Ezeztatu',
            },
            errors: {
                file: {
                    fileType: "'.csv' luzapeneko fitxategia igo daiteke.",
                },
            },
        },
        importCardsDetails: {
            header: 'RFID txartelen inportazio xehetasunak',
            label: {
                unSuccessfullImport: 'Ondorengo txartelak ezin dira inportatu',
                successfullImport: 'Ondorengo txartelak ongi inportatu dira',
                failerReason: 'Huts egiteko arrazoia',
                publicCardId: 'Txartel publikoaren IDa',
            },
            message: {
                defualtErrorMessage: 'Arazo bat dago ondorengo txartelak inportatzean.',
            },
        },
        rfidDetails: {
            label: {
                event_date: 'Ekitaldiaren data',
                chargeLocation: 'Kargaren kokapena',
                charge_station_name: 'Geltokiaren izena',
                response_status: 'Erantzunen egoera',
            },
        },
    },
    referralPromotion: {
        title: 'Igorpen-sustapena: ##COMPANY_BRAND_NAME## - eMobility Zerbitzuaren Plataforma',
        header: 'Igorpen-sustapenak',
        manageReferralPromotion: 'Kudeatu bazkideen sustapena',
        label: {
            name: 'Izena',
            code: 'Kodea',
            minCharge: 'Karga min',
            maxLimit: 'Muga max',
            maxRefreeLimit: 'Bitartekariaren muga max',
            createdDate: 'Noiz sortua',
            status: 'Egoera',
            action: 'Ekintza',
            disabled: 'Desgaituta',
            enabled: 'Gaituta',
            delete: 'Ezabatu',
            enable: 'Gaitu',
            disable: 'Desgaitu',
            promotionCode: 'Sustapen-kodea',
            description: 'Deskribapena',
            maxReferralLimit: 'Gehieneko igorpen-muga',
            minChargeValue: 'Kargaren balio minimoa',
            refereeBonus: 'Bitartekariaren hobaria',
            referrerBonus: 'Igorlearen hobaria',
        },
        button: {
            search: 'Bilatu',
            back: 'Atzera',
            add: 'Gehitu',
            reset: 'Berrezarri',
            edit: 'Editatu',
            delete: 'Ezabatu',
            enable: 'Gaitu',
            disable: 'Desgaitu',
            save: 'Gorde',
            cancel: 'Ezeztatu',
            action: 'Ekintza',
        },
        message: {
            deleteConfirmMesage: 'Ziur ezabatu nahi duzula?',
            enableConfirmMesage: 'Ziur gaitu nahi duzula?',
            disableConfirmMesage: 'Ziur desgaitu nahi duzula?',
        },
        placeholder: {
            name: 'Izena',
            code: 'Kodea',
            selectPromotion: 'Hautatu sustapena',
            selectStatus: 'Hautatu egoera',
            promotionCode: 'Sustapen-kodea',
            description: 'Deskribapena',
            maxReferralLimit: 'Gehieneko igorpen-muga',
            minChargeValue: 'Kargaren balio minimoa',
            refereeBonus: 'Bitartekariaren hobaria',
            referrerBonus: 'Igorlearen hobaria',
        },
        errors: {
            name: {
                valid: 'Sartu baliozko sustapen-izen bat',
            },
            promotionCode: {
                valid: 'Sartu baliozko sustapen-kode bat',
            },
            maxReferralLimit: {
                moreThan: 'Gehieneko igorpen-mugak zero baino handiagoa izan behar du',
            },
            referrerBonus: {
                max: 'Erreferentziaren Bonuaren balioa ezin da ##MAX_REFERRAL_BONUS## baino handiagoa izan',
            },
            refereeBonus: {
                max: 'Erreferituaren Bonuaren balioa ezin da ##MAX_REFERRAL_BONUS## baino handiagoa izan',
            },
        },
    },
    termsConditions: {
        title: 'Terminoak eta baldintzak: ##COMPANY_BRAND_NAME## - eMobility Zerbitzuaren Plataforma',
        header: 'Terminoak eta baldintzak',
        manageTermsConditions: 'Kudeatu Terminoak eta baldintzak',
        label: {
            enabled: 'Gaituta',
            disabled: 'Desgaituta',
            name: 'Izena',
            description: 'Deskribapena',
            apply_to: 'Aplikatu honi',
            mandatory_for_user: 'Nahitaezkoa erabiltzailearentzat',
            status: 'Egoera',
            delete: 'Ezabatu',
            content: 'Gidalerroen edukia',
            yes: 'Bai',
            no: 'Ez',
            draft: 'Zirriborroa',
            published: 'Argitaratua',
        },
        placeholder: {
            name: 'Izena',
            description: 'Deskribapena',
            select: {
                apply_to: 'Aplikatu honi',
                status: 'Hautatu egoera',
            },
        },
        columns: {
            name: 'Izena',
            description: 'Deskribapena',
            applyto: 'Aplikatu honi',
            mandatory_for_user: 'Nahitaezkoa',
            status: 'Egoera',
            action: 'Ekintza',
            modified_date: 'Noiz aldatua',
        },
        button: {
            search: 'Bilatu',
            reset: 'Berrezarri',
            action: 'Ekintza',
            edit: 'Editatu',
            add: 'Gehitu',
            back: 'Atzera',
            save: 'Gorde',
            cancel: 'Ezeztatu',
            delete: 'Ezabatu',
            yes: 'Bai',
            no: 'Ez',
        },
        errors: {
            name: {
                valid: 'Sartu baliozko izena',
            },
            invalidFormat: 'Igo baliozko formatuko irudi bat',
            common: 'Zerbait ez da ongi atera, saiatu berriro arren.',
        },
        message: {
            deleteConfirmMesage: 'Ziur ezabatu nahi duzula?',
        },
    },
    rewardPromotion: {
        title: 'Sarien sustapena: ##COMPANY_BRAND_NAME## - eMobility Zerbitzuaren Plataforma',
        header: 'IV sarien sustapenak',
        manageRewardPromotion: 'Kudeatu IV sarien sustapena',
        label: {
            name: 'Izena',
            code: 'Kodea',
            valuesPerkwh: 'Balioak/kWh',
            monetoryValue: 'Diruzko balioa',
            redemptionBlock: 'Itzulera-blokea',
            createdDate: 'Noiz sortua',
            status: 'Egoera',
            enabled: 'Gaituta',
            disabled: 'Desgaituta',
            action: 'Ekintza',
            delete: 'Ezabatu',
            enable: 'Gaitu',
            disable: 'Desgaitu',
            promotionCode: 'Sustapen-kodea',
            description: 'Deskribapena',
            expired: 'Iraungia',
            locationApplicable: 'Karga-kokapen aplikagarria',
            voltsPerkwh: 'Volt/kWh',
            confirmation: 'Berrespena',
        },
        button: {
            search: 'Bilatu',
            cancel: 'Ezeztatu',
            save: 'Gorde',
            add: 'Gehitu',
            edit: 'Editatu',
            reset: 'Berrezarri',
            delete: 'Ezabatu',
            enable: 'Gaitu',
            disable: 'Desgaitu',
            action: 'Ekintza',
            back: 'Atzera',
        },
        message: {
            deleteConfirmMesage: 'Ziur ezabatu nahi duzula?',
            enableConfirmMesage: 'Ziur gaitu nahi duzula?',
            disableConfirmMesage: 'Ziur desgaitu nahi duzula?',
            uncheckConfirmMesage:
                'Lauki honetako marka kentzean, sustapen honekin lotutako kargaren kokapen guztiak kenduko dira. Ziur hau kendu nahi duzula?',
        },
        placeholder: {
            name: 'Izena',
            code: 'Kodea',
            selectPromotion: 'Hautatu sustapena',
            selectStatus: 'Hautatu egoera',
            locationApplicable: 'Karga-kokapen aplikagarria',
            voltsPerkwh: 'Volt/kWh',
        },
        errors: {
            name: {
                valid: 'Sartu baliozko sustapen-izen bat',
            },
            promotionCode: {
                valid: 'Sartu baliozko sustapen-kode bat',
            },
            monetoryValue: {
                moreThan: 'Diruzko balioak zero baino handiagoa izan behar du',
                lessThan: 'Diru-balioak 99999,99 baino txikiagoa edo berdina izan behar du',
                typeError: 'Sartu baliozko diruzko balio bat',
            },
            redemptionPointBlock: {
                moreThan: 'Itzulera-blokeak zero baino handiagoa izan behar du',
            },
            valuePerKwh: {
                moreThan: 'Balioak zero baino handiagoa izan behar du',
            },
        },
    },
    amenitys: {
        title: 'Instalazioak: ##COMPANY_BRAND_NAME## - eMobility Zerbitzuaren Plataforma',
        header: 'Instalazioak',
        manageamenitys: 'Kudeatu instalazioak',
        chargeStationsList: 'Kargatzeko geltokiak',
        chargeLocation: 'Kargaren kokapenak',
        amenityTranslationNote:
            'Sartu instalazioaren xehetasunak administrazioko erabiltzaile/gidarientzat eskualde bakoitzari dagokion hizkuntzan. Hizkuntza zehatz batentzat xehetasunik eman ez denean, sistemak xehetasun lehenetsiak bistaratuko ditu.',
        label: {
            enabled: 'Gaituta',
            disabled: 'Desgaituta',
            name: 'Izena',
            imageUpload: 'Ikonoa (34 X 34)',
            language: 'Hizkuntza',
            image: 'Ikonoa',
            description: 'Deskribapena',
            default_search: 'Bilaketa lehenetsia',
            status: 'Egoera',
            delete: 'Ezabatu',
            csvFile: 'CSV Fitxategia',
            importAmenityHeader: 'Inportatu instalazioak',
            chargeLocation: {
                name: 'Izena',
                type: 'Mota',
                address: 'Helbidea',
                city: 'Hiria',
                postal_code: 'Posta kodea',
                modifiedDate: 'Noiz aldatua',
                action: 'Ekintza',
            },
            charge_station_name: 'Charge_Station_Name',
            charge_point: 'Charge_Point',
            charge_location_name: 'Charge_Location_Name',
            latitude: 'Latitudea',
            longitude: 'Longitudea',
            location_address: 'Location_Address',
            amenities: 'Instalazioak',
            amenity_type: 'Instalazio mota',
        },
        placeholder: {
            name: 'Izena',
            description: 'Deskribapena',
            file: 'Hautatu CSV fitxategia',
            select: {
                status: 'Hautatu egoera',
                amenity_type: 'Hautatu mota',
            },
        },
        columns: {
            name: 'Izena',
            description: 'Deskribapena',
            status: 'Egoera',
            action: 'Ekintza',
            amenity_type: 'Mota',
        },
        button: {
            search: 'Bilatu',
            reset: 'Berrezarri',
            action: 'Ekintza',
            edit: 'Editatu',
            add: 'Gehitu',
            back: 'Atzera',
            save: 'Gorde',
            cancel: 'Ezeztatu',
            delete: 'Ezabatu',
            yes: 'Bai',
            no: 'Ez',
            disable: 'Desgaitu',
            enable: 'Gaitu',
            import: 'Inportatu',
        },
        errors: {
            common: 'Zerbait ez da ongi atera, saiatu berriro arren.',
            name: {
                valid: 'Sartu baliozko izen bat.',
            },
            image: {
                fileType: "'.jpg', '.png', '.svg', '.jpeg' luzapeneko fitxategiak karga daitezke.",
                dimensions: 'Ikonoaren neurria 34 X 34 izan behar da',
                required: 'Ikonoa nahitaez jarri behar da',
            },
        },
        message: {
            deleteConfirmMesage: 'Ziur ezabatu nahi duzula?',
            enableConfirmMesage: 'Ziur gaitu nahi duzula?',
            disableConfirmMesage: 'Ziur desgaitu nahi duzula?',
        },
    },
    vehicle: {
        title: 'Ibilgailua: ##COMPANY_BRAND_NAME## - eMobility Zerbitzuaren Plataforma',
        header: 'Ibilgailuak',
        columns: {
            name: 'Izena',
            registerNo: 'Erregistro zenb.',
            make: 'Marka',
            model: 'Modeloa',
            chargeType: 'Karga mota',
            batteryCapacity: 'Bateriaren edukiera',
            consumption: 'Kontsumoa',
        },
        placeholder: {
            nameEmail: 'Izena / e-posta',
            makeModelRegistrationNo: 'Marka / Modeloa / Erregistro zenb.',
        },
        button: {
            search: 'Bilatu',
            reset: 'Berrezarri',
        },
    },
    incompleteSessions: {
        title: 'Burutu gabeko saioak: ##COMPANY_BRAND_NAME## - eMobility Zerbitzuaren Plataforma',
        header: 'Burutu gabeko saioak',
        placeholder: {
            nameOrEmail: 'Izena / e-posta',
            locationOrStation: 'Kokapena / Geltokia',
            startDate: 'Hasiera-data',
            endDate: 'Bukaera-data',
            status: 'Hautatu egoera',
            comment: 'Idatzi zure iruzkinak',
        },
        label: {
            invalid: 'Baliogabea',
            generateCDR: 'CDR sortu',
            totalEnergy: 'Energia guztira',
            totalCost: 'Kostuak guztira',
            comment: 'Idatzi zure iruzkinak',
            cancelCDR: 'Ezeztatu CDR-a',
        },
        columns: {
            name: 'Izena',
            location: 'Kokapena',
            sessionId: 'Saioaren Id-a',
            startDate: 'Hasiera-data',
            modifiedDate: 'Noiz aldatua',
            time: 'Denbora',
            energy: 'Energia </br> (kWh)',
            cost: 'Kostua',
            status: 'Egoera',
            action: 'Ekintza',
        },
        button: {
            action: 'Ekintza',
            generateCDR: 'CDR-a sortu',
            search: 'Bilatu',
            reset: 'Berrezarri',
            save: 'Gorde',
            cancel: 'Ezeztatu',
            yes: 'Bai',
            no: 'Ez',
            cancelCDR: 'Ezeztatu CDR-a',
        },
        error: {
            max: '250 karaktere erabil daitezke gehienez',
        },
        message: {
            cancelCDRMessage: 'Ziur saio hau bertan behera utzi nahi duzula?',
            cancelBulkCDRMessage: 'Ziur saio hau bertan behera utzi nahi duzula hautatutako erregistroentzat?',
            selectCDR: 'Mesedez hautatu burutu gabeko saioak',
        },
    },
    ocpiSessions: {
        title: 'OCPI saioak: ##COMPANY_BRAND_NAME## - eMobility Zerbitzuaren Plataforma',
        header: 'Saioak',
        placeholder: {
            nameOrEmail: 'Izena / e-posta',
            locationOrStation: 'Kokapena / Geltokia',
            startDate: 'Hasiera-data',
            endDate: 'Bukaera-data',
            status: 'Hautatu egoera',
            comment: 'Idatzi zure iruzkinak',
        },
        columns: {
            name: 'Izena',
            location: 'Kokapena',
            sessionId: 'Saioaren Id-a',
            startDate: 'Hasiera-data',
            endDate: 'Bukaera-data',
            time: 'Denbora',
            energy: 'Energia </br> (kWh)',
            cost: 'Kostua',
            status: 'Egoera',
            action: 'Ekintza',
            vehicleNumber: 'Ibilgailuaren zenbakia',
        },
        button: {
            search: 'Bilatu',
            reset: 'Berrezarri',
            complete: 'Osatu',
        },
        label: {
            complete: 'Osatu',
            completeSessions: 'Karga-saio osoak',
        },
        message: {
            completeConfirmMessage: 'Karga-saioa osatu nahiko zenuke?',
            stopBulkSessionsMessage: 'Hautatutako karga-saioak osatu nahiko zenituzke?',
            selectSession: 'Hautatu karga-saioak',
        },
    },
    organisation: {
        title: 'Kudeatu erakundea: ##COMPANY_BRAND_NAME## - eMobility Zerbitzuaren Plataforma',
        header: 'Erakundea',
        manageOrganisation: 'Kudeatu erakundea',
        label: {
            name: 'Izena',
            description: 'Deskribapena',
            address: 'Helbidea',
            city: 'Hiria',
            county: 'Konderria',
            postal_code: 'Posta kodea',
            contact_person: 'Harremanetarako pertsona',
            email: 'Helbide elektronikoa',
            phone_number: 'Telefono-zenb.',
            payment_mode: 'Ordaintzeko modua',
            payment_schedule: 'Ordainketa-egutegia',
            user_group_ids: 'Erabiltzaile-taldeak',
            enabled: 'Gaituta',
            disabled: 'Desgaituta',
            amount: 'Kredituaren muga',
            po_number: 'PO zenbakia',
            finance_account_number: 'Finantza-kontuaren zenbakia',
            account_contact_email: 'Kontuaren harremanetarako helbide elektronikoa',
            remaining_credit: 'Gelditzen den kreditua (%)',
            remoteChargePassword: 'Urrutiko karga abiarazteko pasahitza',
            is_deleted: 'Ezabatu egin da',
            yes: 'Bai',
            deleted: 'Ezabatuta',
            dailySpendLimit: 'Egunean gastatutako muga',
            weeklySpendLimit: 'Astean gastatutako muga',
            monthlySpendLimit: 'Egutegiko hilabetean gastatutako muga',
            defaultSpendLimitGroup: 'Gastatutako muga talde lehenetsia',
            updateSpendLimitAssociation: 'Gastatutako muga talde elkartea',
            promotionUpdate: 'Sustapenaren eguneraketa',
            currentPromotion: 'Abian den sustapena',
            newPromotion: 'Sustapen berria',
        },
        placeholder: {
            name: 'Izena',
            name_or_email_or_contact_person: 'Izena/harremanetarako pertsona/helbide elektronikoa',
            description: 'Deskribapena',
            address: 'Helbidea',
            city: 'Hiria',
            county: 'Konderria',
            postal_code: 'Posta kodea',
            contact_person: 'Harremanetarako pertsona',
            email: 'Helbide elektronikoa',
            phone_number: 'Telefono-zenb.',
            select: {
                status: 'Hautatu egoera',
                payment_mode: 'Hautatu ordaintzeko modua',
                payment_schedule: 'Hautatu ordainketa-egutegia',
                user_group_ids: 'Hautatu erabiltzaile-taldeak',
            },
            amount: 'Kredituaren muga',
            po_number: 'PO zenbakia',
            finance_account_number: 'Finantza-kontuaren zenbakia',
            remaining_credit: 'Gelditzen den kreditua (%)',
            remoteChargePassword: 'Urrutiko karga abiarazteko pasahitza',
            enableSpendLimit: 'Gaitu gastatutako muga',
            defaultSpendLimitGroup: 'Hautatu Gastatutako muga talde lehenetsia',
            selectCurrentPromotion: 'Hautatu oraingo sustapenak',
            selectNewPromotion: 'Hautatu sustapen berria',
        },
        columns: {
            name: 'Izena',
            contact_Person: 'Harremanetarako pertsona',
            email: 'Helbide elektronikoa',
            payment_mode: 'Ordaintzeko modua',
            payment_schedule: 'Ordainketa-egutegia',
            created_date: 'Noiz sortua',
            status: 'Egoera',
            action: 'Ekintza',
            remote_charge_password: 'Urrutiko karga abiarazteko pasahitza',
            promotion: 'Sustapena',
        },
        button: {
            search: 'Bilatu',
            reset: 'Berrezarri',
            action: 'Ekintza',
            edit: 'Editatu',
            add: 'Gehitu',
            back: 'Atzera',
            save: 'Gorde',
            cancel: 'Ezeztatu',
            delete: 'Ezabatu',
            yes: 'Bai',
            no: 'Ez',
            enable: 'Gaitu',
            disable: 'Desgaitu',
            permission: 'API baimena',
            assignSpendLimitGroup: 'Esleitu gastatutako muga taldea',
        },
        errors: {
            name: {
                valid: 'Sartu taldearen baliozko izen bat',
            },
            contact_person: {
                valid: 'Sartu harremanetarako pertsona',
            },
            email: {
                required: 'Sartu helbide elektronikoa',
                email: 'Sartu baliozko helbide elektronikoa',
            },
            phoneNo: {
                required: 'Sartu telefono-zenbakia',
                match: 'Sartu baliozko telefono-zenbaki bat',
            },
            amount: {
                moreThan: 'Kantitateak 1etik gorakoa izan behar du',
                maxcredit: 'Kreditu-konturako gehienezko mugara iritsi da',
            },
            po_number: {
                valid: 'Sartu baliozko PO zenbaki bat',
            },
            finance_account_number: {
                valid: 'Sartu baliozko finantza-kontuaren zenbakia',
            },
            account_contact_email: {
                required: 'Sartu baliozko helbide elektroniko bat edo gehiago',
                maxLimit: 'Kontuaren harremanetarako helbide elektronikoko gehieneko mugara iritsi zara',
            },
            remaining_credit: {
                match: 'Sartu gelditzen den baliozko kreditu bat',
                maxCredit: 'Gelditzen den kredituaren gehieneko balioak ezin du 100 baino handiagoa izan',
                minCredit: 'Gelditzen den kredituaren gutxieneko balioak ezin du 0 baino txikiagoa izan',
            },
            value: {
                moreThan: 'Balioak 1etik gorakoa izan behar du',
                lessThan: 'Balioa 5000 edo txikiagoa izan behar da',
                number: 'Balioa zenbaki bat izan behar da',
                lessThanWeekly: 'Balioak asteko gastu-mugaren berdina edo txikiagoa izan behar du',
                lessThanMonthly: 'Balioak hileko gastu-mugaren berdina edo txikiagoa izan behar du',
            },
            spend_limit: {
                moreThan: 'Astean gastatutako mugak egunean gastatutako muga baino handiagoa izan behar du',
                lessThan: 'Egunean gastatutako mugak astean behin gastatutako muga baino txikiagoa izan behar du',
            },
            address: '10 karaktere behar dira gutxienez',
            addressValid: 'Sartu baliozko helbide bat',
            user_group: {
                required: 'Aukeratu erabiltzaile-talde bat gutxienez',
            },
        },
        message: {
            deleteConfirmMesage: 'Ziur ezabatu nahi duzula?',
            enableConfirmMesage: 'Ziur gaitu nahi duzula?',
            disableConfirmMesage: 'Ziur desgaitu nahi duzula?',
            assignAllDriversToDefaultGroup:
                'Erakunde honetako gidari guztiak gastatutako muga talde lehenetsian sartu nahi al dituzu?',
            updatePromotionConfirmMessage: 'Ziur zaude sustapena eguneratu nahi duzula hautatutako erakundearentzat?',
            selectOneRecord: 'Hautatu erakunde bat gutxienez sustapena eguneratzeko',
            promotionAssignMessage: 'Sustapen berria ezarriko zaie honako erakunde hauei:',
        },
        permission: {
            header: 'API baimena',
            label: {
                description: 'Deskribapena',
                action: 'API-ak',
            },
        },
    },
    transactionLogs: {
        title: 'Transakzio-erregistroak: ##COMPANY_BRAND_NAME## - eMobility Zerbitzuaren Plataforma',
        header: 'Transakzio-erregistroak',
        placeholder: {
            page: 'Hautatu orrialdea',
            email: 'Helbide elektronikoa',
            startDate: 'Hasiera-data',
            endDate: 'Bukaera-data',
            fieldName: 'Eremuaren izena',
            content: 'Edukia',
        },
        button: {
            search: 'Bilatu',
            reset: 'Berrezarri',
        },
        label: {
            tableName: 'Taularen izena',
            fieldName: 'Eremuaren izena',
            oldValue: 'Aurreko balioa',
            newValue: 'Balio berria',
            user: 'Erabiltzailea',
            logDate: 'Erregistroaren data',
            action: 'Ekintza',
            goToPage: 'Joan orri honetara',
        },
    },
    organisationAccountBalance: {
        title: 'Erakundearen kontuko saldoa: ##COMPANY_BRAND_NAME## - eMobility Zerbitzuaren Plataforma',
        header: 'Erakundearen kontuko saldoa',
        manageUser: 'Kudeatu Erakundearen kontuko saldoa',
        columns: {
            currentBalance: 'Uneko saldoa',
            closingBalance: 'Azken saldoa',
            availableCredit: 'Kreditu erabilgarria',
            unbilledAmount: 'Fakturatu gabeko zenbatekoa',
            name: 'Izena',
            contact_Person: 'Harremanetarako pertsona',
            email: 'Helbide elektronikoa',
            payment_mode: 'Ordaintzeko modua',
            payment_schedule: 'Ordainketa-egutegia',
            balance: 'Saldoa',
            status: 'Egoera',
            action: 'Ekintza',
            refund: 'Zuzendu kontuko saldoa',
        },
        placeholder: {
            name: 'Izena/harremanetarako pertsona/helbide elektronikoa',
            description: 'Iruzkina',
            amount: 'Sartu kreditu/zordunketa kantitatea',
            select: {
                status: 'Hautatu egoera',
                payment_mode: 'Ordaintzeko modua',
                payment_schedule: 'Ordainketa-egutegia',
            },
            invoice: 'Hautatu faktura',
        },
        label: {
            description: 'Iruzkina',
            amount: 'Sartu kreditu/zordunketa kantitatea',
            payment_settlement: 'Saldoaren zuzenketa - Eskaera',
            enabled: 'Gaituta',
            disabled: 'Desgaituta',
            invoice: 'Faktura',
        },
        button: {
            search: 'Bilatu',
            cancel: 'Ezeztatu',
            save: 'Gorde',
            add: 'Gehitu',
            edit: 'Editatu',
            reset: 'Berrezarri',
            action: 'Ekintza',
            send_for_approval: 'Bidali onesteko',
            accept: 'Onartu',
        },
        errors: {
            amount: {
                moreThan: 'Kantitateak 0 baino handiagoa/txikiagoa izan behar du',
                maxcredit: 'Kreditu-konturako gehienezko mugara iritsi da',
                maxdebit: 'Zordunketa-konturako gehienezko mugara iritsi da',
            },
        },
    },
    driverAward: {
        rewardTitle: 'Sarien saldoa - ##COMPANY_BRAND_NAME## : IE karga azkarra EB (UK)',
        approvalRequest: 'Sarien saldoen onespenak - ##COMPANY_BRAND_NAME## : IE karga azkarra EB (UK)',
        rewards: 'Sarien saldoa',
        approvalRequests: 'Sarien saldoen onespenak',
        label: {
            name: 'Izena',
            email: 'Helbide elektronikoa',
            iVRewardPromotion: 'IV sarien sustapena',
            balance: 'Saldoa',
            status: 'Egoera',
            action: 'Ekintza',
            enabled: 'Gaituta',
            disabled: 'Desgaituta',
            location: 'Kokapena',
            date: 'Data',
            energy: 'Energia (kWh)',
            cost: 'Kostua',
            rewardPoint: 'Sari-puntua',
            rewardSettelemant: 'Sarien likidazioa',
            description: 'Deskribapena',
            credit: 'Kreditua',
            debit: 'Zordunketa',
            iVRewardSettelemant: 'Sariak - likidazioa',
            amount: 'Kantitatea',
            request_by: 'Nork eskatua',
            request_date: 'Noiz eskatua',
            review_by: 'Nork berrikusia',
            review_date: 'Noiz berrikusia',
            review_comment: 'Ikuskatzailearen iruzkinak',
            approvalRequest: 'Onespen-eskaera',
            enterComments: 'Idatzi zure iruzkinak',
            transaction_date: 'Transakzioaren data',
            debit_credit: 'Zordunketa/Kreditua',
            type: 'Mota',
            requested_by_comment: 'Iruzkinek eskatua',
            volts: 'Voltak',
            commentsFrom: 'Honen iruzkinak',
            approve: 'Onetsi',
            decline: 'Baztertu',
            federatedAccount: 'Kontu mota federatuak',
        },
        placeholder: {
            nameOrEmail: 'Izena/helbide elektronikoa',
            selectIVAwardPromotion: 'Hautatu IV sarien sustapena',
            selectStatus: 'Hautatu egoera',
            startDate: 'Hasiera-data',
            endDate: 'Bukaera-data',
            description: 'Deskribapena',
            volts: 'Voltak',
            enterComments: 'Idatzi zure iruzkinak',
        },
        button: {
            search: 'Bilatu',
            reset: 'Berrezarri',
            save: 'Gorde',
            cancel: 'Ezeztatu',
            decline: 'Baztertu',
            approve: 'Onetsi',
            send_for_approval: 'Bidali onesteko',
        },
        errors: {
            type: {
                required: 'Likidazioaren ordainketa edo zordunketa',
            },
            volts: {
                typeError: 'Sartu baliozko voltak',
                moreThan: 'Volten kopuruak 1etik gorakoa/beherakoa izan behar du',
            },
            status: {
                selectApprovalOrReject: 'Onartu/Baztertu eskaera hau.',
            },
        },
    },
    organisationdashboard: {
        title: 'Erakundearen aginte-taula: ##COMPANY_BRAND_NAME## - eMobility Zerbitzuaren Plataforma',
        header: 'Erakundearen aginte-taula',
        dashboard: 'Arbela',
        label: {
            filter: 'Iragazi',
            organisation: 'Erakundea',
            selectOrganisations: 'Hautatu erakundeak',
            dateRange: 'Data-tartea',
            driverGroup: 'Gidari-taldeak',
            drivers: 'Gidaria/Ibilgailua',
            selectDriver: 'Hautatu gidaria/Ibilgailua',
            selectDriverGroup: 'Hautatu gidari-taldeak',
            month: 'Hilabetea',
            year: 'Urtea',
            day: 'Eguna',
            week: 'Astea',
            userSessionTitle: 'Gidariaren saioak',
            userSessions: 'Gidariaren saioak',
            totalIncomeTitle: 'Diru-sarreren batura',
            income: 'Diru-sarrerak',
            energy: 'Energia',
            energyTitle: 'Energia-batura (kWh)',
            selectAll: 'Hautatu guztiak',
            totalRFIDCards: 'RFID txartelen guztizkoa',
            available: 'Erabilgarri',
            allocated: 'Esleitua',
            duplicate: 'Bikoiztu',
            disabled: 'Desgaituta',
            rfid: 'RFID',
            totalDriverAccounts: 'Gidarien kontuen guztizkoa',
            driver: 'Gidariak',
            enabled: 'Gaituta',
            pending: 'Egiteke',
            deleted: 'Ezabatuta',
            topTenDriverVehicles: '10 gidari/ibilgailu erabilienak',
            driverAccount: 'Gidaria',
            vehicle: 'Ibilgailua',
            driverName: 'Gidariaren izena',
            vehicleNumber: 'Ibilgailuaren zenbakia',
            kwhUsage: 'kWh erabilera',
            dateRangeLabel: 'Data-tartea:',
            both: 'Biak',
            nameorvehicleno: 'Izena/Ibilgailuaren Zenb.',
            type: 'Mota',
        },
        button: {
            apply: 'Aplikatu',
            clear: 'Garbitu',
            syncData: 'Sinkronizatu datuak',
            search: 'Bilatu',
            reset: 'Berrezarri',
        },
    },
    organisationtransactions: {
        headerTitle: 'Erakundearen transakzioak - ##COMPANY_BRAND_NAME## : IE karga azkarra EB (UK)',
        invoiceHeader: 'Fakturaren xehetasunak- ##COMPANY_BRAND_NAME## : IE karga azkarra EB (UK)',
        invoiceTitle: 'Fakturaren xehetasunak',
        title: 'Erakundearen transakzioak',
        transaction: 'Transakzioa',
        columns: {
            location: 'Kokapena',
            date: 'Data',
            time: 'Denbora',
            cost: 'Kostua',
            energy: 'Energia',
            action: 'Ekintza',
            remark: 'Iruzkinak',
            amount: 'Kantitatea',
            closing: 'Ixten',
            transaction: 'Transakzioaren ID-a',
            name: 'Izena',
            credit: 'Kreditua',
            debit: 'Zordunketa',
            vehicleNumber: 'Ibilgailuaren zenbakia',
            invoiceNumber: 'Fakturaren zenbakia',
            comment: 'Iruzkina',
            startDate: 'Hasiera-data',
            endDate: 'Bukaera-data',
        },
        csvHeader: {
            transaction: 'Transaction_ID',
            publicCardId: 'Public_Card_ID',
            stationId: 'Station_ID',
            transactionStartDate: 'Transaction_Start_Date',
            transactionEndDate: 'Transaction_End_Date',
            stationAddress: 'Station_Address',
            driverAccountId: 'Driver_Account_ID',
            vat_amount: 'VAT_Amount',
            stationName: 'Station_Name',
            kwh: 'kWh_Delivered',
            price_per_kwh: 'Price_Per_kWh',
            net_value: 'Net_Value',
            vat_rate: 'VAT_Rate',
            gross_value: 'Gross_Value',
            invoiceNumber: 'Invoice_Number',
            driverName: 'Driver_Name',
        },
        form: {
            charge: 'Karga',
            payment: 'Ordainketa',
            month: 'Hilabetea',
        },
        label: {
            exportAll: 'Esportatu denak',
            amount: 'Kantitatea',
            driverName: 'Gidariaren/Ibilgailuaren Zenb.',
            station: 'Geltokia',
            kwh: 'kWh',
            price_per_kwh: 'Prezioa/kWh',
            net_value: 'Balio garbia',
            vat_rate: 'BEZ tasa',
            gross_value: 'Balio gordina',
            totalBeforeVAT: 'Totala BEZ gabe',
            VatAt: ' BEZ-a',
            VatRate: 'BEZ tasa:',
            totalNetAmount: 'Zenbateko garbia guztira',
            subTotal: 'Azpi-guztizkoa',
            adjustedAmount: 'Doitutako zenbatekoa',
            grandTotal: 'Guztizko osoa',
            totalFee: ' Zergen totala',
            invoiceNumber: 'Faktura-zenbakia',
            invoiceDate: 'Faktura-data',
            transaction: 'Transakzioaren ID-a',
            name: 'Izena',
            date: 'Data',
            publicCardId: 'Txartel publikoaren ID-a',
            stationId: 'Geltokiaren ID-a',
            transactionStartDate: 'Transakzioaren hasiera-data',
            transactionEndDate: 'Transakzioaren bukaera-data',
            stationAddress: 'Geltokiaren helbidea',
            driverAccountId: 'Gidariaren kontuaren ID-a',
            vat_amount: 'BEZ zenbatekoa',
            stationName: 'Geltokiaren izena',
            status: 'Egoera',
        },
        button: {
            search: 'Bilatu',
            reset: 'Berrezarri',
            back: 'Atzera',
            export: 'Esportatu',
        },
        placeholder: {
            startDate: 'Hasiera-data',
            endDate: 'Bukaera-data',
            startDateFrom: 'Hasiera-data noiztik',
            startDateTo: 'Hasiera-data noiz arte',
            select: {
                organisation: 'Hautatu erakundea',
                invoice: 'Hautatu faktura-zenbakia',
            },
        },
        message: {
            noDataToExport: 'Ez dago daturik esportatzeko.',
            organisation: {
                required: 'Hautatu erakundea',
            },
            selectRecordToExport: 'Hautatu esportatzeko erregistroak.',
        },
    },
    driverVehicleAccount: {
        title: 'Gidariaren/Ibilgailuaren kontuak: ##COMPANY_BRAND_NAME## - eMobility Zerbitzuaren Plataforma',
        header: 'Gidariaren/Ibilgailuaren kontuak',
        managedriver: 'Kudeatu gidaria/Ibilgailua',
        importHeader: 'Igo RFID txartelak dituzten kontu berriak',
        importUpdateStatusHeader: 'Gaitu/desgaitu kontuak',
        importUpdateSpendGroupAssociation: 'Eguneratu gastatutako muga talde elkartea',
        placeholder: {
            name: 'Izena / helbide elektronikoa / Ibilgailuaren zenbakia',
            rfidCardNo: 'RFID txartel-zenb.',
            driverGroups: 'Hautatu gidari-taldeak',
            status: 'Hautatu egoera',
            first_name: 'Izena',
            last_name: 'Abizena',
            email: 'Helbide elektronikoa',
            vehicle_no: 'Ibilgailu zenb.',
            driverGroup: 'Hautatu gidari-taldeak',
            accountType: 'Hautatu kontu mota',
            publicRFIDCardNo: 'Sartu RFID txartel publikoaren zenb.',
            languagePreference: 'Hizkuntza lehenetsia',
        },
        label: {
            name: 'Izena',
            email: 'Helbide elektronikoa',
            vehicleNo: 'Ibilgailu zenb.',
            group: 'Taldea',
            createdDate: 'Noiz sortua',
            status: 'Egoera',
            action: 'Ekintza',
            enabled: 'Gaituta',
            disabled: 'Desgaituta',
            cancelled: 'Ezeztatuta',
            deleted: 'Ezabatuta',
            delete: 'Ezabatu',
            first_name: 'Izena',
            last_name: 'Abizena',
            vehicle_no: 'Ibilgailu zenb.',
            driverGroup: 'Gidari-taldeak',
            accountType: 'Kontu mota',
            assignRFIDCard: 'Esleitu RFFID txartela',
            rfidCard: 'RFID txartela',
            publicRFIDCardNo: 'Sartu RFID txartel publikoaren zenb.',
            assign: 'Esleitu',
            allocatedRFIDCards: 'Esleitutako RFID txartelak',
            file: 'CSV Fitxategia',
            clickHere: 'Sakatu hemen',
            downloadTemplate: 'txantiloia deskargatzeko',
            errosInImportedFile: 'Erroreak',
            driverVehicleNo: 'Gidariaren/Ibilgailuaren Zenb.',
            driverVehicleDetails: 'Gidariaren/Ibilgailuaren xehetasunak',
            error: 'Errorea',
            pending: 'Egiteke',
            card_allocated: 'RFID txartel esleitua',
            driver: 'Gidaria (Fleet App-en oinarritutako kontua)',
            vehicle: 'Ibilgailua (RFID-en oinarritutako kontua)',
            note: 'Oharra: ',
            accountSetupNote:
                'Kontuaren titularrak kontuaren ezarpenak bete beharko ditu hurrengo 24 ordutan ##COMPANY_BRAND_NAME## Fleet App bitartez, posta elektronikoz jasoko duen aldi baterako pasahitza erabiliz.',
        },
        button: {
            import: 'Inportatu',
            add: 'Gehitu',
            search: 'Bilatu',
            reset: 'Berrezarri',
            edit: 'Editatu',
            enable: 'Gaitu',
            disable: 'Desgaitu',
            delete: 'Ezabatu',
            yes: 'Bai',
            no: 'Ez',
            back: 'Atzera',
            save: 'Gorde',
            cancel: 'Ezeztatu',
            assignRFIDCard: 'Esleitu RFFID txartela',
            assign: 'Esleitu',
            action: 'Ekintza',
            done: 'Egina',
            sendEmail: 'Bidali posta elektronikoa',
            enableDisableAccounts: 'Gaitu/desgaitu kontuak',
            export: 'Esportatu',
        },
        message: {
            deleteConfirmMesage: 'Ziur ezabatu nahi duzula?',
            enableConfirmMesage: 'Ziur gaitu nahi duzula?',
            disableConfirmMesage: 'Ziur desgaitu nahi duzula?',
            sendMailConfirmMessage: 'Ziur mezu elektronikoa bidali nahi duzula?',
            mailSentSuccessMessage: 'Mezu elektronikoa ondo bidali da.',
        },
        errors: {
            invalidEmail: 'Sartu baliozko helbide elektroniko bat.',
            invalidFirstName: 'Sartu baliozko izen bat.',
            invalidLastName: 'Sartu baliozko abizen bat.',
            invalidVehicleNo: 'Sartu baliozko ibilgailu-zenbaki bat.',
            common: 'Zerbait ez da ongi atera, saiatu berriro arren.',
        },
        account_type: {
            driver: 'Gidaria',
            vehicle: 'Ibilgailua',
        },
        columns: {
            public_rfid_card_no: 'Txartel zenb.',
            allocatedBy: 'Nork esleitua',
            allocatedDate: 'Esleipen data',
            status: 'Egoera',
        },
    },
    chargingHistory: {
        header: 'Karga-saioak - ##COMPANY_BRAND_NAME## : IE karga azkarra EB (UK)',
        title: 'Karga-saioak',
        label: {
            exportAll: 'Esportatu',
            location: 'Kokapena',
            date: 'Data',
            milesAdded: 'Gehitutako miliak',
            time: 'Denbora',
            cost: 'Kostua',
            energy: 'Energia',
            action: 'Ekintza',
            remark: 'Iruzkinak',
            name: 'Izena',
            vehicleNo: 'Ibilgailu zenb.',
        },
        button: {
            search: 'Bilatu',
            reset: 'Berrezarri',
            back: 'Atzera',
        },
        placeholder: {
            startDate: 'Hasiera-data',
            endDate: 'Bukaera-data',
            startDateFrom: 'Hasiera-data noiztik',
            startDateTo: 'Hasiera-data noiz arte',
            driver: 'Izena / helbide elektronikoa / Ibilgailuaren zenbakia',
            selectDriverGroup: 'Hautatu gidaria/Ibilgailua Taldeak',
        },
        errors: {
            noDataToExport: 'Ez dago daturik esportatzeko.',
            selectRecordToExport: 'Hautatu esportatzeko erregistroak.',
            common: 'Zerbait ez da ongi atera, saiatu berriro arren.',
        },
    },
    paymentHistory: {
        header: 'Ordainketen historia- ##COMPANY_BRAND_NAME## : IE karga azkarra EB (UK)',
        title: 'Ordainketen historia',
        invoiceHeader: 'Fakturaren xehetasunak- ##COMPANY_BRAND_NAME## : IE karga azkarra EB (UK)',
        invoiceTitle: 'Fakturaren xehetasunak',
        label: {
            remark: 'Iruzkinak',
            credit: 'Kreditua',
            debit: 'Zordunketa',
            closing: 'Ixten',
            transaction: 'Transakzioaren ID-a',
            name: 'Izena',
            date: 'Data',
            amount: 'Kantitatea',
            driverName: 'Gidariaren/Ibilgailuaren Zenb.',
            station: 'Geltokia',
            kwh: 'kWh',
            price_per_kwh: 'Prezioa/kWh',
            net_value: 'Balio garbia',
            vat_rate: 'BEZ tasa',
            gross_value: 'Balio gordina',
            totalBeforeVAT: 'Totala BEZ gabe',
            VatAt: ' BEZ-a',
            totalFee: ' Zergen totala',
            invoiceNumber: 'Faktura-zenbakia',
            invoiceDate: 'Faktura-data',
            publicCardId: 'Txartel publikoaren ID-a',
            stationId: 'Geltokiaren ID-a',
            transactionStartDate: 'Transakzioaren hasiera-data',
            transactionEndDate: 'Transakzioaren bukaera-data',
            stationAddress: 'Geltokiaren helbidea',
            driverAccountId: 'Gidariaren kontuaren ID-a',
            vat_amount: 'BEZ zenbatekoa',
            stationName: 'Geltokiaren izena',
        },
        csvHeader: {
            transaction: 'Transaction_ID',
            publicCardId: 'Public_Card_ID',
            stationId: 'Station_ID',
            transactionStartDate: 'Transaction_Start_Date',
            transactionEndDate: 'Transaction_End_Date',
            stationAddress: 'Station_Address',
            driverAccountId: 'Driver_Account_ID',
            vat_amount: 'VAT_Amount',
            stationName: 'Station_Name',
            kwh: 'kWh_Delivered',
            price_per_kwh: 'Price_Per_kWh',
            net_value: 'Net_Value',
            vat_rate: 'VAT_Rate',
            gross_value: 'Gross_Value',
            invoiceNumber: 'Invoice_Number',
            driverName: 'Driver_Name',
        },
        placeholder: {
            startDate: 'Hasiera-data',
            endDate: 'Bukaera-data',
        },
        button: {
            search: 'Bilatu',
            reset: 'Berrezarri',
            export: 'Esportatu',
        },
        errors: {
            noDataToExport: 'Ez dago daturik esportatzeko.',
            selectRecordToExport: 'Hautatu esportatzeko erregistroak.',
        },
    },
    configurations: {
        title: 'Konfigurazioak: ##COMPANY_BRAND_NAME## - eMobility Zerbitzuaren Plataforma',
        header: 'Konfigurazioak',
        columns: {
            name: 'Izena',
            value: 'Balioa',
            description: 'Deskribapena',
            system_type: 'Sistema mota',
            modifiedBy: 'Nork aldatua',
            modifiedDate: 'Noiz aldatua',
            action: 'Ekintza',
        },
        button: {
            save: 'Gorde',
            cancel: 'Ezeztatu',
            reset: 'Berrezarri',
            search: 'Bilatu',
            action: 'Ekintza',
            edit: 'Editatu',
        },
        note: 'ABISUA: Konfigurazio horiek aldatzeak eragin handia izan dezake plataformaren funtzionamenduan. Zalantzarik baduzu, jar zaitez harremanetan sistemaren administratzailearekin.',
        errors: {
            maxLengthString: 'Sartu balio bat, gehienez',
            maxLengthStringCharacters: 'karaktereak',
            maxLengthNUmberCharacters: 'digituak',
            valueBetween: 'Sartu balio bat, hauen artekoa',
            valueGraterThen: 'Sartu balio bat, hau edo hau baino handiagoa',
            valueMention: 'Eman aipaturiko tarteko balio bat',
        },
        placeholder: {
            value: 'Sartu balioa',
            description: 'Idatzi deskribapena',
            name: 'Izena',
            valueSearch: 'Balioa',
            descriptionSearch: 'Deskribapena',
            referenceCode: 'Erreferentzia kodea',
            systemType: 'Hautatu sistema mota',
        },
        label: {
            value: 'Balioa',
            dataType: 'Data mota',
            description: 'Deskribapena',
            system: 'SISTEMA',
            driver: 'GIDARIA',
            admin: 'ADMIN',
            referenceCode: 'Erreferentzia kodea',
        },
    },
    rfidRequests: {
        title: 'RFID txartela eskaerak-##COMPANY_BRAND_NAME## : IE karga azkarra EB (UK)',
        header: 'RFID txartelaren eskaerak',
        placeholder: {
            nameEmail: 'Izena / e-posta',
            startDate: 'Hasiera-data',
            endDate: 'Bukaera-data',
            publicCardNo: 'Sartu txartel publikoaren zk.',
            enterComments: 'Sartu zure iruzkinak',
            status: 'Hautatu egoera',
            publicRFIDCardNo: 'Sartu RFID txartel publikoaren zenb.',
            scanReqQR: 'Eskaneatu gutunean inprimatutako QR kodea',
        },
        button: {
            search: 'Bilatu',
            reset: 'Berrezarri',
            save: 'Gorde',
            cancel: 'Ezeztatu',
            add: 'Gehitu',
            done: 'Egina',
            action: 'Ekintza',
            assign: 'Esleitu',
            downloadPdf: 'Deskargatu eskaeren PDF-a',
            downloadPdfSelected: 'Deskargatu hautatutako eskaeren PDF-a ',
            downloadPendingApprovedPdf: 'Deskargatu Onartzeke eta Onartuta dauden eskaeren PDF-a',
        },
        columns: {
            name: 'Izena',
            email: 'Helbide elektronikoa',
            requestedDate: 'Eskatutako data',
            noofCardReq: 'Eskatutako txartelaren zk',
            noofCardAllocated: 'Esleitutako txartelaren zk',
            requestStatus: 'Eskaeraren egoera',
            status: 'Egoera',
            driverStatus: 'Gidariaren egoera',
            action: 'Ekintza',
            public_rfid_card_no: 'Txartel zenb.',
            allocatedBy: 'Nork esleitua',
            allocatedDate: 'Esleipen-data',
            federated_account_type: 'Kontu mota federatuak',
        },
        label: {
            reviewRequest: 'Berrikusi eskaera',
            assignRFID: 'RFID txartela',
            processRFIDRequest: 'Prozesatu eskaera',
            noofCardRequested: 'Eskatutako txartelaren zenb.',
            noofCardAllocated: 'Esleitutako txartelaren zenb.',
            approved: 'Onetsi',
            declined: 'Baztertu',
            publicCardNo: 'Sartu txartel publikoaren zenb.',
            enterComments: 'Sartu zure iruzkinak',
            requestStatus: 'Eskaeraren egoera',
            assignRFIDCards: 'Esleitu RFFID txartelak',
            publicRFIDCardNo: 'Sartu RFID txartel publikoaren zenb.',
            allocatedRFIDCards: 'Esleitutako RFID txartelak',
            address: 'Helbidea',
            scanReqQR: 'Eskaneatu gutunean inprimatutako QR kodea',
            name: 'Izena',
            requestId: 'Eskaeraren Id-a',
            scanHistory: 'Eskaneatu historia',
        },
        message: {
            requestProcessed: 'Eskaera ongi prozesatu da',
        },
        errors: {
            approveReject: 'Onartu/Baztertu eskaera hau.',
            selectAnyRecord: 'Hautatu erregistro bat gutxienez PDF deskargatzeko.',
            reqNumTypeError: 'Sartu baliozko eskaeraren id bat',
        },
        pdfText: {
            dear: 'Adeitsua',
            instavolt: ' ##COMPANY_BRAND_NAME##',
            companyNumber: 'Enpresaren zenbakia',
            line1: 'Eskerrik asko zure RFID txartela ##COMPANY_BRAND_NAME## aplikazioaren bitartez eskatzeagatik, atxikita aurkituko duzu txartela.',
            line2: 'Zure txartela aktibatzeko, jarraitu hurrengo urratsei:',
            step1: '1. Hasi saioa aplikazioan',
            step2: '2. Menuan, hautatu ‘Ezarpenak’',
            step3: '3. Sakatu ‘Nire RFID txartelak’ aukera',
            step4: '4. Sakatu ‘Gehitu RFID txartela’ botoia',
            step5: '5. Sartu txartelean inprimatutako txartelaren zenbakia eta sakatu ‘Ekin’ botoia',
            step6: '6. Zure txartela aktibatuta dago orain, eta hurrengo karga-saioa abiarazteko erabil dezakezu jada',
            line3: 'Ba al zenekien kargatzen duzun bakoitzean sariak irabazi ditzakezula? Jaso Volt bana erabilitako kWh bakoitzeko, eta behar beste metatzen dituzunean, haiek trukatu ahal izango dituzu sarean karga-saioak ordaintzeko.',
            line4: 'Eskerrik asko gurekin kargatzeagatik.',
            line5: '##COMPANY_BRAND_NAME## Taldea',
            line6: 'Ibilgailu elektrikoak kargatzeko Erresuma Batuko azpiegitura',
        },
    },
    RFIDCardFleets: {
        title: 'RFID txartelak: ##COMPANY_BRAND_NAME## - eMobility Zerbitzuaren Plataforma',
        header: 'RFID txartelak',
        placeholder: {
            name: 'Gidariaren izena / Helbide elektronikoa / Ibilgailuaren zenbakia',
            manufacturer: 'Fabrikatzailea',
            public_card_id: 'Txartel publikoaren Id-a',
            status: 'Hautatu egoera',
            mifare_uid: 'Mifare UID',
        },
        label: {
            name: 'Izena',
            manufacturer: 'Fabrikatzailea',
            part_id: 'Alderdiaren Id-a',
            public_card_id: 'Txartel publikoaren Id-a',
            private_card_id: 'Txartel pribatuaren Id-a',
            created_date: 'Noiz sortua',
            status: 'Egoera',
            action: 'Ekintza',
            enabled: 'Gaituta',
            disabled: 'Desgaituta',
            delete: 'Ezabatu',
            remove: 'Kendu elkartea',
            reinstate: 'Berrezarri',
            activated: 'Aktibatuta',
            available: 'Erabilgarri',
            duplicate: 'Bikoiztu',
        },
        button: {
            search: 'Bilatu',
            cancel: 'Ezeztatu',
            add: 'Gehitu',
            assing: 'Esleitu RFFID txartela',
            import: 'Inportatu fitxategia',
            save: 'Gorde',
            edit: 'Editatu',
            reset: 'Berrezarri',
            yes: 'Bai',
            no: 'Ez',
            enabled: 'Gaitu',
            disabled: 'Desgaitu',
            action: 'Ekintza',
            back: 'Atzera',
            enable: 'Gaitu',
            disable: 'Desgaitu',
            getCredentials: 'Lortu kredentzialak',
            delete: 'Ezabatu',
            remove: 'Kendu elkartea',
            reinstate: 'Berrezarri',
            exportAll: 'Esportatu denak',
        },
        message: {
            enableConfirmMesage: 'Ziur gaitu nahi duzula?',
            disableConfirmMesage: 'Ziur desgaitu nahi duzula?',
            deleteConfirmMesage: 'Ziur ezabatu nahi duzula?',
            removeConfirmMesage: 'Ziur kontu batekin lotutako RFID txartela kendu nahi duzula?',
            reinstateConfirmMessage: 'Ziur RFID txartel hori berrezarri nahi duzula?',
        },
        insert: {
            header: 'Kudeatu RFID txartela',
            placeholder: {
                manufacturer: 'Fabrikatzailearen izena',
                part_id: 'Alderdiaren Id-a',
                public_card_id: 'Txartel publikoaren Id-a',
                private_card_id: 'Txartel pribatuaren Id-a',
                mifare_uid: 'Mifare UID',
            },
            label: {
                manufacturer: 'Fabrikatzailea',
                part_id: 'Alderdiaren Id-a',
                public_card_id: 'Txartel publikoaren Id-a',
                private_card_id: 'Txartel pribatuaren Id-a',
                mifare_uid: 'Mifare UID',
            },
            errors: {
                common: 'Zerbait ez da ongi atera, saiatu berriro arren.',
                name: {
                    valid: 'Sartu baliozko izena',
                },
                code: {
                    valid: 'Sartu baliozko kodea',
                },
                url: {
                    valid: 'URL-ak baliozko URL bat izan behar du',
                },
            },
        },
        assignCards: {
            header: 'Esleitu RFFID txartela',
            label: {
                driver: 'Gidaria/Ibilgailua',
            },
            button: {
                yes: 'Esleitu',
                no: 'Ezeztatu',
            },
            form: {
                driver: 'Gidaria/Ibilgailua',
                placeholder: {
                    driver: 'Hautatu gidaria/Ibilgailua',
                },
            },
        },
        disableCards: {
            header: 'Desgaitu',
            header2: 'Ziur desgaitu nahi duzula?',
            placeholder: {
                comment: 'Sartu iruzkina',
            },
            label: {
                comment: 'Iruzkina',
            },
            button: {
                yes: 'Bai',
                no: 'Ez',
            },
        },
        importCards: {
            header: 'Inportatu RFID txartelak',
            placeholder: {
                file: 'Hautatu CSV fitxategia',
            },
            label: {
                file: 'CSV Fitxategia',
            },
            button: {
                yes: 'Inportatu',
                no: 'Ezeztatu',
            },
            errors: {
                common: 'Zerbait ez da ongi atera, saiatu berriro arren.',
                file: {
                    fileType: "'.csv' luzapeneko fitxategia igo daiteke.",
                },
            },
        },
        importCardsDetails: {
            header: 'RFID txartelen inportazio xehetasunak',
            label: {
                unSuccessfullImport: 'Ondorengo txartelak ezin dira inportatu',
                successfullImport: 'Ondorengo txartelak ongi inportatu dira',
                failerReason: 'Huts egiteko arrazoia',
                publicCardId: 'Txartel publikoaren IDa',
            },
            message: {
                defualtErrorMessage: 'Arazo bat dago ondorengo txartelak inportatzean.',
            },
        },
    },
    myProfile: {
        title: 'Nire profila: ##COMPANY_BRAND_NAME## - eMobility Zerbitzuaren Plataforma',
        header: 'Nire profila',
        subheader: {
            details: 'Datu pertsonalak',
            security: 'Segurtasuna',
            password: 'Pasahitza',
        },
        label: {
            firstName: 'Izena',
            lastName: 'Abizena',
            email: 'Helbide elektronikoa',
            phoneNo: 'Telefono-zenb.',
            currentPassword: 'Oraingo pasahitza',
            newPassword: 'Pasahitz berria',
            confirmPassword: 'Berretsi pasahitza',
            mfaAuthentication: '2FA egiaztapena',
            authentication: 'Egiaztapena',
            securityCode: 'Segurtasun-kodea',
            languagePreference: 'Hizkuntza lehenetsia',
        },
        placeholder: {
            firstName: 'Izena',
            lastName: 'Abizena',
            email: 'Helbide elektronikoa',
            phoneNo: 'Telefono-zenb.',
            currentPassword: 'Oraingo pasahitza',
            newPassword: 'Pasahitz berria',
            confirmPassword: 'Berretsi pasahitza',
            securityCode: 'Segurtasun-kodea',
            languagePreference: 'Hizkuntza lehenetsia',
        },
        button: {
            save: 'Gorde',
            cancel: 'Ezeztatu',
            update: 'Eguneratu',
            ok: 'Ados',
        },
        toast: {
            profileSuccess: 'Profila ongi eguneratu da.',
            profileError: 'Profila ez da eguneratu. Berriz saiatu geroago.',
            passwordChange: 'Pasahitza ongi aldatu da.',
            passwordErr: 'Pasahitza ez da ongi aldatu. Berriz saiatu geroago.',
            passwordWrong: 'Oraingo pasahitza ez da zuzena.',
            securityStop: '2FA egiaztapen-segurtasuna eten da.',
            error: 'Zerbait ez da ongi atera. Berriz saiatu geroago.',
            securitySetupSuccess: '2FA egiaztapena ongi konfiguratu da.',
            securitySetupError: '2FA egiaztapena ez da ongi konfiguratu. Saiatu berriz geroago.',
            securityCodeInvalid: 'Baliogabetu segurtasun-kodea.',
        },
        errors: {
            securityCode: {
                match: 'Sartu baliozko kode bat',
                inValid: 'Sartu 6 digituko kode bat',
            },
            password: {
                confirmPasswordMatch: 'Pasahitz berria eta berretsitako pasahitza ez datoz bat.',
            },
        },
    },
    apiCredentials: {
        title: 'API kredentzialak: ##COMPANY_BRAND_NAME## - eMobility Zerbitzuaren Plataforma',
        header: 'API kredentzialak',
        button: {
            generate: 'Sortu Tokena',
            regenerate: 'Birsortu Tokena',
            yes: 'Bai',
            no: 'Ez',
        },
        note_no_permission:
            'Ez duzu eskubiderik API-an sartzeko. Jarri harremanetan ##COMPANY_BRAND_NAME## enpresaren administratzailearekin sarbidea lortzeko.',
        note_generte_token:
            'Tokena sor dezakezu “sortu Tokena” aukera sakatuz, eta token hori erabil dezakezu API-an sartzeko.',
        note: 'Tokena berriz sor dezakezu “birsortu Tokena” aukera sakatuz, eta token hori erabil dezakezu API-an sartzeko.',
        label: {
            token: 'Tokena',
            generate: 'Sortu Tokena',
            regenerate: 'Birsortu Tokena',
        },
        message: {
            regenerateConfirmMesage:
                'Ziur Tokena birsortu nahi duzula? <br/> Tokena berriz sortzen duzunean, token zaharra baliogabetuko da eta ezingo zara API-an sartu zaharrarekin.',
            generateConfirmMesage: 'Ziur Tokena sortu nahi duzula?',
        },
    },
    cookiePolicy: {
        text: 'Webgune honek cookieak erabiltzen ditu erabiltzailearen esperientzia hobetzeko. Gure webgunea erabiltzean, onartzen duzu irakurri eta ulertu duzula gure',
        action: 'Cookien politika',
        iAccept: 'Onartzen dut',
    },
    paymentconfig: {
        title: 'Ordainketa - ##COMPANY_BRAND_NAME## : IE karga azkarra (EB)',
        header: 'Ordainketa',
        processingNote: 'Itxaron transakzioa prozesatzen ari den bitartean',
        purchaseOrderNote: '##PAYMENT_SCHEDULE## fakturazio-zikloa duzu. Hau da hurrengo fakturazio-data: ',
        description: 'Ordainketa honi ##COMPANY_BRAND_NAME##',
        note: 'Atzeko lana astero egingo da fakturatu gabe geratzen diren fakturak kentzeko Gidariek/Ibilgailuek egindako Karga elektrikoentzat ',
        addReplaceCardNote:
            'Kontuan izan ordaintzeko txartel bat gehitzen duzunean, zure kontuan ##CURRENCY_SYMBOL_WITH_VALUE## kargatuko zaizula, zeina zure ##COMPANY_BRAND_NAME## zorroko saldotik kenduko den.',
        label: {
            currentBalance: 'Uneko saldoa',
            closingBalance: 'Azken saldoa',
            availableCredit: 'Kreditu erabilgarria',
            unbilledAmount: 'Fakturatu gabeko zenbatekoa',
            cardTitle: 'Txarteleko izena',
            cardNumber: 'Txartel-zenbakia',
            expiry: 'Iraungitzea',
            note: 'Oharra: ',
            CSC: 'CSC',
            cardSecurityCode: '(Txartelaren segurtasun-kodea)',
            charityDonation: 'Ongizateko dohaintza',
            roundUp: 'Gorantz biribildua',
            topUp: 'Areagotu',
            expires: 'Iraungiko du',
            charity: 'Karitatea',
        },
        placeholder: {
            cardTitle: 'Txarteleko izena',
            cardNumber: '1234 1234 1234 1234',
            CSC: 'CSC',
            topUpAmount: '00,00',
        },
        button: {
            save: 'Gorde',
            edit: 'Editatu',
            replace: 'Ordezkatu',
            back: 'Atzera',
            payNow: 'Orain ordaindu',
        },
        errors: {
            CSC: {
                min: 'Sartu gutxienez 3 digituko kodea.',
            },
            topupAmount: {
                min: 'Kantitateak 0,1 edo handiagoa izan behar du',
            },
            cardNumber: {
                inValid: 'Txartelaren zenbaki baliogabea',
            },
            commonError: 'Errore bat dago zure eskaera prozesatzean, saiatu geroago.',
            transactionFailed: 'Zure transakzioak huts egin du, mesedez saiatu berriz.',
        },
        message: {
            cardSaved: 'Txartelaren xehetasunak ongi gorde dira',
        },
    },
    refundRequest: {
        title: 'Baimendutako diru-ateratzeak - ##COMPANY_BRAND_NAME## : IE karga azkarra (EB)',
        header: 'Baimendutako diru-ateratzeak',
        accountInfoNote: 'Dirua ateratzeko beharrezko kontuaren informazioa:',
        completeConfirmNote:
            'Ezarritako balioa Gidarien bankuko kontuan ordaindu bada bakarrik bete dirua ateratzeko eskaera hau. Jarraitu nahi duzu?',
        bulkCompleteConfirmNote:
            'Ezarritako balioa Gidarien bankuko kontuan ordaindu bada bakarrik bete dirua ateratzeko eskaera hauek. Jarraitu nahi duzu?',
        declineConfirmNote:
            'Ziurtatu eskaera baztertzeko arrazoi egokia adierazi duzula, informazio hori bezeroari igorriko zaio eta.  Jarraitu nahi al duzu?',
        bulkDeclineConfirmNote:
            'Ziurtatu eskaerak baztertzeko arrazoi egokia adierazi duzula, informazio hori bezeroari igorriko zaio eta.  Jarraitu nahi al duzu?',
        label: {
            name: 'Izena',
            reviewRequest: 'Berrikusi eskaera',
            driverName: 'Gidariaren izena',
            driverEmail: 'Gidariaren helbide elektronikoa',
            requestedDate: 'Eskatutako data',
            action: 'Ekintza',
            amount: 'Kantitatea',
            refundRequested: 'Eskatutako diru-ateratzea',
            status: 'Egoera',
            accountNumber: 'Kontu-zenbakia',
            sortCode: 'Sailkapen-kodea',
            enterComments: 'Sartu iruzkinak',
            pending: 'Egiteke',
            closed: 'Itxita',
            complete: 'Osatu',
            decline: 'Baztertu',
            review_by: 'Nork berrikusia',
            review_date: 'Noiz berrikusia',
            approvalRequest: 'Onetsi eskaera',
            processRefundRequest: 'Prozesatu dirua ateratzeko eskaera',
            completeRefundRequest: 'Burutu dirua ateratzeko eskaera',
            bulkCompleteRefundRequest: 'Burutu dirua ateratzeko eskaerak',
            declineRefundRequest: 'Baztertu dirua ateratzeko eskaera',
            bulkdeclineRefundRequest: 'Baztertu dirua ateratzeko eskaera',
            export: 'Esportatu datuak',
            bulk: 'Multzoan',
        },
        button: {
            decline: 'Baztertu',
            approve: 'Onetsi',
            reset: 'Berrezarri',
            search: 'Bilatu',
            complete: 'Osatu',
            save: 'Gorde',
            cancel: 'Ezeztatu',
            yes: 'Bai',
            no: 'Ez',
        },
        placeholder: {
            selectStatus: 'Hautatu egoera',
            enterComments: 'Sartu iruzkinak',
            name: 'Izena/helbide elektronikoa',
        },
        errors: {
            status: {
                selectApprovalOrReject: 'Onartu/Baztertu eskaera hau.',
            },
            selectWithdrawalApprovals: 'Hautatu dirua ateratzeko eskaerak',
        },
    },
    termsAndConditionListing: {
        title: 'Terminoak eta baldintzak- ##COMPANY_BRAND_NAME## : IE karga azkarra (EB)',
        header: 'Terminoak eta baldintzak',
        noteDetails: '*Nahitaezkoa onartu behar da kontua erabiltzeko edo erregistratzeko.',
        label: {
            iAggreeToTermsCondition: 'Onartzen dut ',
            note: 'Oharra: ',
            termsAndConditions: 'Terminoak eta baldintzak.',
            reviewUpdatedCondition: 'Berrikusi eta onetsi beheko zerrendako termino eta baldintza eguneratuak.',
            name: 'Izena',
        },
        button: {
            accept: 'Onartu',
            next: 'Hurrengoa',
            cancel: 'Ezeztatu',
        },
        errors: {
            acceptTermCondition: 'Onartu * nahitaezko Terminoak eta baldintzak jarraitzeko.',
        },
    },
    adminDashboard: {
        title: 'Hasierako orria: ##COMPANY_BRAND_NAME## - eMobility Zerbitzuaren Plataforma',
        header: 'Arbela',
        formtitle: 'Formulario-balioztapena',
        label: {
            filter: 'Iragazi',
            reportTags: 'Jakinarazitako etiketak',
            driverGroup: 'Gidari-taldeak',
            selectDriverGroup: 'Hautatu gidari-taldeak',
            selectTags: 'Hautatu etiketak',
            dateRange: 'Data-tartea',
            month: 'Hilabetea',
            year: 'Urtea',
            day: 'Eguna',
            week: 'Astea',
            userSessionTitle: 'Gidariaren saioak',
            userSessions: 'Gidariaren saioak',
            totalIncomeTitle: 'Diru-sarreren batura',
            income: 'Diru-sarrerak',
            transactionTitle: 'Transakzioen batezbestekoa',
            transaction: 'Transakzioa',
            energy: 'Energia',
            energyTitle: 'Energia-batura (kWh)',
            failedPaymentTitle: 'Huts egindako ordainketa kopurua',
            failedPayment: 'Huts egindako ordainketa',
            driverCountTitle: 'Gidariaren kontuak',
            driver: 'Gidaria',
            accumulatedVolts: 'Metatutako Voltak',
            claimedVolts: 'Erreklamatutako Voltak ',
            outStandingFailPayment: 'Huts egindako ordainketa nabarmena',
            outStandingFailedPaymentTitle: 'Huts egindako ordainketa nabarmenak',
            voltsLiability: 'Volten erantzukizuna',
            voltsAccumulatedTitle: 'Metatutako Voltak',
            volts: 'Voltak',
            voltsClaimedTitle: 'Trukatutako Voltak',
            lapsedVolts: 'Iraungitako Voltak',
            totalNoOfDriverAccount: 'Gidarien kontu kopurua guztira',
            enabled: 'Gaituta',
            disabled: 'Desgaituta',
            badDebtor: 'Zordun txarra',
            cancelled: 'Ezeztatuta',
            deleted: 'Ezabatuta',
            fake_account: 'Kontu faltsua',
            numberOfReferees: 'Bitartekari kopurua',
            numberOfReferrers: 'Igorle kopurua',
            referralPayment: 'Igorpen ordainketa (igorlea + bitartekaria)',
            referrer: 'Igorlea',
            referee: 'Bitartekaria',
            moneySpent: 'Igorleek bakarrik gastatutako dirua',
            referralBonus: 'Igorpen hobaria',
            referralPromotion: 'Igorle-sustapena',
            overnightAutomated: 'Gaueko automatizazioa',
            customerManual: 'Bezeroen eskuliburua',
            pending: 'Egiteke',
            patnerPromoClicksCount: 'Bazkideen sustapenen sakatze-kontagailua ',
            clicksCount: 'Sakatze-kontagailua',
            clicksCountMessage:
                'Hautatu aukera bakarra edo anitza bazkideen sustapenen sakatze-kontagailua bistaratzeko',
            individualDrivers: 'Gidariek gaitutako kontuak',
            organisationDrivers: 'Erakundeak gaitutako kontuak',
            individualAndOrgDriverCount: 'Gaitutako kontuak: Gidariak erakundeen aldean',
            alerts: 'Alertak',
            alertsCountTitle: 'Alerten zenbaketa',
            premiumSubscriptions: 'Premium harpidetzak',
            activeSubscriptions: 'Premium harpidetza aktiboak guztira',
            newSubscriptions: 'Harpidetza berriak',
            cancelledSubscriptions: 'Ezeztatutako harpidetzak',
            subscriptions: '(Harpidetzak)',
        },
        placeholder: {
            patnerPromotions: 'Hautatu bazkide baten edo gehiagoren sustapenak datuak bistaratzeko',
        },
        button: {
            apply: 'Aplikatu',
            clear: 'Garbitu',
            syncData: 'Sinkronizatu datuak',
        },
    },
    footer: {
        version: 'Bertsioa',
        copyRightText: 'Eskubide guztiak erreserbatuta',
    },
    cardReader: {
        title: 'Txartel-irakurleak: ##COMPANY_BRAND_NAME## - eMobility Zerbitzuaren Plataforma',
        header: 'Txartel-irakurleak',
        manageCardReader: 'Kudeatu txartel-irakurlea',
        importHeader: 'Inportatu txartel-irakurleak',
        button: {
            import: 'Inportatu',
            add: 'Gehitu',
            back: 'Atzera',
            save: 'Gorde',
            cancel: 'Ezeztatu',
            edit: 'Editatu',
            action: 'Ekintza',
            delete: 'Ezabatu',
            search: 'Bilatu',
            reset: 'Berrezarri',
            disable: 'Desgaitu',
            duplicate: 'Bikoiztu',
            active: 'Aktibo',
            chargeStation: 'Kargatzeko geltokiak',
            yes: 'Bai',
            no: 'Ez',
            claimCardReader: 'Erreklamatu esleitu gabeko txartelen irakurgailuak',
            claim: 'Erreklamazioa',
        },
        label: {
            description: 'Deskribapena',
            latitude: 'Latitudea',
            longitude: 'Longitudea',
            serialNumber: 'Serie-zenbakia',
            endPoint: 'Bukaera-puntua',
            createdDate: 'Noiz sortua',
            status: 'Egoera',
            action: 'Ekintza',
            delete: 'Ezabatu',
            csvFile: 'CSV Fitxategia',
            clickHere: 'Sakatu hemen',
            downloadTemplate: 'txantiloia deskargatzeko',
            evse_id: 'EVSE ID',
            error: 'Errorea',
            errorDetail: 'Errorearen xehetasunak',
            failureReason: 'Porrotaren arrazoia',
            id: 'txartel irakurgailuaren ID',
        },
        placeholder: {
            description: 'Deskribapena',
            latitude: 'Latitudea',
            longitude: 'Longitudea',
            serialNumber: 'Serie-zenbakia',
            endPoint: 'Baliogabetu bukaera-puntua',
            selectStatus: 'Hautatu egoera',
        },
        errors: {
            latitude: {
                min: 'Latitudeak -90,0 eta 90,0 bitartean egon behar du',
                max: 'Latitudeak -90,0 eta 90,0 bitartean egon behar du',
                number: 'Latitudea zenbaki bat izan behar da',
            },
            longitude: {
                min: 'Longitudeak -180,0 eta 180,0 bitartean egon behar du',
                max: 'Longitudeak -180,0 eta 180,0 bitartean egon behar du',
                number: 'Longitudea zenbaki bat izan behar da',
            },
            serial_number: {
                valid: 'Sartu baliozko serie-zenbaki bat',
            },
        },
        message: {
            deleteConfirmMesage: 'Ziur ezabatu nahi duzula?',
            duplicateConfirmMesage: 'Ziur bikoiztu nahi duzula?',
            disableConfirmMesage: 'Ziur desgaitu nahi duzula?',
            activeConfirmMesage: 'Ziur aktibatu nahi duzula?',
        },
        assign: {
            header: 'Kargatzeko geltokiak',
            headerModal: 'Kargatzeko geltokia',
            placeholder: {
                name: 'Sartu izena',
                address: 'Helbidea',
                tags: 'Hautatu etiketak',
            },
            label: {
                add: 'Gehitu',
                address: 'Helbidea',
                city: 'Hiria',
                name: 'Izena',
                type: 'Mota',
                physical_reference: 'Erreferentzia fisikoa',
                postcode: 'Posta kodea',
                action: 'Ekintza',
                delete: 'Ezabatu',
            },
            button: {
                delete: 'Ezabatu',
            },
            message: {
                deleteConfirmMesage: 'Ziur ezabatu nahi duzula?',
            },
        },
    },
    cardScheme: {
        title: 'Txartel-eskemak: ##COMPANY_BRAND_NAME## - eMobility Zerbitzuaren Plataforma',
        header: 'Txartel-eskemak',
        manageCardScheme: 'Kudeatu txartel-eskema',
        label: {
            TransIdSeed: 'Transakzioaren Id-a',
            keybEncrKey: 'KeyB Enkriptatze-gakoa',
            transIdEncrKey: 'Transakzioaren Id Enkriptatze-gakoa',
            emspCode: 'EMSP Kodea',
            endPoint: 'Bukaera-puntua',
            createdDate: 'Noiz sortua',
            status: 'Egoera',
            action: 'Ekintza',
            delete: 'Ezabatu',
            enabled: 'Gaituta',
            disabled: 'Desgaituta',
        },
        button: {
            import: 'Inportatu',
            add: 'Gehitu',
            back: 'Atzera',
            save: 'Gorde',
            cancel: 'Ezeztatu',
            edit: 'Editatu',
            action: 'Ekintza',
            delete: 'Ezabatu',
            search: 'Bilatu',
            reset: 'Berrezarri',
            disable: 'Desgaitu',
            enable: 'Gaitu',
        },
        message: {
            deleteConfirmMesage: 'Ziur ezabatu nahi duzula?',
            disableConfirmMesage: 'Ziur desgaitu nahi duzula?',
            enableConfirmMesage: 'Ziur gaitu nahi duzula?',
        },
        placeholder: {
            emspCode: 'EMSP Kodea',
            keybEncrKey: 'KeyB Enkriptatze-gakoa',
            transIdEncrKey: 'Transakzioaren Id Enkriptatze-gakoa',
            TransIdSeed: 'Transakzioaren Id-a',
        },
        errors: {
            emsp_code: {
                valid: 'Sartu baliozko EMSP kode bat',
            },
            transaction_id_seed: {
                valid: 'Sartu baliozko transakzio id erroa',
                min: 'Transakzioaren Id erroak ezin da 0 baino txikiagoa izan',
                max: 'Transakzioaren Id erroarentzat gehieneko mugara iritsi zara',
            },
        },
    },
    fleetProfile: {
        orgProfile: 'Erakundearen profila',
        message: {
            success: 'Erakundearen profila ongi eguneratu da',
        },
    },
    dataAggregator: {
        title: 'Datu gehitzaileak: ##COMPANY_BRAND_NAME## - eMobility Zerbitzuaren Plataforma',
        header: 'Datu gehitzaileak',
        button: {
            add: 'Gehitu',
            search: 'Bilatu',
            reset: 'Berrezarri',
            enable: 'Gaitu',
            disable: 'Desgaitu',
            edit: 'Editatu',
            yes: 'Bai',
            no: 'Ez',
            action: 'Ekintza',
            back: 'Atzera',
            save: 'Gorde',
            cancel: 'Ezeztatu',
            syncDataAggregatorAPIKeys: 'Sinkronizatu API gakoak erabilera planekin',
        },
        placeholder: {
            name: 'Izena',
            status: 'Hautatu egoera',
        },
        label: {
            enabled: 'Gaituta',
            disabled: 'Desgaituta',
            name: 'Izena',
            party_id: 'Alderdiaren Id-a',
            country_code: 'Herrialde-kodea',
            version_url: 'Bertsioaren URL-a',
            created_date: 'Noiz sortua',
            status: 'Egoera',
            action: 'Ekintza',
        },
        message: {
            enableConfirmMesage: 'Ziur gaitu nahi duzula?',
            disableConfirmMesage: 'Ziur desgaitu nahi duzula?',
        },
        insert: {
            header: 'Kudeatu datu gehitzailea',
            errors: {
                common: 'Zerbait ez da ongi atera, saiatu berriro arren.',
                name: {
                    valid: 'Sartu baliozko datu gehitzailearen izena',
                },
                party_id: {
                    valid: 'Sartu baliozko Alderdiaren Id bat',
                },
                country_code: {
                    valid: 'Sartu baliozko herrialde-kode bat',
                },
                version_url: {
                    url: 'Bertsioaren URL-ak baliozko URL bat izan behar du',
                },
                token: {
                    valid: 'Sartu baliozko token bat',
                },
            },
            placeholder: {
                name: 'Izena',
                party_id: 'Alderdiaren Id-a',
                country_code: 'Herrialde-kodea',
                version_url: 'Datuen gehitzailearen URL bertsioa',
                token_a: 'A tokena',
                token_b: 'B tokena',
                token_c: 'C tokena',
                emsp: 'EMSP',
                access_group: 'Talde sarbidea',
                usagePlan: 'Erabilera Plana',
            },
            label: {
                name: 'Izena',
                party_id: 'Alderdiaren Id-a',
                country_code: 'Herrialde-kodea',
                version_url: 'Bertsioaren URL-a',
                emsp: 'EMSP',
                token_a: 'A tokena',
                token_b: 'B tokena',
                token_c: 'C tokena',
                allow_locations_to_be_extracted: 'EMPS-tik kokapenak bakarrik ateratzea baimendu',
                allow_receive_location_update:
                    'Baimendu PUT (Hasierakoa) eta PATCH (Egoera eguneratu) kokapenen eguneratzea jasotzea ',
                access_group: 'Talde-sarbidea',
                allow_tariff_extraction: 'Tarifa Sartu',
                usagePlan: 'Erabilera Plana',
            },
        },
    },
    accessGroups: {
        title: 'Taldeen sarbidea: ##COMPANY_BRAND_NAME## - eMobility Zerbitzuaren Plataforma',
        header: 'Taldeen sarbidea',
        manageAccessGroup: 'Kudeatu Talde-sarbidea',
        label: {
            createdDate: 'Noiz sortua',
            status: 'Egoera',
            action: 'Ekintza',
            delete: 'Ezabatu',
            enabled: 'Gaituta',
            disabled: 'Desgaituta',
            name: 'Izena',
            description: 'Deskribapena',
            access_control_type: 'Sarbide kontrol mota',
            allow_public_access: 'Baimendu sarbide publikoa',
            managed_by_organisation: 'Erakundeak kudeatua',
            override_tariff: 'Baliogabetu tarifa',
            yes: 'Bai',
            no: 'Ez',
            access_code: 'Sarbide kodea',
            deleted: ' (Ezabatuta)',
        },
        button: {
            enable: 'Gaitu',
            disable: 'Desgaitu',
            action: 'Ekintza',
            edit: 'Editatu',
            delete: 'Ezabatu',
            enabled: 'Gaituta',
            disabled: 'Desgaituta',
            add: 'Gehitu',
            search: 'Bilatu',
            reset: 'Berrezarri',
            back: 'Atzera',
            save: 'Gorde',
            cancel: 'Ezeztatu',
            deleted: ' (Ezabatuta)',
            chargeStation: 'Kargaren kokapenak',
            yes: 'Bai',
            no: 'Ez',
            drivers: 'Gidariak',
        },
        placeholder: {
            name: 'Izena',
            selectStatus: 'Hautatu egoera',
            allow_public_access: 'Baimendu sarbide publikoa',
            description: 'Deskribapena',
            access_control_type: 'Sarbide kontrol mota',
        },
        message: {
            deleteConfirmMesage: 'Ziur ezabatu nahi duzula?',
            disableConfirmMesage: 'Ziur desgaitu nahi duzula?',
            enableConfirmMesage: 'Ziur gaitu nahi duzula?',
        },
        assign: {
            header: 'Kargaren kokapenak',
            headerModal: 'Kargaren kokapenak',
            placeholder: {
                name: 'Sartu izena',
                address: 'Helbidea',
                tags: 'Hautatu etiketak',
                postal_code: 'Posta kodea',
                power_type: 'Hautatu potentzia mota',
            },
            label: {
                add: 'Gehitu',
                address: 'Helbidea',
                city: 'Hiria',
                name: 'Izena',
                type: 'Mota',
                physical_reference: 'Erreferentzia fisikoa',
                postcode: 'Posta kodea',
                action: 'Ekintza',
                delete: 'Ezabatu',
            },
            button: {
                delete: 'Ezabatu',
            },
            message: {
                deleteConfirmMesage: 'Ziur ezabatu nahi duzula?',
            },
        },
        driverAssign: {
            header: 'Gidariak',
            headerModal: 'Gidariak',
            placeholder: {
                email: 'Helbide elektronikoa',
                status: 'Egoera',
            },
        },
        errors: {
            name: {
                valid: 'Sartu baliozko izena',
            },
        },
    },
    accessGroupRequests: {
        title: 'Talde-sarbide eskaerak: ##COMPANY_BRAND_NAME## - eMobility Zerbitzuaren Plataforma',
        header: 'Talde-sarbide eskaerak',
        columns: {
            name: 'Izena',
            email: 'Helbide elektronikoa',
            federated_account_type: 'Kontu mota federatuak',
            requested_access_group: 'Eskatutako talde-sarbidea',
            requested_date: 'Eskatutako data',
            driver_status: 'Gidariaren egoera',
            request_status: 'Eskaeraren egoera',
            action: 'Ekintza',
        },
        button: {
            action: 'Ekintza',
            search: 'Bilatu',
            reset: 'Berrezarri',
            save: 'Gorde',
            cancel: 'Ezeztatu',
        },
        label: {
            review_request: 'Berrikusi eskaera',
            requested_access_group: 'Eskatutako talde-sarbidea:',
            approve: 'Onetsi',
            decline: 'Baztertu',
            enterComments: 'Iruzkinak',
        },
        placeholder: {
            nameEmail: 'Izena / e-posta',
            startDate: 'Hasiera-data',
            endDate: 'Bukaera-data',
            status: 'Hautatu egoera',
            enterComments: 'Sartu zure iruzkinak',
        },
        errors: {
            approveReject: 'Onartu/Baztertu eskaera hau.',
        },
    },
    payByWeb: {
        title: 'Webgunetik ordaindu: ##COMPANY_BRAND_NAME## - eMobility Zerbitzuaren Plataforma',
        header: 'Webgunetik ordaindu',
        columns: {
            evse_id: 'EVSE ID-a',
            status: 'Egoera',
            physical_reference: 'Erreferentzia fisikoa',
            location_name: 'Kokapenaren izena',
            location_address: 'Kokapenaren helbidea',
            location_city: 'Kokapenaren hiria',
            location_postal_code: 'Kokapenaren posta kodea',
            pay_by_web_active: 'Webgunetik ordaindu',
            action: 'Ekintza',
        },
        button: {
            search: 'Bilatu',
            reset: 'Berrezarri',
            enablePayByWeb: 'Gaitu webgunetik ordaindu',
            disabledPayByWeb: 'Desgaitu webgunetik ordaindu',
            submit: 'Bidali',
            cancel: 'Ezeztatu',
        },
        label: {
            enabled: 'Gaitu',
            disabled: 'Desgaitu',
            manageUniqueCode: 'Kudeatu kode bakarra',
            uniqueCode: 'Kode bakarra',
        },
        message: {
            enableConfirmMesage:
                'Ziur zaude webgunetik ordaintzeko aukera gaitu nahi duzula hautatutako geltokientzat?',
            disableConfirmMesage:
                'Ziur zaude webgunetik ordaintzeko aukera desgaitu nahi duzula hautatutako geltokientzat?',
        },
        placeholder: {
            evse_id: 'EVSE ID-a',
            status: 'Hautatu egoera',
            physical_reference: 'Erreferentzia fisikoa',
            location_name: 'Kokapenaren izena',
            location_address: 'Kokapenaren helbidea',
        },
        errors: {
            unique_code: {
                valid: 'Sartu baliozko kode bakarra',
            },
        },
    },
    driverDebt: {
        title: 'Gidariaren zorra: ##COMPANY_BRAND_NAME## - eMobility Zerbitzuaren Plataforma',
        header: 'Gidariaren zorra',
        button: {
            download: 'Deskargatu',
            strikeOneLetter: 'Lehen saiakera gutuna',
            strikeTwoLetter: 'Bigarren saiakera gutuna',
            generateStrikeOneLetters: 'Lehen saiakera gutunak sortu',
            generateStrikeTwoLetters: 'Bigarren saiakera gutunak sortu',
            runHistory: 'Saiakera gutunak sortu - Historia abiarazi ',
            pastLetters: 'Iraganeko gutunak',
            regenerateLetters: 'Birsortu gutunak',
            refreshPastLetters: 'Eguneratu iraganeko gutunak',
        },
        label: {
            pastLetters: 'Iraganeko gutunak',
            inProgress: '(abian)',
            noDataFound: 'Ez da aurkitu daturik.',
            dynamicFields: 'Eremu dinamikoak',
            clickToCopy: '(sakatu oharra kopiatzeko)',
            driverName: 'Gidariaren izena',
            driverDebt: 'Gidariaren zorra',
            debtAge: 'Zordunketa-adina',
            driverEmail: 'Gidariaren helbide elektronikoa',
            driverAddress: 'Gidariaren helbidea',
            date: 'Data',
            clickToCopyTooltip: 'Sakatu kopiatzeko',
            regenerate: 'Birsortu',
            regenerateLetters: 'Birsortu gutunak',
            letterTemplate: 'Gutunaren txantiloia',
            cancel: 'Ezeztatu',
            reportGenerationInProgress: '(Jakinarazi sortzen ari dela)',
            copyDriverIds: 'Sakatu gidariaren id-ak kopiatzeko',
        },
        columns: {
            run: 'Abiarazte zenb.',
            driverIDs: 'Gidariaren Id-ak ezin dira irakurri puntu honetan',
            runTimestamp: 'Egikaritze-ordua',
            strikeType: 'Saiakera mota',
            initiatedByUser: 'Abiaraztea hasi duen erabiltzailea',
            regenerate: 'Birsortu',
            action: 'Ekintza',
            relatedRun: 'Lotutako abiarazte zenb.',
            date: 'Data',
            file: 'Fitxategia',
            templateUsed: 'Erabilitako txantiloia',
            generatedBy: 'Nork sortua',
        },
        placeholder: {
            strikeOneLetter: 'Hautatu lehen saiakera gutuna',
            strikeTwoLetter: 'Hautatu bigarren saiakera gutuna',
        },
    },
    fleetAccessGroups: {
        title: 'Talde-sarbide eskaerak: ##COMPANY_BRAND_NAME## - eMobility Zerbitzuaren Plataforma',
    },
    emailLogs: {
        title: 'Posta elektronikoaren erregistroak: ##COMPANY_BRAND_NAME## - eMobility Zerbitzuaren Plataforma',
        header: 'Posta elektronikoaren erregistroak',
        columns: {
            recipient: 'Hartzailea',
            subject: 'Subjektua',
            deliveryStatus: 'Entregaren egoera',
            errorMessage: 'Errore-mezua',
            createdDate: 'Noiz sortua',
        },
        label: {
            viewError: 'Ikus errorea',
        },
        placeholder: {
            recipient: 'Hartzailea',
            subject: 'Subjektua',
            deliveryStatus: 'Entregaren egoera',
            errorMessage: 'Errore-mezua',
            startDate: 'Hasiera-data',
            endDate: 'Bukaera-data',
        },
    },
    alerts: {
        title: 'OCPI errore erregistroak: ##COMPANY_BRAND_NAME## - eMobility Zerbitzuaren Plataforma',
        header: 'OCPI errore erregistroak',
        columns: {
            api: 'url-a',
            api_call_type: 'API dei mota',
            api_request_type: 'Eskaera mota',
            response_code: 'Erantzun-kodea',
            error_message: 'Errore-mezua',
            alert_type: 'Alerta mota',
            created_date: 'Noiz sortua',
            request_body: 'Eskaeraren mamia',
            response_body: 'Erantzunaren mamia',
        },
        placeholder: {
            api: 'url-a',
            alert_type: 'Alerta mota',
            startDate: 'Hasiera-data',
            endDate: 'Bukaera-data',
        },
        button: {
            search: 'Bilatu',
            reset: 'Berrezarri',
        },
        label: {
            viewDetails: 'Ikus xehetasunak',
            errorLogDetails: 'OCPI errore erregistroen xehetasunak',
        },
    },
    SubscriptionSetting: {
        title: 'Premium harpidetzak: ##COMPANY_BRAND_NAME## - eMobility Zerbitzuaren Plataforma',
        header: 'Premium harpidetzak',
        manageSubscription: 'Kudeatu premium harpidetza',
        label: {
            subscription_type: 'Harpidetza mota',
            subscription_amount: 'Harpidetza kantitatea',
            free_subscription_duration: 'Doako harpidetzaren iraupena',
            created_date: 'Noiz sortua',
            status: 'Egoera',
            action: 'Ekintza',
            enabled: 'Gaitu',
            disabled: 'Desgaitu',
            maximum_routing_call: 'Ibiltaritzako gehieneko deiak (hileko)',
            additional_volts_per_kwh: 'Volt gehigarrien saria /kWh',
            name: 'Izena',
            description: 'Deskribapena',
            subscriptionImage: 'Premium harpidetzaren irudia',
            exportSubscribersList: 'Esportatu harpidetuen zerrenda',
            downloadSubscribersList: 'Deskargatu harpidetuen zerrenda',
        },
        placeholder: {
            subscription_amount: 'Harpidetza kantitatea',
            free_subscription_duration: 'Doako harpidetzaren iraupena (Egunak)',
            maximum_routing_call: 'Gehieneko ibiltaritza deiak',
            name: 'Izena',
            status: 'Hautatu egoera',
            subscriptionType: 'Hautatu harpidetza mota',
            subscriptionImage: 'Hautatu Premium harpidetzaren irudia',
        },
        button: {
            action: 'Ekintza',
            disable: 'Desgaitu',
            enable: 'Gaitu',
            edit: 'Editatu',
            back: 'Atzera',
            save: 'Gorde',
            cancel: 'Ezeztatu',
            enableDisable: 'Gaitu/desgaitu harpidetza',
            add: 'Gehitu',
            search: 'Bilatu',
            reset: 'Berrezarri',
        },
        errors: {
            amount: {
                moreThan: 'Kantitateak 1 baino handiagoa izan behar du',
                lessThan: 'Kantitateak 100 baino txikiagoa izan behar du',
                number: 'Kantitatea zenbaki bat izan behar da',
            },
            duration: {
                moreThan: 'Iraupenak 1 baino handiagoa izan behar di',
                lessThan: 'Iraupenak 180 baino txikiagoa izan behar di',
            },
            maxRoutingCall: {
                moreThan: 'Gehieneko ibiltaritza deien balioak 1 baino handiagoa izan behar du',
                lessThan: 'Gehieneko ibiltaritza deien balioak 1000 baino txikiagoa izan behar du',
            },
            additionalVolts: {
                lessThan: 'Balioak 5 edo txikiagoa izan behar du',
                number: 'Balioa zenbaki bat izan behar da',
            },
        },
        message: {
            enableFromConfig:
                'Premium Harpidetza gaitzeko, lehenen, ezarri ‘Gaitu Premium harpidetza’ aukeran ‘Egia’ Ezarpenak > Konfigurazioak atalean',
            disableConfirmMessage:
                'Abisua: Premium harpidetza desgaitzeak Gidariaren kontuari lotutako berritze automatiko guztiak ezeztatuko ditu. Ziur desgaitu nahi duzula?',
            enableConfirmMessage: 'Ziur gaitu nahi duzula?',
        },
    },
    advertisingDevices: {
        title: 'Publizitate-gailuak: ##COMPANY_BRAND_NAME## - eMobility Zerbitzuaren Plataforma',
        header: 'Publizitate-gailuak',
        label: {
            enabled: 'Gaituta',
            disabled: 'Desgaituta',
            device_name: 'Izena',
            device_id: 'Gailuaren ID',
            postal_code: 'Posta kodea',
            charge_station: 'Kargatzeko geltokia',
            screen_size: 'Pantailaren tamaina',
            created_date: 'Noiz sortua',
            status: 'Egoera',
            action: 'Ekintza',
            delete: 'Ezabatu',
            operational: 'Eragilea',
        },
        button: {
            action: 'Ekintza',
            edit: 'Editatu',
            delete: 'Ezabatu',
            enabled: 'Gaitu',
            disabled: 'Desgaitu',
            add: 'Gehitu',
            reset: 'Berrezarri',
            search: 'Bilatu',
            back: 'Atzera',
            save: 'Gorde',
            cancel: 'Ezeztatu',
            assignVideos: 'Esleitu bideoak',
            yes: 'Bai',
            no: 'Ez',
            regenerateS3File: 'Birsortu S3 fitxategia',
            mediaTerminalLogs: 'Multimedia terminaleko erregistroak',
        },
        placeholder: {
            device_name: 'Gailuaren izena',
            postal_code: 'Posta kodea',
            charge_station: 'Kargatzeko geltokia',
            selectStatus: 'Hautatu egoera',
            screen_size: 'Pantailaren tamaina',
        },
        message: {
            deleteConfirmMesage: 'Ziur ezabatu nahi duzula?',
            enableConfirmMesage: 'Ziur gaitu nahi duzula?',
            disableConfirmMesage: 'Ziur desgaitu nahi duzula?',
        },
        insert: {
            header: 'Kudeatu publizitate-gailua',
            placeholder: {
                device_name: 'Gailuaren izena',
                device_id: 'Gailuaren Id-a',
                charge_station: 'Kargatzeko geltokia',
                screen_size: 'Pantailaren tamaina',
            },
            label: {
                device_name: 'Gailuaren izena',
                device_id: 'Gailuaren Id-a',
                charge_station: 'Kargatzeko geltokia',
                screen_size: 'Pantailaren tamaina',
            },
            errors: {
                common: 'Zerbait ez da ongi atera, saiatu berriro arren.',
                name: {
                    valid: 'Sartu baliozko izena',
                },
                device_id: {
                    valid: 'Sartu baliozko Gailuaren ID bat',
                    min: 'Gailuaren ID-ak 6 karaktere izan behar ditu gutxienez',
                },
            },
        },
        assignVideos: {
            header: 'Bideoak',
            headerModal: 'Bideoak',
            label: {
                action: 'Ekintza',
                delete: 'Ezabatu',
            },
            placeholder: {
                file_name: 'Fitxategiaren izena',
                description: 'Deskribapena',
            },
            message: {
                deleteConfirmMesage: 'Ziur ezabatu nahi duzula?',
            },
        },
    },
    advertisingVideos: {
        title: 'Publizitateko bideoak: ##COMPANY_BRAND_NAME## - eMobility Zerbitzuaren Plataforma',
        header: 'Publizitate-bideoak',
        label: {
            file_name: 'Fitxategiaren izena',
            description: 'Deskribapena',
            operational_start_date: 'Eragiketen hasiera-data',
            operational_end_date: 'Eragiketen bukaera-data',
            created_date: 'Noiz sortua',
            status: 'Egoera',
            action: 'Ekintza',
            delete: 'Ezabatu',
            reviewVideo: 'Berrikusi bideoa',
            approve: 'Onetsi',
            reject: 'Ukatu',
            videoUpload: 'Bideoa',
            comments: 'Iruzkinak',
        },
        button: {
            action: 'Ekintza',
            edit: 'Editatu',
            delete: 'Ezabatu',
            enabled: 'Gaitu',
            disabled: 'Desgaitu',
            add: 'Gehitu',
            reset: 'Berrezarri',
            search: 'Bilatu',
            back: 'Atzera',
            save: 'Gorde',
            cancel: 'Ezeztatu',
            reviewVideo: 'Berrikusi bideoa',
            downloadVideo: 'Deskargatu bideoa',
            assignDevice: 'Esleitu gailuak',
        },
        placeholder: {
            file_name: 'Fitxategiaren izena',
            description: 'Deskribapena',
            start_date: 'Eragiketen hasiera-data',
            end_date: 'Eragiketen bukaera-data',
            selectStatus: 'Hautatu egoera',
            videoUpload: 'Bideoa',
            enterComments: 'Idatzi zure iruzkinak',
        },
        message: {
            deleteConfirmMesage: 'Ziur ezabatu nahi duzula?',
        },
        insert: {
            header: 'Kudeatu publizitateko bideoa',
            placeholder: {
                description: 'Deskribapena',
                operational_start_date: 'Eragiketen hasiera-data',
                operational_end_date: 'Eragiketen bukaera-data',
            },
            label: {
                description: 'Deskribapena',
                operational_start_date: 'Eragiketen hasiera-data',
                operational_end_date: 'Eragiketen bukaera-data',
            },
        },
        errors: {
            status: {
                message: {
                    selectApprovalOrReject: 'Onartu/ Ukatu eskaera hau.',
                },
            },
            name: {
                valid: 'Sartu baliozko izena',
            },
            file_name: {
                fileType: "'.mp4', '.flv', '.wmv', '.mpeg', '.avi', '.3gp' luzapeneko fitxategia igo daiteke",
                uploadError: 'Errorea bideo fitxategia igotzean',
                required: 'Bideo-fitxategia behar da',
                fileNameLength: 'Gehienez 15 karaktere erabil daitezke fitxategiaren izenean',
            },
            file_size: 'Igotzeko fitxategiaren gehieneko tamaina:',
        },
        assignDevices: {
            header: 'Gailuak',
            headerModal: 'Gailuak',
            label: {
                action: 'Ekintza',
                delete: 'Ezabatu',
            },
            placeholder: {
                device_name: 'Gailuaren izena',
                device_id: 'Gailuaren ID',
                status: 'Egoera',
            },
            message: {
                deleteConfirmMesage: 'Ziur ezabatu nahi duzula?',
            },
        },
    },
    advertisingCredentials: {
        title: 'Publizitate-kredentzialak: ##COMPANY_BRAND_NAME## - eMobility Zerbitzuaren Plataforma',
        header: 'Publizitate- kredentzialak',
        manageCredentials: 'Kudeatu publizitate-kredentzialak',
        label: {
            bucket_name: 'Ontziaren izena',
            region_name: 'Eskualdearen izena',
            download_access_key: 'Deskargatu sarbide-gakoa',
            download_secret_key: 'Deskargatu ezkutuko gakoa',
            upload_access_key: 'Igo sarbide-gakoa',
            upload_secret_key: 'Igo ezkutuko gakoa',
            download_info_object_name: 'Deskargatu info objektuaren izena',
            upload_path: 'Igo bidea',
            dialog_password: 'Elkarrizketaren pasahitza',
            expect_bucket_name: 'Itxaron ontziaren izena',
            expect_region_name: 'Itxaron eskualdearen izena',
            expect_download_access_key: 'Itxaron deskargatu sarbide-gakoa',
            expect_download_secret_key: 'Itxaron deskargatu ezkutuko gakoa',
            version_code: 'Bertsioaren kodea',
            download_url: 'Deskargatu URL-a',
            prompt: 'Eskaera',
            remarks: 'Iruzkinak',
            modified_by: 'Nork aldatua',
            modified_date: 'Noiz aldatua',
            status: 'Egoera',
            action: 'Ekintza',
            enabled: 'Gaitu',
            disabled: 'Desgaitu',
        },
        button: {
            action: 'Ekintza',
            disable: 'Desgaitu',
            enable: 'Gaitu',
            edit: 'Editatu',
            back: 'Atzera',
            save: 'Gorde',
            cancel: 'Ezeztatu',
        },
    },
    organisationInvoices: {
        title: 'Erakundearen fakturak: ##COMPANY_BRAND_NAME## - eMobility Zerbitzuaren Plataforma',
        header: 'Erakundearen fakturak',
        label: {
            name: 'Erakundea',
            invoice_id: 'Fakturaren ID-a',
            invoice_value: 'Fakturaren balioa',
            invoice_date: 'Faktura-data',
            action: 'Ekintza',
            undo: 'Desegin',
            undoPayment: 'Desegin ordainketa',
            disputed: 'Eztabaidatua',
            adjustAmount: 'Doitu fakturaren balioa ',
            paid_value: 'Ordaindutako balioa',
            outstanding: 'Ordaintzeke',
            status: 'Egoera',
            comments: 'Iruzkinak',
            original_value: 'Jatorrizko balioa',
        },
        placeholder: {
            name: 'Izena',
            start_date: 'Hasiera-data',
            end_date: 'Bukaera-data',
            status: 'Egoera',
            organisation: 'Hautatu erakundea',
        },
        button: {
            search: 'Bilatu',
            reset: 'Berrezarri',
            action: 'Ekintza',
            pay: 'Ordaindu',
            partPay: 'Ordainketaren zati bat',
            undo: 'Desegin',
            disputed: 'Eztabaidatua',
            adjustValue: 'Doitu fakturaren balioa',
        },
        errors: {
            amount: {
                moreThan: 'Kantitateak 0 baino handiagoa izan behar du',
                maxValue: 'Kantitateko gehieneko baliora iritsi da',
                notZero: 'Kantitateak 0 baino handiagoa/txikiagoa izan behar du',
                minValue: 'Kantitateko gutxieneko baliora iritsi da',
                number: 'Kantitatea zenbaki bat izan behar da',
            },
            organisation: {
                required: 'Hautatu erakundea',
            },
        },
        message: {
            undoConfirmMessage:
                'Ziur ordaindutako balioa kendu eta egoera ‘Ordaintzeke’ ezarri nahi duzula faktura honentzat?',
            disputedConfirmMessage: 'Ziur egoera ‘Eztabaidatua’ ezarri nahi duzula faktura honentzat?',
        },
        payModal: {
            header: 'Ordaindu',
            partPayHeader: 'Ordainketaren zati bat',
            label: {
                amount: 'Kantitatea',
                date_paid: 'Ordainketa-data',
                comments: 'Iruzkinak',
            },
            placeholder: {
                amount: 'Sartu zenbatekoa',
                date_paid: 'Sartu ordainketa-data',
                comments: 'Sartu iruzkinak',
            },
            button: {
                accept: 'Onartu',
                send_for_approval: 'Bidali onesteko',
                cancel: 'Ezeztatu',
                submit: 'Bidali',
            },
        },
    },
    mediaTerminalLogs: {
        title: 'Multimedia terminaleko erregistroak: ##COMPANY_BRAND_NAME## - eMobility Zerbitzuaren Plataforma',
        header: 'Multimedia terminaleko erregistroak',
        label: {
            file_name: 'Fitxategiaren izena',
            date_played: 'Noiz erreproduzituta',
            play_time: 'Erreprodukzio-ordua',
            start_time: 'Hasiera-ordua',
        },
        placeholder: {
            fileName: 'Fitxategiaren izena',
            startDate: 'Hasiera-data',
            endDate: 'Bukaera-data',
        },
    },
    fleetDriverSpendHistory: {
        title: 'Gastuen mugaren historia: ##COMPANY_BRAND_NAME## - eMobility Zerbitzuaren Plataforma',
        header: 'Gastuen mugaren historia',
        label: {
            enabled: 'Gaituta',
            disabled: 'Desgaituta',
            name: 'Gidariaren izena',
            email: 'Gidariaren helbide elektronikoa',
            type: 'Atalase-mota',
            spend_limit_exceed_date: 'Gastuen muga gainditutako data',
            status: 'Gidariaren egoera',
            action: 'Ekintza',
            export: 'Esportatu',
            onStop: 'Geldialdian',
            cancelOnStop: 'Ezeztatu geldialdian',
        },
        button: {
            disable: 'Desgaitu',
            enable: 'Gaitu',
            search: 'Bilatu',
            reset: 'Berrezarri',
            yes: 'Bai',
            no: 'Ez',
            back: 'Atzera',
        },
        placeholder: {
            name: 'Gidariaren izena',
            email: 'Gidariaren helbide elektronikoa',
            status: 'Hautatu gidariaren egoera',
            dateFrom: 'Muga gainditutako data noiztik',
            dateTo: 'Muga gainditutako data noiz arte',
            type: 'Hautatu atalase-mota',
        },
        message: {
            noDataToExport: 'Ez dago daturik esportatzeko.',
            cancelOnStopConfirmation: 'Ziur zaude geldialdian ezeztatu nahi duzula gidari honentzat?',
        },
    },
    driverDebtorLetters: {
        title: 'Gidariaren zordun-gutunak: ##COMPANY_BRAND_NAME## - eMobility Zerbitzuaren Plataforma',
        header: 'Gidariaren zordun-gutunak',
        manageDriverDebtorLetter: 'Kudeatu gidariaren zordun-gutuna',
        label: {
            reportType: 'Txosten mota',
            defaultLetter: 'Zordun-gutunaren txantiloi lehenetsia',
            content: 'Edukia',
            enabled: 'Gaituta',
            disabled: 'Desgaituta',
            created_date: 'Noiz sortua',
            status: 'Egoera',
            action: 'Ekintza',
            delete: 'Ezabatu',
            dynamicFields: 'Eremu dinamikoak',
            copyNotation: '(Sakatu oharra kopiatzeko)',
            clickToCopy: 'Sakatu kopiatzeko',
            driverName: ' â€¢ Gidariaren izena',
            driverDebt: 'â€¢ Gidariaren zorra',
            debtAge: 'â€¢ Zordunketa adina',
            driverEmail: 'â€¢ Gidariaren Helbide elektronikoa',
            driverAddress: 'â€¢ Gidariaren Helbidea',
            date: 'â€¢ Data',
            uniqueReference: 'â€¢ Erreferentzia bakarra',
            useStandardTemplate: 'Erabili txantiloi arrunta',
        },
        column: {
            defaultLetter: 'Gutun lehenetsia',
        },
        button: {
            setDefaultLetter: 'Ezarri Lehenetsi gisa',
            enable: 'Gaitu',
            disable: 'Desgaitu',
            edit: 'Editatu',
            delete: 'Ezabatu',
            createDuplicate: 'Sortu bikoiztua',
            save: 'Gorde',
            cancel: 'Ezeztatu',
            preview: 'Aurreikusi',
        },
        message: {
            setDefaultConfirmMesage: 'Ziur zordun-gutun hori lehenetsi gisa ezarri nahi duzula?',
            enableConfirmMesage: 'Ziur gaitu nahi duzula?',
            disableConfirmMesage: 'Ziur desgaitu nahi duzula?',
            deleteConfirmMesage: 'Ziur ezabatu nahi duzula?',
        },
        error: {
            emptyContent: 'Edukiak hornitu Gutunaren txantiloia aurreikusteko',
            common: 'Errore bat dago zure eskaera prozesatzean, saiatu geroago.',
            supportedDynamicField1: 'Eremu dinamiko horiek',
            supportedDynamicField2: 'zordungutunarentzat bakarrik dira.',
        },
    },
    driverSubscriptions: {
        title: 'Gidariaren premium harpidetzak: ##COMPANY_BRAND_NAME## - eMobility Zerbitzuaren Plataforma',
        header: 'Premium harpidetzak',
        label: {
            subscriptionType: 'Harpidetza mota',
            subscriptionStartDate: 'Harpidetzaren hasiera-data',
            subscriptionStatus: 'Harpidetzaren egoera',
            renewalOrExpiryDate: 'Berritzea /Iraungitze-data',
            voltsCredited: 'Kargatutako Voltak',
            journeysPlanned: 'Planifikatutako bidaiak',
            active: 'Aktibo',
            cancelled: 'Ezeztatuta',
            action: 'Ekintza',
            cancel: 'Ezeztatu',
            cancelSubscription: 'Ezeztatu harpidetza',
            terminate: 'Bukatu',
            terminateSubscription: 'Bukatu harpidetza',
            freeTrial: 'Doako probaldia',
            name: 'Izena',
            promotion: 'Sustapena',
        },
        message: {
            cancelConfirmMessage:
                'Ziur zaude harpidetza ezeztatu nahi duzula erabiltzaile honentzat? Harpidetzaren hurrengo berritze automatikoa ezeztatuko du horrek.',
            terminateConfirmMessage:
                'Ziur zaude harpidetza bukatu nahi duzula erabiltzaile honentzat? Horrek berritze automatikoa ezeztatuko du eta harpidetza honen onura guztiak etengo ditu unean bertan.',
            terminateConfirmMessageWithoutRenew:
                'Ziur zaude harpidetza bukatu nahi duzula erabiltzaile honentzat? Horrek harpidetzaren onura guztiak etengo ditu unean bertan.',
        },
    },
    advertisingDropDownDefaultmessage: 'Sartu kokapenaren 3 karaktere gutxienez geltokien zerrenda bistaratzeko',
    rfidcardDropDownDefaultMessage:
        'Sartu kokapenaren 3 karaktere gutxienez gidarien/ibilgailuen zerrenda bistaratzeko',
    chargeStationMapDropDownDefaultMessage:
        'Sartu kargatzeko geltokiaren 3 karaktere gutxienez kargatzeko geltokiak bistaratzeko',
    startChargePageDropDownDefaultMessage: 'Sartu kokapenaren karaktereak kokapenen zerrenda bistaratzeko',
    groupGridDropDownDefaultMessage:
        'Sartu kokapenaren 3 karaktere gutxienez gidarien/ibilgailuen zerrenda bistaratzeko',
    organisationdashBoardDefaultMessage:
        'Sartu kokapenaren 3 karaktere gutxienez gidarien/ibilgailuen zerrenda bistaratzeko',
    rfidAssigncardDefaultDropDownMessage:
        'Sartu gidariaren helbide elektronikoaren 3 karaktere gutxienez gidarien zerrenda bistaratzeko',
    tariffDropDownDefaultMessage: 'Sartu tarifaren gutxienez 3 karaktere tarifa zerrenda bistaratzeko',
    limitExceedAddressError: 'Ezin da aurkitu helbidea une honetan',
    continueTypingSearch: 'Jarraitu idazten bilaketa zuzentzeko',
    noFileChosen: 'Ez da aukeratu fitxategirik',
    ChooseFile: 'Aukeratu fitxategia',
    noOptions: 'Ez dago aukerarik',
    requiredField: 'Fitxategia nahitaez jarri behar da',
    removeImage: 'Kendu irudia',
    help: 'Laguntza',
    editor: {
        bold: 'Lodia',
        italic: 'Etzana',
        underline: 'Azpimarratu',
        strikeThrough: 'Marratu',
        monospace: 'Espazio-bakarra',
        superscript: 'Goi-indizea',
        subscript: 'Azpiindizea',
        blockType: 'Bloke mota',
        fontSize: 'Letra-tamaina',
        font: 'Letra mota',
        unordered: 'Ordenatu gabea',
        ordered: 'Ordenatua',
        indent: 'Koska-marka',
        outdent: 'Koska-markarik ez',
        left: 'Ezkerra',
        right: 'Eskuina',
        center: 'Erdian',
        justify: 'Justifikatua',
        colorPicker: 'Kolore hautagailua',
        link: 'Estekatu',
        unlink: 'Desestekatu',
        embedded: 'Txertatua',
        emoji: 'Emojia',
        remove: 'Kendu',
        undo: 'Desegin',
        redo: 'Berriz egin',
        image: 'Irudia',
    },
    map: {
        zoomIn: 'Handiagotu',
        zoomOut: 'Txikiagotu',
    },
    InstaVolt: '##COMPANY_BRAND_NAME##',
    apply: 'Aplikatu',
    cancel: 'Ezeztatu',
    noDataFound: 'Barkatu! Ez da aurkitu daturik',
    globalService: {
        title: 'Google zerbitzuaren erregistroa: ##COMPANY_BRAND_NAME## - eMobility Zerbitzuaren Plataforma',
        status: {
            pending:
                'Zerbitzu orokorrekin harremanetan jartzeko, sartu honako informazio hau. ‘Erregistratu’ botoia sakatuz, komunikazioa konfiguratu ahal izango duzu.',
            registered:
                'EMSP plataforma orain bertan komunika daiteke zerbitzu orokorrekin. Komunikazioarekin arazorik baduzu, sartu honako informazio hau eta sakatu ‘Berriz erregistratu’ botoia.',
        },
        insert: {
            url: 'URL-a',
            handshakeToken: 'Handshake Token',
        },
        placeholder: {
            url: 'URL-a',
            handshakeToken: 'Handshake Token',
        },
        label: {
            note: 'Oharra',
            noteValue:
                "'Handshake token' sartu beharko da zerbitzu orokorrekin komunikazioa ezartzen den bakoitzean. 'Handshake token’ hori identifikatzeko, jarri harremanetan sistemaren administratzailearekin.",
            rfidSync: 'RFID Sinkronizazioa',
        },
        button: {
            register: 'Erregistratu',
            reRegister: 'Berriz erregistratu',
        },
        error: {
            errorWhileCreatingGlobalService: 'Errorea zerbitzu orokorra sortzean.',
            errorWhileUpdatingGlobalService: 'Errorea zerbitzu orokorra eguneratzean.',
        },
        endpointsTable: {
            header: 'Google zerbitzuaren bukaera:',
            column: {
                identifer: 'Identifikatzailea',
                httpMethod: 'Http metodoa',
                url: 'Url-a',
            },
        },
    },
    price_breakdown_details: {
        detailed_breakup: 'Banaketa xehatua',
        total_cost: 'Kostuak guztira',
        conversion_rate: 'Bihurketa tasa',
        totalNetCost: 'Guztizko Kostu Garbia',
        total_parking_cost: 'Aparkalekuaren Kostu Totala',
        total_energy_cost: 'Energiaren Kostu Totala',
        total_fixed_cost: 'Kostu Finko Totala',
        total_time_cost: 'Kargatzeko Denbora Kostu Totala',
    },
    SubscriptionImages: {
        title: 'Premium harpidetzaren irudiak',
        manageSubscriptionImage: 'Kudeatu Premium harpidetzaren irudia',
        label: {
            name: 'Izena',
            description: 'Deskribapena',
            action: 'Ekintza',
            delete: 'Ezabatu',
            image: 'Irudia',
            language: 'Hizkuntza',
        },
        button: {
            edit: 'Editatu',
            search: 'Bilatu',
            reset: 'Berrezarri',
            add: 'Gehitu',
        },
        message: {
            deleteConfirmMesage: 'Ziur ezabatu nahi duzula?',
        },
        errors: {
            insertEnglishLanguageImage: 'Igo irudia ingeleserako',
            required: 'Irudia beharrezkoa da.',
        },
    },
    driverPaymentCards: {
        title: 'Gidaria ordaintzeko txartelak: InstaVolt - eMobility zerbitzuko plataforma',
        header: 'Ordaintzeko txartelak',
        label: {},
    },
};
